(function (_, Kotlin) {
  'use strict';
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var Annotation = Kotlin.kotlin.Annotation;
  var Kind_INTERFACE = Kotlin.Kind.INTERFACE;
  var Unit = Kotlin.kotlin.Unit;
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var throwUPAE = Kotlin.throwUPAE;
  var equals = Kotlin.equals;
  var split = Kotlin.kotlin.text.split_ip8yn$;
  var toInt = Kotlin.kotlin.text.toInt_pdl1vz$;
  var Exception = Kotlin.kotlin.Exception;
  var toMutableList = Kotlin.kotlin.collections.toMutableList_4c7yge$;
  var PrimitiveClasses$intClass = Kotlin.kotlin.reflect.js.internal.PrimitiveClasses.intClass;
  var PrimitiveClasses$stringClass = Kotlin.kotlin.reflect.js.internal.PrimitiveClasses.stringClass;
  var PrimitiveClasses$booleanClass = Kotlin.kotlin.reflect.js.internal.PrimitiveClasses.booleanClass;
  var getKClass = Kotlin.getKClass;
  var contains = Kotlin.kotlin.collections.contains_2ws7j4$;
  var requireNoNulls = Kotlin.kotlin.collections.requireNoNulls_whsx6z$;
  var lazy = Kotlin.kotlin.lazy_klfg04$;
  var ensureNotNull = Kotlin.ensureNotNull;
  var throwCCE = Kotlin.throwCCE;
  var sortWith = Kotlin.kotlin.collections.sortWith_nqfjgj$;
  var listOf = Kotlin.kotlin.collections.listOf_mh5how$;
  var sortedWith = Kotlin.kotlin.collections.sortedWith_eknfly$;
  var abs = Kotlin.kotlin.math.abs_s8cxhz$;
  var equals_0 = Kotlin.kotlin.text.equals_igcy3c$;
  var toString = Kotlin.toString;
  var AssertionError_init = Kotlin.kotlin.AssertionError_init_pdl1vj$;
  var getCallableRef = Kotlin.getCallableRef;
  var Pair = Kotlin.kotlin.Pair;
  var toMutableMap = Kotlin.kotlin.collections.toMutableMap_abgq59$;
  var replace = Kotlin.kotlin.text.replace_680rmw$;
  var IntRange = Kotlin.kotlin.ranges.IntRange;
  var substring = Kotlin.kotlin.text.substring_fc3b62$;
  var first = Kotlin.kotlin.text.first_gw00vp$;
  var toList = Kotlin.kotlin.text.toList_gw00vp$;
  var unboxChar = Kotlin.unboxChar;
  var StringBuilder_init = Kotlin.kotlin.text.StringBuilder_init;
  var contains_0 = Kotlin.kotlin.text.contains_li3zpu$;
  var Enum = Kotlin.kotlin.Enum;
  var throwISE = Kotlin.throwISE;
  var to = Kotlin.kotlin.to_ujzrz7$;
  var mapOf = Kotlin.kotlin.collections.mapOf_qfcya0$;
  var joinToString = Kotlin.kotlin.collections.joinToString_fmv235$;
  var mutableMapOf = Kotlin.kotlin.collections.mutableMapOf_qfcya0$;
  var take = Kotlin.kotlin.collections.take_ba2ldo$;
  var Regex_init = Kotlin.kotlin.text.Regex_init_61zpoe$;
  DiseaseConcept.prototype = Object.create(Concept.prototype);
  DiseaseConcept.prototype.constructor = DiseaseConcept;
  VaccineConcept.prototype = Object.create(Concept.prototype);
  VaccineConcept.prototype.constructor = VaccineConcept;
  GenericConcept.prototype = Object.create(VaccineConcept.prototype);
  GenericConcept.prototype.constructor = GenericConcept;
  TradeNameConcept.prototype = Object.create(VaccineConcept.prototype);
  TradeNameConcept.prototype.constructor = TradeNameConcept;
  CollectionPage.prototype = Object.create(Page.prototype);
  CollectionPage.prototype.constructor = CollectionPage;
  OtherPage.prototype = Object.create(Page.prototype);
  OtherPage.prototype.constructor = OtherPage;
  Error_0.prototype = Object.create(Result.prototype);
  Error_0.prototype.constructor = Error_0;
  Success.prototype = Object.create(Result.prototype);
  Success.prototype.constructor = Success;
  PHUIntegration.prototype = Object.create(Integration.prototype);
  PHUIntegration.prototype.constructor = PHUIntegration;
  RequestType.prototype = Object.create(Enum.prototype);
  RequestType.prototype.constructor = RequestType;
  SyncManager$makeRequest$ObjectLiteral.prototype = Object.create(ResponseCallback.prototype);
  SyncManager$makeRequest$ObjectLiteral.prototype.constructor = SyncManager$makeRequest$ObjectLiteral;
  SyncManager$logout$ObjectLiteral.prototype = Object.create(ResponseCallback.prototype);
  SyncManager$logout$ObjectLiteral.prototype.constructor = SyncManager$logout$ObjectLiteral;
  SyncManager$sync$ObjectLiteral.prototype = Object.create(ResponseCallback.prototype);
  SyncManager$sync$ObjectLiteral.prototype.constructor = SyncManager$sync$ObjectLiteral;
  JavelinException.prototype = Object.create(Exception.prototype);
  JavelinException.prototype.constructor = JavelinException;
  function JOverloads() {
  }
  JOverloads.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'JOverloads',
    interfaces: [Annotation]
  };
  function DateInterface() {
  }
  DateInterface.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'DateInterface',
    interfaces: []
  };
  function JavelinInterface() {
  }
  JavelinInterface.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'JavelinInterface',
    interfaces: []
  };
  function JavelinManager(platform, javelinInterface, jsonInterface, dateInterface, dataInterface) {
    JavelinManager$Companion_getInstance();
    this.platform = platform;
    this.javelinInterface_0 = javelinInterface;
    this.jsonInterface_0 = jsonInterface;
    this.dateInterface_0 = dateInterface;
    this.dataManager = new DataManager(dataInterface);
    this.syncManager_14u34z$_0 = null;
    this.localNotificationManager_ndj6mw$_0 = null;
    this.language_6i3oef$_0 = '';
    var tmp$;
    if (this.javelinInterface_0.languages.isEmpty()) {
      throw new JavelinException('No languages added');
    }
    this.language = (tmp$ = this.simpleBroadcast(Type$Simple_getInstance().LANGUAGE, Action_getInstance().READ, null)) != null ? tmp$ : this.javelinInterface_0.languages.get_za3lpa$(0);
    JavelinManager$Companion_getInstance().instance_8be2vx$ = this;
    this.logMessage('JavelinManager', 'Initialized Javelin v4.4.13');
  }
  Object.defineProperty(JavelinManager.prototype, 'syncManager', {
    get: function () {
      return this.syncManager_14u34z$_0;
    },
    set: function (syncManager) {
      this.syncManager_14u34z$_0 = syncManager;
    }
  });
  Object.defineProperty(JavelinManager.prototype, 'localNotificationManager', {
    get: function () {
      return this.localNotificationManager_ndj6mw$_0;
    },
    set: function (localNotificationManager) {
      this.localNotificationManager_ndj6mw$_0 = localNotificationManager;
    }
  });
  Object.defineProperty(JavelinManager.prototype, 'language', {
    get: function () {
      return this.language_6i3oef$_0;
    },
    set: function (value) {
      this.language_6i3oef$_0 = value;
      this.simpleBroadcast(Type$Simple_getInstance().LANGUAGE, Action_getInstance().UPDATE, this.language);
    }
  });
  JavelinManager.prototype.addSyncManager = function (syncManager) {
    this.syncManager = syncManager;
  };
  JavelinManager.prototype.addLocalNotificationManager_1szayr$ = function (localNotificationManager) {
    this.localNotificationManager = localNotificationManager;
  };
  Object.defineProperty(JavelinManager.prototype, 'languages', {
    get: function () {
      return this.javelinInterface_0.languages;
    }
  });
  JavelinManager.prototype.randomId = function () {
    return this.javelinInterface_0.randomId();
  };
  Object.defineProperty(JavelinManager.prototype, 'appVersion', {
    get: function () {
      return this.javelinInterface_0.appVersion;
    }
  });
  Object.defineProperty(JavelinManager.prototype, 'buildType', {
    get: function () {
      return this.javelinInterface_0.buildType;
    }
  });
  Object.defineProperty(JavelinManager.prototype, 'deviceId', {
    get: function () {
      return this.javelinInterface_0.deviceId;
    }
  });
  Object.defineProperty(JavelinManager.prototype, 'deviceName', {
    get: function () {
      return this.javelinInterface_0.deviceName;
    }
  });
  Object.defineProperty(JavelinManager.prototype, 'deviceModel', {
    get: function () {
      return this.javelinInterface_0.deviceModel;
    }
  });
  JavelinManager.prototype.getString = function (stringId, arguments_0) {
    return this.javelinInterface_0.getString(stringId, arguments_0.slice());
  };
  JavelinManager.prototype.logMessage = function (tag, message) {
    this.javelinInterface_0.logMessage(tag, message);
  };
  JavelinManager.prototype.logError = function (tag, exception) {
    this.javelinInterface_0.logError(tag, exception);
  };
  JavelinManager.prototype.objectFromJson_tandj7$ = function (json, type, elementId) {
    if (elementId === void 0)
      elementId = null;
    return this.jsonInterface_0.fromJson(json, type, elementId);
  };
  JavelinManager.prototype.listFromJson_tandj7$ = function (json, type, elementId) {
    return this.jsonInterface_0.listFromJson(json, type, elementId);
  };
  JavelinManager.prototype.objectToJson = function (obj) {
    return this.jsonInterface_0.toJson(obj);
  };
  JavelinManager.prototype.zonedNow = function () {
    return this.dateInterface_0.zonedNow();
  };
  JavelinManager.prototype.localNow = function () {
    return this.dateInterface_0.localNow();
  };
  JavelinManager.prototype.localOf = function (year, month, day) {
    return this.dateInterface_0.localOf(year, month, day);
  };
  JavelinManager.prototype.simpleBroadcast = function (objectType, action, value) {
    return this.javelinInterface_0.simpleBroadcast(objectType, action, value);
  };
  JavelinManager.prototype.clientBroadcast = function (action, anObject) {
    if (anObject === void 0)
      anObject = null;
    this.javelinInterface_0.broadcast(action, anObject);
  };
  var emptyList = Kotlin.kotlin.collections.emptyList_287e2$;
  JavelinManager.prototype.broadcast = function (action, anObject, fields) {
    if (fields === void 0) {
      fields = emptyList();
    }
    var tmp$;
    this.clientBroadcast(action, anObject);
    this.dataManager.onBroadcastReceived_2urz0g$(action, anObject, fields);
    (tmp$ = this.syncManager) != null ? (tmp$.onBroadcastReceived(action, anObject, fields), Unit) : null;
  };
  function JavelinManager$Platform() {
    JavelinManager$Platform_instance = this;
    this.ANDROID = 0;
    this.IOS = 1;
    this.WEB = 2;
  }
  Object.defineProperty(JavelinManager$Platform.prototype, 'string', {
    get: function () {
      switch (JavelinManager$Companion_getInstance().instance_8be2vx$.platform) {
        case 0:
          return 'Android';
        case 1:
          return 'iOS';
        default:return 'Web';
      }
    }
  });
  JavelinManager$Platform.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Platform',
    interfaces: []
  };
  var JavelinManager$Platform_instance = null;
  function JavelinManager$Platform_getInstance() {
    if (JavelinManager$Platform_instance === null) {
      new JavelinManager$Platform();
    }
    return JavelinManager$Platform_instance;
  }
  function JavelinManager$Companion() {
    JavelinManager$Companion_instance = this;
    this.VERSION = '4.4.13';
    this.instance_8be2vx$_wj4jng$_0 = this.instance_8be2vx$_wj4jng$_0;
  }
  Object.defineProperty(JavelinManager$Companion.prototype, 'instance_8be2vx$', {
    get: function () {
      if (this.instance_8be2vx$_wj4jng$_0 == null)
        return throwUPAE('instance');
      return this.instance_8be2vx$_wj4jng$_0;
    },
    set: function (instance) {
      this.instance_8be2vx$_wj4jng$_0 = instance;
    }
  });
  Object.defineProperty(JavelinManager$Companion.prototype, 'dm_8be2vx$', {
    get: function () {
      return this.instance_8be2vx$.dataManager;
    }
  });
  JavelinManager$Companion.prototype.setIOSInstance_a71ppp$ = function (manager) {
    this.instance_8be2vx$ = manager;
  };
  JavelinManager$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var JavelinManager$Companion_instance = null;
  function JavelinManager$Companion_getInstance() {
    if (JavelinManager$Companion_instance === null) {
      new JavelinManager$Companion();
    }
    return JavelinManager$Companion_instance;
  }
  JavelinManager.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'JavelinManager',
    interfaces: []
  };
  function JsonInterface() {
  }
  JsonInterface.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'JsonInterface',
    interfaces: []
  };
  function DataInterface() {
  }
  DataInterface.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'DataInterface',
    interfaces: []
  };
  function City(cityId, name, region, country, longitude, latitude) {
    this.cityId = cityId;
    this.name = name;
    this.region = region;
    this.country = country;
    this.longitude = longitude;
    this.latitude = latitude;
  }
  Object.defineProperty(City.prototype, 'fullName', {
    get: function () {
      return this.name + ', ' + this.region;
    }
  });
  City.prototype.equals = function (other) {
    return Kotlin.isType(other, City) && equals(other.cityId, this.cityId);
  };
  City.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'City',
    interfaces: []
  };
  function Country(code, en, fr) {
    this.code = code;
    this.en = en;
    this.fr = fr;
  }
  Object.defineProperty(Country.prototype, 'name', {
    get: function () {
      return equals(Language_getInstance().get_8be2vx$(), Language_getInstance().ENGLISH) ? this.en : this.fr;
    }
  });
  Country.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Country',
    interfaces: []
  };
  function DateModifier(years, months, weeks, days) {
    DateModifier$Companion_getInstance();
    this.years = years;
    this.months = months;
    this.weeks = weeks;
    this.days = days;
  }
  DateModifier.prototype.apply = function (date) {
    return date.plusYears(this.years).plusMonths(this.months).plusWeeks(this.weeks).plusDays(this.days);
  };
  DateModifier.prototype.toLocalDate_8be2vx$ = function () {
    return Date_getInstance().of_cub51b$(this.years, this.months, this.days);
  };
  DateModifier.prototype.equals = function (other) {
    return Kotlin.isType(other, DateModifier) && this.years === other.years && this.months === other.months && this.weeks === other.weeks && this.days === other.days;
  };
  DateModifier.prototype.toString = function () {
    return this.years.toString() + ',' + this.months + ',' + this.weeks + ',' + this.days;
  };
  function DateModifier$Companion() {
    DateModifier$Companion_instance = this;
  }
  var collectionSizeOrDefault = Kotlin.kotlin.collections.collectionSizeOrDefault_ba2ldo$;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  DateModifier$Companion.prototype.fromString = function (string) {
    var tmp$;
    if (string == null) {
      return null;
    }
    try {
      var $receiver = split(string, [',']);
      var destination = ArrayList_init(collectionSizeOrDefault($receiver, 10));
      var tmp$_0;
      tmp$_0 = $receiver.iterator();
      while (tmp$_0.hasNext()) {
        var item = tmp$_0.next();
        destination.add_11rb$(toInt(item));
      }
      var sections = destination;
      tmp$ = new DateModifier(sections.get_za3lpa$(0), sections.get_za3lpa$(1), sections.get_za3lpa$(2), sections.get_za3lpa$(3));
    }
     catch (e) {
      if (Kotlin.isType(e, Exception)) {
        Log_getInstance().e_xnh3o3$('DateModifier', 'Error parsing from String', e);
        tmp$ = null;
      }
       else
        throw e;
    }
    return tmp$;
  };
  DateModifier$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var DateModifier$Companion_instance = null;
  function DateModifier$Companion_getInstance() {
    if (DateModifier$Companion_instance === null) {
      new DateModifier$Companion();
    }
    return DateModifier$Companion_instance;
  }
  DateModifier.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'DateModifier',
    interfaces: []
  };
  function Filter(filterId, parentId, parentType, type, value) {
    Filter$Companion_getInstance();
    this.filterId = filterId;
    this.parentId = parentId;
    this.parentType = parentType;
    this.type = type;
    this.value = value;
  }
  Filter.prototype.getListValue_0 = function (aClass) {
    return Json_getInstance().listFrom_z6hou8$(this.value, aClass);
  };
  Filter.prototype.getParsedValue_0 = function (aClass) {
    return Json_getInstance().from_z6hou8$(this.value, aClass);
  };
  function Filter$Type() {
    Filter$Type_instance = this;
    this.PLATFORM = 'PLATFORM';
    this.LANGUAGE = 'LANGUAGE';
    this.CITY = 'CITY';
    this.REGION = 'REGION';
    this.SCHEDULE = 'SCHEDULE';
    this.ACCOUNT = 'ACCOUNT';
  }
  Filter$Type.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Type',
    interfaces: []
  };
  var Filter$Type_instance = null;
  function Filter$Type_getInstance() {
    if (Filter$Type_instance === null) {
      new Filter$Type();
    }
    return Filter$Type_instance;
  }
  function Filter$Companion() {
    Filter$Companion_instance = this;
  }
  var ArrayList_init_0 = Kotlin.kotlin.collections.ArrayList_init_287e2$;
  Filter$Companion.prototype.canBeShown_1nqkch$ = function (theFilters) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4;
    var filters = toMutableList(theFilters);
    var toDelete = ArrayList_init_0();
    tmp$ = filters.iterator();
    loop: while (tmp$.hasNext()) {
      var filter = tmp$.next();
      switch (filter.type) {
        case 'PLATFORM':
          toDelete.add_11rb$(filter);
          if (!filter.getListValue_0(PrimitiveClasses$intClass).contains_11rb$(JavelinManager$Companion_getInstance().instance_8be2vx$.platform)) {
            return false;
          }

          break;
        case 'LANGUAGE':
          toDelete.add_11rb$(filter);
          if (!filter.getListValue_0(PrimitiveClasses$stringClass).contains_11rb$(JavelinManager$Companion_getInstance().instance_8be2vx$.language)) {
            return false;
          }

          break;
        case 'ACCOUNT':
          toDelete.add_11rb$(filter);
          tmp$_0 = filter.getParsedValue_0(PrimitiveClasses$booleanClass);
          if (tmp$_0 == null) {
            continue loop;
          }

          var accountNeeded = tmp$_0;
          var loggedIn = (tmp$_2 = (tmp$_1 = JavelinManager$Companion_getInstance().instance_8be2vx$.syncManager) != null ? tmp$_1.isLoggedIn : null) != null ? tmp$_2 : false;
          if (!accountNeeded && loggedIn || (accountNeeded && !loggedIn)) {
            return false;
          }

          break;
      }
    }
    filters.removeAll_brywnq$(toDelete);
    if (filters.isEmpty()) {
      return true;
    }
    tmp$_3 = JavelinManager$Companion_getInstance().dm_8be2vx$.queryList(getKClass(Record), new QueryBuilder(Type_getInstance().RECORD)).iterator();
    while (tmp$_3.hasNext()) {
      var record = tmp$_3.next();
      tmp$_4 = filters.iterator();
      while (tmp$_4.hasNext()) {
        var filter_0 = tmp$_4.next();
        switch (filter_0.type) {
          case 'CITY':
            if (contains(filter_0.getListValue_0(PrimitiveClasses$stringClass), record.cityId)) {
              return true;
            }

            break;
          case 'REGION':
            var region = record.region;
            if (region != null && filter_0.getListValue_0(PrimitiveClasses$stringClass).contains_11rb$(region)) {
              return true;
            }

            break;
          case 'SCHEDULE':
            var scheduleId = record.scheduleId;
            if (scheduleId != null && filter_0.getListValue_0(PrimitiveClasses$stringClass).contains_11rb$(scheduleId)) {
              return true;
            }

            break;
        }
      }
    }
    return false;
  };
  Filter$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var Filter$Companion_instance = null;
  function Filter$Companion_getInstance() {
    if (Filter$Companion_instance === null) {
      new Filter$Companion();
    }
    return Filter$Companion_instance;
  }
  Filter.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Filter',
    interfaces: []
  };
  function Gender() {
    Gender_instance = this;
    this.MALE = 0;
    this.FEMALE = 1;
    this.BOTH = 2;
  }
  Gender.prototype.isRightGender = function (objectGender, recordGender) {
    return objectGender === 2 || objectGender === recordGender;
  };
  Gender.prototype.getString = function (gender) {
    switch (gender) {
      case 0:
        return Str_getInstance().get_y4putb$(Id_getInstance().male);
      case 1:
        return Str_getInstance().get_y4putb$(Id_getInstance().female);
      case -1:
      case 2:
        return '';
      default:throw new JavelinException('Unknown Gender: ' + gender);
    }
  };
  Gender.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Gender',
    interfaces: []
  };
  var Gender_instance = null;
  function Gender_getInstance() {
    if (Gender_instance === null) {
      new Gender();
    }
    return Gender_instance;
  }
  function Language() {
    Language_instance = this;
    this.ENGLISH = 'en';
    this.FRENCH = 'fr';
  }
  Language.prototype.get_8be2vx$ = function () {
    return JavelinManager$Companion_getInstance().instance_8be2vx$.language;
  };
  Language.prototype.getString_61zpoe$ = function (language) {
    switch (language) {
      case 'en':
        return Str_getInstance().get_y4putb$(Id_getInstance().english);
      case 'fr':
        return Str_getInstance().get_y4putb$(Id_getInstance().french);
      default:throw new JavelinException('Unknown language: ' + language);
    }
  };
  Language.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Language',
    interfaces: []
  };
  var Language_instance = null;
  function Language_getInstance() {
    if (Language_instance === null) {
      new Language();
    }
    return Language_instance;
  }
  function Notification(record, title, status, obj) {
    if (obj === void 0)
      obj = null;
    this.record = record;
    this.title = title;
    this.status = status;
    this.obj = obj;
  }
  Notification.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Notification',
    interfaces: []
  };
  function Outbreak(outbreakId, locations, latitude, longitude, diseaseNames, diseaseConceptId, date, source) {
    this.outbreakId = outbreakId;
    this.locations = locations;
    this.latitude = latitude;
    this.longitude = longitude;
    this.diseaseNames = diseaseNames;
    this.diseaseConceptId = diseaseConceptId;
    this.date = date;
    this.source = source;
  }
  Object.defineProperty(Outbreak.prototype, 'location', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.locations, Language_getInstance().get_8be2vx$());
    }
  });
  Object.defineProperty(Outbreak.prototype, 'diseaseName', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.diseaseNames, Language_getInstance().get_8be2vx$());
    }
  });
  Outbreak.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Outbreak',
    interfaces: []
  };
  function PHUConfig(phuId, phuNames, isEnabled, color, colorDark, iconUrl, consentTexts, consentTextsRich, maxAge, headerUrls, modalHeaderUrls, webModalHeaderUrls, cityIds) {
    this.phuId = phuId;
    this.phuNames = phuNames;
    this.isEnabled = isEnabled;
    this.color = color;
    this.colorDark = colorDark;
    this.iconUrl = iconUrl;
    this.consentTexts = consentTexts;
    this.consentTextsRich = consentTextsRich;
    this.maxAge = maxAge;
    this.headerUrls = headerUrls;
    this.modalHeaderUrls = modalHeaderUrls;
    this.webModalHeaderUrls = webModalHeaderUrls;
    this.cityIds = cityIds;
    this.cities_fmmmbu$_0 = lazy(PHUConfig$cities$lambda(this));
  }
  Object.defineProperty(PHUConfig.prototype, 'phuName', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.phuNames, Language_getInstance().get_8be2vx$());
    }
  });
  Object.defineProperty(PHUConfig.prototype, 'consentText', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.consentTexts, Language_getInstance().get_8be2vx$());
    }
  });
  Object.defineProperty(PHUConfig.prototype, 'consentTextRich', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.consentTextsRich, Language_getInstance().get_8be2vx$());
    }
  });
  Object.defineProperty(PHUConfig.prototype, 'headerUrl', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.headerUrls, Language_getInstance().get_8be2vx$());
    }
  });
  Object.defineProperty(PHUConfig.prototype, 'modalHeaderUrl', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.modalHeaderUrls, Language_getInstance().get_8be2vx$());
    }
  });
  Object.defineProperty(PHUConfig.prototype, 'webModalHeaderUrl', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.webModalHeaderUrls, Language_getInstance().get_8be2vx$());
    }
  });
  Object.defineProperty(PHUConfig.prototype, 'cities', {
    get: function () {
      return this.cities_fmmmbu$_0.value;
    }
  });
  function PHUConfig$cities$lambda(this$PHUConfig) {
    return function () {
      var $receiver = this$PHUConfig.cityIds;
      var destination = ArrayList_init(collectionSizeOrDefault($receiver, 10));
      var tmp$;
      tmp$ = $receiver.iterator();
      while (tmp$.hasNext()) {
        var item = tmp$.next();
        destination.add_11rb$(JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(City), (new QueryBuilder(Type_getInstance().CITY)).where_puj7f4$('cityId', item)));
      }
      return requireNoNulls(destination);
    };
  }
  PHUConfig.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'PHUConfig',
    interfaces: []
  };
  var LinkedHashMap_init = Kotlin.kotlin.collections.LinkedHashMap_init_q3lmfv$;
  function Region(key) {
    this.key = key;
    this.names_0 = LinkedHashMap_init();
  }
  Object.defineProperty(Region.prototype, 'name', {
    get: function () {
      var language = Language_getInstance().get_8be2vx$();
      if (!this.names_0.containsKey_11rb$(language)) {
        var $receiver = this.names_0;
        var value = Str_getInstance().get_y4putb$(this.key);
        $receiver.put_xwzc9p$(language, value);
      }
      return ensureNotNull(this.names_0.get_11rb$(language));
    }
  });
  Region.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Region',
    interfaces: []
  };
  function Relationship() {
    Relationship_instance = this;
    this.UNKNOWN = -1;
    this.SELF = 0;
    this.PARENT_GUARDIAN = 1;
    this.SPOUSE = 2;
    this.OTHER = 3;
  }
  Relationship.prototype.getName = function (relationship) {
    var tmp$;
    switch (relationship) {
      case -1:
        return '';
      case 0:
        tmp$ = Id_getInstance().relationship_self;
        break;
      case 1:
        tmp$ = Id_getInstance().relationship_guardian;
        break;
      case 2:
        tmp$ = Id_getInstance().relationship_spouse;
        break;
      case 3:
        tmp$ = Id_getInstance().relationship_other;
        break;
      default:Log_getInstance().e_xnh3o3$('Relationship', 'Unknown relationship: ' + relationship);
        return '';
    }
    var stringId = tmp$;
    return Str_getInstance().get_y4putb$(stringId);
  };
  Relationship.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Relationship',
    interfaces: []
  };
  var Relationship_instance = null;
  function Relationship_getInstance() {
    if (Relationship_instance === null) {
      new Relationship();
    }
    return Relationship_instance;
  }
  function Status() {
    Status_instance = this;
    this.OVERDUE = 0;
    this.APPROACHING = 1;
    this.RECEIVED = 2;
    this.FUTURE = 3;
    this.IGNORED = 4;
  }
  Status.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Status',
    interfaces: []
  };
  var Status_instance = null;
  function Status_getInstance() {
    if (Status_instance === null) {
      new Status();
    }
    return Status_instance;
  }
  function Concept(conceptId, snomedCTId, preferredTerms) {
    this.conceptId = conceptId;
    this.snomedCTId = snomedCTId;
    this.preferredTerms = preferredTerms;
  }
  Object.defineProperty(Concept.prototype, 'preferredTerm', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.preferredTerms, Language_getInstance().get_8be2vx$());
    }
  });
  Object.defineProperty(Concept.prototype, 'color', {
    get: function () {
      return '#CCCCCC';
    }
  });
  Concept.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Concept',
    interfaces: []
  };
  function DiseaseConcept(conceptId, snomedCTId, preferredTerms) {
    Concept.call(this, conceptId, snomedCTId, preferredTerms);
    this.disease_uj5yzm$_0 = lazy(DiseaseConcept$disease$lambda(conceptId));
    this.preferredTerm_457tzj$_0 = lazy(DiseaseConcept$preferredTerm$lambda(this));
    this.conceptPreferredTerm_jam3w1$_0 = lazy(DiseaseConcept$conceptPreferredTerm$lambda(this));
  }
  Object.defineProperty(DiseaseConcept.prototype, 'disease', {
    get: function () {
      return this.disease_uj5yzm$_0.value;
    }
  });
  Object.defineProperty(DiseaseConcept.prototype, 'preferredTerm', {
    get: function () {
      return this.preferredTerm_457tzj$_0.value;
    }
  });
  Object.defineProperty(DiseaseConcept.prototype, 'conceptPreferredTerm', {
    get: function () {
      return this.conceptPreferredTerm_jam3w1$_0.value;
    }
  });
  DiseaseConcept.prototype.equals = function (other) {
    return Kotlin.isType(other, DiseaseConcept) && equals(other.conceptId, this.conceptId);
  };
  function DiseaseConcept$disease$lambda(closure$conceptId) {
    return function () {
      return JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(Disease), (new QueryBuilder(Type_getInstance().DISEASE)).where_puj7f4$('conceptId', closure$conceptId));
    };
  }
  function DiseaseConcept$preferredTerm$lambda(this$DiseaseConcept) {
    return function () {
      var tmp$, tmp$_0;
      return (tmp$_0 = (tmp$ = this$DiseaseConcept.disease) != null ? tmp$.preferredTerm : null) != null ? tmp$_0 : this$DiseaseConcept.conceptPreferredTerm;
    };
  }
  function DiseaseConcept$conceptPreferredTerm$lambda(this$DiseaseConcept) {
    return function () {
      return Kotlin.callGetter(this$DiseaseConcept, Concept.prototype, 'preferredTerm');
    };
  }
  DiseaseConcept.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'DiseaseConcept',
    interfaces: [Concept]
  };
  function GenericConcept(conceptId, snomedCTId, preferredTerms, displayTerms, abbreviations, diseaseConceptIds, diseaseDescriptions, isShownInPickList, color) {
    VaccineConcept.call(this, conceptId, snomedCTId, preferredTerms, displayTerms);
    this.abbreviations = abbreviations;
    this.diseaseConceptIds_drw6l$_0 = diseaseConceptIds;
    this.diseaseDescriptions = diseaseDescriptions;
    this.isShownInPickList = isShownInPickList;
    this.color_2w0hh2$_0 = color;
    this.tradeNameConcepts_xkdwjj$_0 = lazy(GenericConcept$tradeNameConcepts$lambda(conceptId));
  }
  Object.defineProperty(GenericConcept.prototype, 'diseaseConceptIds', {
    get: function () {
      return this.diseaseConceptIds_drw6l$_0;
    }
  });
  Object.defineProperty(GenericConcept.prototype, 'color', {
    get: function () {
      return this.color_2w0hh2$_0;
    }
  });
  Object.defineProperty(GenericConcept.prototype, 'tradeNameConcepts', {
    get: function () {
      return this.tradeNameConcepts_xkdwjj$_0.value;
    }
  });
  function GenericConcept$tradeNameConcepts$lambda(closure$conceptId) {
    return function () {
      return JavelinManager$Companion_getInstance().dm_8be2vx$.queryList(getKClass(TradeNameConcept), (new QueryBuilder(Type_getInstance().TRADE_NAME_CONCEPT)).where_puj7f4$('parentConceptId', closure$conceptId));
    };
  }
  GenericConcept.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'GenericConcept',
    interfaces: [VaccineConcept]
  };
  function TradeNameConcept(conceptId, snomedCTId, preferredTerms, displayTerms, parentConceptId, din, manufacturer, gtins) {
    VaccineConcept.call(this, conceptId, snomedCTId, preferredTerms, displayTerms);
    this.parentConceptId_57l854$_0 = parentConceptId;
    this.din = din;
    this.manufacturer = manufacturer;
    this.gtins = gtins;
  }
  Object.defineProperty(TradeNameConcept.prototype, 'parentConceptId', {
    get: function () {
      return this.parentConceptId_57l854$_0;
    }
  });
  TradeNameConcept.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'TradeNameConcept',
    interfaces: [VaccineConcept]
  };
  function VaccineConcept(conceptId, snomedCTId, preferredTerms, displayTerms) {
    Concept.call(this, conceptId, snomedCTId, preferredTerms);
    this.displayTerms = displayTerms;
    this.parentConceptId_gl342q$_0 = conceptId;
    this.parentConcept_k9pcxz$_0 = lazy(VaccineConcept$parentConcept$lambda(conceptId, this));
    this.vaccine_1ljp8e$_0 = lazy(VaccineConcept$vaccine$lambda(conceptId));
    this.abbreviation_scck29$_0 = lazy(VaccineConcept$abbreviation$lambda(this));
    this.conceptAbbreviation_4n8fsv$_0 = lazy(VaccineConcept$conceptAbbreviation$lambda(this));
  }
  Object.defineProperty(VaccineConcept.prototype, 'parentConceptId', {
    get: function () {
      return this.parentConceptId_gl342q$_0;
    }
  });
  Object.defineProperty(VaccineConcept.prototype, 'parentConcept', {
    get: function () {
      return this.parentConcept_k9pcxz$_0.value;
    }
  });
  Object.defineProperty(VaccineConcept.prototype, 'vaccine', {
    get: function () {
      return this.vaccine_1ljp8e$_0.value;
    }
  });
  Object.defineProperty(VaccineConcept.prototype, 'color', {
    get: function () {
      return this.parentConcept.color;
    }
  });
  Object.defineProperty(VaccineConcept.prototype, 'displayTerm', {
    get: function () {
      var tmp$, tmp$_0;
      return (tmp$_0 = (tmp$ = this.vaccine) != null ? tmp$.displayTerm : null) != null ? tmp$_0 : this.conceptDisplayTerm;
    }
  });
  Object.defineProperty(VaccineConcept.prototype, 'conceptDisplayTerm', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.displayTerms, Language_getInstance().get_8be2vx$());
    }
  });
  Object.defineProperty(VaccineConcept.prototype, 'abbreviation', {
    get: function () {
      return this.abbreviation_scck29$_0.value;
    }
  });
  Object.defineProperty(VaccineConcept.prototype, 'conceptAbbreviation', {
    get: function () {
      return this.conceptAbbreviation_4n8fsv$_0.value;
    }
  });
  Object.defineProperty(VaccineConcept.prototype, 'diseaseConceptIds', {
    get: function () {
      return this.parentConcept.diseaseConceptIds;
    }
  });
  VaccineConcept.prototype.hasDiseaseConceptId_pdl1vj$ = function (conceptId) {
    return contains(this.diseaseConceptIds, conceptId);
  };
  VaccineConcept.prototype.equals = function (other) {
    return Kotlin.isType(other, VaccineConcept) && equals(other.conceptId, this.conceptId);
  };
  var IllegalStateException_init = Kotlin.kotlin.IllegalStateException_init_pdl1vj$;
  function VaccineConcept$parentConcept$lambda(closure$conceptId, this$VaccineConcept) {
    return function () {
      var tmp$, tmp$_0;
      if (equals(closure$conceptId, this$VaccineConcept.parentConceptId)) {
        return Kotlin.isType(tmp$ = this$VaccineConcept, GenericConcept) ? tmp$ : throwCCE();
      }
       else {
        var tmp$_1;
        if ((tmp$_0 = JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(GenericConcept), (new QueryBuilder(Type_getInstance().GENERIC_CONCEPT)).where_puj7f4$('conceptId', this$VaccineConcept.parentConceptId))) != null)
          tmp$_1 = tmp$_0;
        else {
          throw IllegalStateException_init('Parent concept not found'.toString());
        }
        return tmp$_1;
      }
    };
  }
  function VaccineConcept$vaccine$lambda(closure$conceptId) {
    return function () {
      return JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(Vaccine), (new QueryBuilder(Type_getInstance().VACCINE)).where_puj7f4$('conceptId', closure$conceptId));
    };
  }
  function VaccineConcept$abbreviation$lambda(this$VaccineConcept) {
    return function () {
      var tmp$, tmp$_0;
      return (tmp$_0 = (tmp$ = this$VaccineConcept.parentConcept.vaccine) != null ? tmp$.abbreviation : null) != null ? tmp$_0 : this$VaccineConcept.conceptAbbreviation;
    };
  }
  function VaccineConcept$conceptAbbreviation$lambda(this$VaccineConcept) {
    return function () {
      return Help_getInstance().getMapValue_ije21m$(this$VaccineConcept.parentConcept.abbreviations, Language_getInstance().get_8be2vx$());
    };
  }
  VaccineConcept.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'VaccineConcept',
    interfaces: [Concept]
  };
  function JLocalDate() {
  }
  JLocalDate.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'JLocalDate',
    interfaces: []
  };
  function JZonedDateTime() {
  }
  JZonedDateTime.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'JZonedDateTime',
    interfaces: [JLocalDate]
  };
  function CollectionPage(record, collection) {
    Page.call(this, record);
    this.collection_0 = collection;
    this.lowerDate_0 = this.collection_0.getMinDate_jho0x0$(record);
    this.upperDate_0 = this.collection_0.getMaxDate_jho0x0$(record);
    this.pageId_m9nqi$_0 = this.collection_0.collectionId;
  }
  Object.defineProperty(CollectionPage.prototype, 'pageId', {
    get: function () {
      return this.pageId_m9nqi$_0;
    }
  });
  Object.defineProperty(CollectionPage.prototype, 'name', {
    get: function () {
      return this.collection_0.name;
    }
  });
  Object.defineProperty(CollectionPage.prototype, 'description', {
    get: function () {
      return this.collection_0.description;
    }
  });
  Object.defineProperty(CollectionPage.prototype, 'dateDescription', {
    get: function () {
      var tmp$;
      if (this.lowerDate_0 == null || this.upperDate_0 == null) {
        tmp$ = null;
      }
       else if (this.upperDate_0.isEqual(this.lowerDate_0)) {
        tmp$ = Str_getInstance().get_ge7pzc$(Id_getInstance().visit_recommended_date, [this.lowerDate_0.longDateString]);
      }
       else {
        tmp$ = Str_getInstance().get_ge7pzc$(Id_getInstance().visit_recommended_dates, [this.lowerDate_0.monthAndYearString, this.upperDate_0.monthAndYearString]);
      }
      return tmp$;
    }
  });
  CollectionPage.prototype.canAddDoses = function () {
    return this.collection_0.canAddDoses;
  };
  CollectionPage.prototype.getPageIndex = function (pageType) {
    switch (pageType) {
      case 0:
      case 4:
        return this.collection_0.childIndex;
      case 1:
      case 5:
        return this.collection_0.adultIndex;
      default:return -1;
    }
  };
  CollectionPage.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'CollectionPage',
    interfaces: [Page]
  };
  function OtherPage(record, isOtherPage, doses) {
    OtherPage$Companion_getInstance();
    Page.call(this, record);
    this.isOtherPage_0 = isOtherPage;
    this.addDoses(doses);
  }
  Object.defineProperty(OtherPage.prototype, 'pageId', {
    get: function () {
      return this.isOtherPage_0 ? OtherPage$Companion_getInstance().OTHER_ID : OtherPage$Companion_getInstance().TRAVEL_ID;
    }
  });
  Object.defineProperty(OtherPage.prototype, 'name', {
    get: function () {
      return Str_getInstance().get_y4putb$(this.isOtherPage_0 ? Id_getInstance().other : Id_getInstance().travel);
    }
  });
  Object.defineProperty(OtherPage.prototype, 'description', {
    get: function () {
      return Str_getInstance().get_y4putb$(this.isOtherPage_0 ? Id_getInstance().page_other_description : Id_getInstance().page_travel_description);
    }
  });
  Object.defineProperty(OtherPage.prototype, 'dateDescription', {
    get: function () {
      return null;
    }
  });
  OtherPage.prototype.canAddDoses = function () {
    return true;
  };
  OtherPage.prototype.getPageIndex = function (pageType) {
    if (pageType === 4 || pageType === 5 || (pageType === 2 && this.isOtherPage_0) || (pageType === 3 && !this.isOtherPage_0)) {
      return 0;
    }
     else {
      return -1;
    }
  };
  function OtherPage$Companion() {
    OtherPage$Companion_instance = this;
    this.OTHER_ID = '-1';
    this.TRAVEL_ID = '-2';
  }
  OtherPage$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var OtherPage$Companion_instance = null;
  function OtherPage$Companion_getInstance() {
    if (OtherPage$Companion_instance === null) {
      new OtherPage$Companion();
    }
    return OtherPage$Companion_instance;
  }
  OtherPage.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'OtherPage',
    interfaces: [Page]
  };
  function Page(record) {
    this.recordId = record.recordId;
    this.doses = ArrayList_init_0();
  }
  Page.prototype.getPageDate = function (record) {
    var date = {v: null};
    var $receiver = this.doses;
    var destination = ArrayList_init_0();
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      var currentDate = date.v;
      if (!element.isReceived && !element.isIgnored(record) && (currentDate == null || element.overallDate.isBefore(currentDate)))
        destination.add_11rb$(element);
    }
    var tmp$_0;
    tmp$_0 = destination.iterator();
    while (tmp$_0.hasNext()) {
      var element_0 = tmp$_0.next();
      date.v = element_0.overallDate;
    }
    return date.v;
  };
  Page.prototype.addDose = function (dose) {
    this.doses.add_11rb$(dose);
    this.sortDoses_cpb6e2$_0();
  };
  Page.prototype.removeDose = function (dose) {
    this.doses.remove_11rb$(dose);
  };
  Page.prototype.addDoses = function (doses) {
    this.doses.addAll_brywnq$(doses);
    this.sortDoses_cpb6e2$_0();
  };
  Page.prototype.isOnPage = function (pageType) {
    return this.getPageIndex(pageType) !== -1;
  };
  function Page$sortDoses$lambda(o1, o2) {
    if (o1.scheduleId != null && o2.scheduleId != null || (o1.scheduleId == null && o2.scheduleId == null)) {
      var abbreviation1 = o1.concept().abbreviation.toLowerCase();
      var abbreviation2 = o2.concept().abbreviation.toLowerCase();
      return Kotlin.compareTo(abbreviation1, abbreviation2);
    }
     else if (o1.scheduleId != null)
      return -1;
    else
      return 1;
  }
  var Comparator = Kotlin.kotlin.Comparator;
  function Comparator$ObjectLiteral(closure$comparison) {
    this.closure$comparison = closure$comparison;
  }
  Comparator$ObjectLiteral.prototype.compare = function (a, b) {
    return this.closure$comparison(a, b);
  };
  Comparator$ObjectLiteral.$metadata$ = {kind: Kind_CLASS, interfaces: [Comparator]};
  Page.prototype.sortDoses_cpb6e2$_0 = function () {
    sortWith(this.doses, new Comparator$ObjectLiteral(Page$sortDoses$lambda));
  };
  Page.prototype.hasDoses = function () {
    return !this.doses.isEmpty();
  };
  Page.prototype.ignore = function (record) {
    var $receiver = this.doses;
    var destination = ArrayList_init_0();
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      if (element.generatorId != null)
        destination.add_11rb$(element);
    }
    var tmp$_0;
    tmp$_0 = destination.iterator();
    while (tmp$_0.hasNext()) {
      var element_0 = tmp$_0.next();
      record.addIgnoredDose_yhrpff$(element_0);
    }
    record.saveFieldChanges(listOf(10));
    JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().UI_UPDATE, this.recordId);
  };
  var Collection = Kotlin.kotlin.collections.Collection;
  Page.prototype.isIgnored = function (record) {
    var $receiver = this.doses;
    var any$result;
    any$break: do {
      var tmp$;
      if (Kotlin.isType($receiver, Collection) && $receiver.isEmpty()) {
        any$result = false;
        break any$break;
      }
      tmp$ = $receiver.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        if (!element.isIgnored(record)) {
          any$result = true;
          break any$break;
        }
      }
      any$result = false;
    }
     while (false);
    return !any$result;
  };
  Page.prototype.getDose = function (doseId) {
    var $receiver = this.doses;
    var firstOrNull$result;
    firstOrNull$break: do {
      var tmp$;
      tmp$ = $receiver.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        if (equals(element.doseId, doseId)) {
          firstOrNull$result = element;
          break firstOrNull$break;
        }
      }
      firstOrNull$result = null;
    }
     while (false);
    return firstOrNull$result;
  };
  function Page$Type() {
    Page$Type_instance = this;
    this.ALL = -1;
    this.CHILD = 0;
    this.ADULT = 1;
    this.OTHER = 2;
    this.TRAVEL = 3;
    this.CHILD_INCLUSIVE = 4;
    this.ADULT_INCLUSIVE = 5;
  }
  Page$Type.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Type',
    interfaces: []
  };
  var Page$Type_instance = null;
  function Page$Type_getInstance() {
    if (Page$Type_instance === null) {
      new Page$Type();
    }
    return Page$Type_instance;
  }
  Page.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Page',
    interfaces: []
  };
  function Error_0(titleId, message, buttonId) {
    Error$Companion_getInstance();
    Result.call(this, titleId, message, buttonId, true);
  }
  function Error$Companion() {
    Error$Companion_instance = this;
  }
  Error$Companion.prototype.string = function (message) {
    return new Error_0(Id_getInstance().error, message, Id_getInstance().okay);
  };
  Error$Companion.prototype.id = function (messageId) {
    return this.string(Str_getInstance().get_y4putb$(messageId));
  };
  Error$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var Error$Companion_instance = null;
  function Error$Companion_getInstance() {
    if (Error$Companion_instance === null) {
      new Error$Companion();
    }
    return Error$Companion_instance;
  }
  Error_0.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Error',
    interfaces: [Result]
  };
  function Result(titleId, message, buttonId, isError) {
    this.titleId = titleId;
    this.message = message;
    this.buttonId = buttonId;
    this.isError = isError;
  }
  Result.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Result',
    interfaces: []
  };
  function Success(titleId, message, buttonId) {
    Success$Companion_getInstance();
    Result.call(this, titleId, message, buttonId, false);
  }
  function Success$Companion() {
    Success$Companion_instance = this;
  }
  Success$Companion.prototype.successId = function (messageId) {
    return this.success(Str_getInstance().get_y4putb$(messageId));
  };
  Success$Companion.prototype.success = function (message) {
    return new Success(Id_getInstance().success, message, Id_getInstance().okay);
  };
  Success$Companion.prototype.thankYouId = function (messageId) {
    return new Success(Id_getInstance().thank_you, Str_getInstance().get_y4putb$(messageId), Id_getInstance().okay);
  };
  Success$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var Success$Companion_instance = null;
  function Success$Companion_getInstance() {
    if (Success$Companion_instance === null) {
      new Success$Companion();
    }
    return Success$Companion_instance;
  }
  Success.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Success',
    interfaces: [Result]
  };
  function Banner(bannerId, name, priority, links, compositeImageURLs, backgroundImageURLs, foregroundImageURLs, filters) {
    Banner$Companion_getInstance();
    this.bannerId = bannerId;
    this.name = name;
    this.priority = priority;
    this.links = links;
    this.compositeImageURLs = compositeImageURLs;
    this.backgroundImageURLs = backgroundImageURLs;
    this.foregroundImageURLs = foregroundImageURLs;
    this.filters = filters;
  }
  Object.defineProperty(Banner.prototype, 'link', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.links, Language_getInstance().get_8be2vx$());
    }
  });
  Object.defineProperty(Banner.prototype, 'compositeImageURL', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.compositeImageURLs, Language_getInstance().get_8be2vx$());
    }
  });
  Object.defineProperty(Banner.prototype, 'backgroundImageURL', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.backgroundImageURLs, Language_getInstance().get_8be2vx$());
    }
  });
  Object.defineProperty(Banner.prototype, 'foregroundImageURL', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.foregroundImageURLs, Language_getInstance().get_8be2vx$());
    }
  });
  function Banner$Companion() {
    Banner$Companion_instance = this;
  }
  function Banner$Companion$getFilteredBanners$lambda(a, b) {
    return a.priority - b.priority | 0;
  }
  function Comparator$ObjectLiteral_0(closure$comparison) {
    this.closure$comparison = closure$comparison;
  }
  Comparator$ObjectLiteral_0.prototype.compare = function (a, b) {
    return this.closure$comparison(a, b);
  };
  Comparator$ObjectLiteral_0.$metadata$ = {kind: Kind_CLASS, interfaces: [Comparator]};
  Banner$Companion.prototype.getFilteredBanners = function (banners) {
    var destination = ArrayList_init_0();
    var tmp$;
    tmp$ = banners.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      if (Filter$Companion_getInstance().canBeShown_1nqkch$(element.filters))
        destination.add_11rb$(element);
    }
    return sortedWith(destination, new Comparator$ObjectLiteral_0(Banner$Companion$getFilteredBanners$lambda));
  };
  Banner$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var Banner$Companion_instance = null;
  function Banner$Companion_getInstance() {
    if (Banner$Companion_instance === null) {
      new Banner$Companion();
    }
    return Banner$Companion_instance;
  }
  Banner.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Banner',
    interfaces: []
  };
  function Disease(diseaseId, conceptId, preferredTerms, descriptions, faqs, isTravel) {
    this.diseaseId = diseaseId;
    this.conceptId = conceptId;
    this.preferredTerms = preferredTerms;
    this.descriptions = descriptions;
    this.faqs = faqs;
    this.isTravel = isTravel;
    this.concept_2wovzx$_0 = lazy(Disease$concept$lambda(this));
  }
  Object.defineProperty(Disease.prototype, 'concept', {
    get: function () {
      return this.concept_2wovzx$_0.value;
    }
  });
  Object.defineProperty(Disease.prototype, 'preferredTerm', {
    get: function () {
      var tmp$;
      var preferredTerm = Help_getInstance().getMapValue_ije21m$(this.preferredTerms, Language_getInstance().get_8be2vx$());
      if (!isError(preferredTerm)) {
        tmp$ = preferredTerm;
      }
       else {
        tmp$ = this.concept.conceptPreferredTerm;
      }
      return tmp$;
    }
  });
  Object.defineProperty(Disease.prototype, 'diseaseDescription', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.descriptions, Language_getInstance().get_8be2vx$());
    }
  });
  Disease.prototype.equals = function (other) {
    return Kotlin.isType(other, Disease) && equals(other.diseaseId, this.diseaseId);
  };
  function Disease$concept$lambda(this$Disease) {
    return function () {
      var tmp$;
      var tmp$_0;
      if ((tmp$ = JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(DiseaseConcept), (new QueryBuilder(Type_getInstance().DISEASE_CONCEPT)).where_puj7f4$('conceptId', this$Disease.conceptId))) != null)
        tmp$_0 = tmp$;
      else {
        throw IllegalStateException_init('Disease Concept was null'.toString());
      }
      return tmp$_0;
    };
  }
  Disease.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Disease',
    interfaces: []
  };
  function DoseGenerator(generatorId, conceptId, collectionId, scheduleId, isActive, age, descriptions, rules) {
    this.generatorId = generatorId;
    this.conceptId = conceptId;
    this.collectionId = collectionId;
    this.scheduleId = scheduleId;
    this.isActive = isActive;
    this.age = age;
    this.descriptions = descriptions;
    this.rules = rules;
    this.genericConcept_vqhnqq$_0 = lazy(DoseGenerator$genericConcept$lambda(this));
  }
  Object.defineProperty(DoseGenerator.prototype, 'genericConcept', {
    get: function () {
      return this.genericConcept_vqhnqq$_0.value;
    }
  });
  Object.defineProperty(DoseGenerator.prototype, 'description', {
    get: function () {
      return this.descriptions.get_11rb$(Language_getInstance().get_8be2vx$());
    }
  });
  Object.defineProperty(DoseGenerator.prototype, 'isOverdueDateShown', {
    get: function () {
      var $receiver = this.rules;
      var none$result;
      none$break: do {
        var tmp$;
        if (Kotlin.isType($receiver, Collection) && $receiver.isEmpty()) {
          none$result = true;
          break none$break;
        }
        tmp$ = $receiver.iterator();
        while (tmp$.hasNext()) {
          var element = tmp$.next();
          if (element.name === 9) {
            none$result = false;
            break none$break;
          }
        }
        none$result = true;
      }
       while (false);
      return none$result;
    }
  });
  DoseGenerator.prototype.getRule_kcn2v3$ = function (name) {
    var $receiver = this.rules;
    var firstOrNull$result;
    firstOrNull$break: do {
      var tmp$;
      tmp$ = $receiver.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        if (element.name === name) {
          firstOrNull$result = element;
          break firstOrNull$break;
        }
      }
      firstOrNull$result = null;
    }
     while (false);
    return firstOrNull$result;
  };
  function DoseGenerator$getDoses$lambda(o1, o2) {
    return o1.overallDate.compareTo(o2.overallDate);
  }
  function DoseGenerator$getDoses$lambda_0(closure$value, closure$doses) {
    return function (dose) {
      if (dose.concept().hasDiseaseConceptId_pdl1vj$(closure$value != null ? closure$value.id : null)) {
        closure$doses.add_11rb$(dose);
      }
      return Unit;
    };
  }
  function DoseGenerator$getDoses$lambda_1(o1, o2) {
    return o2.overallDate.compareTo(o1.overallDate);
  }
  function Comparator$ObjectLiteral_1(closure$comparison) {
    this.closure$comparison = closure$comparison;
  }
  Comparator$ObjectLiteral_1.prototype.compare = function (a, b) {
    return this.closure$comparison(a, b);
  };
  Comparator$ObjectLiteral_1.$metadata$ = {kind: Kind_CLASS, interfaces: [Comparator]};
  function Comparator$ObjectLiteral_2(closure$comparison) {
    this.closure$comparison = closure$comparison;
  }
  Comparator$ObjectLiteral_2.prototype.compare = function (a, b) {
    return this.closure$comparison(a, b);
  };
  Comparator$ObjectLiteral_2.$metadata$ = {kind: Kind_CLASS, interfaces: [Comparator]};
  DoseGenerator.prototype.getDoses_9xc4wl$ = function (record, recordDoses) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4, tmp$_5, tmp$_6, tmp$_7, tmp$_8, tmp$_9, tmp$_10;
    if (!this.isActive && recordDoses.isEmpty()) {
      return recordDoses;
    }
    var genderRule = this.getRule_kcn2v3$(0);
    if (genderRule != null ? !Gender_getInstance().isRightGender((tmp$ = genderRule.getValue_lmshww$(PrimitiveClasses$intClass)) != null ? tmp$ : -1, record.gender) : false) {
      return recordDoses;
    }
    var generatorHideRule = this.getRule_kcn2v3$(1);
    if (generatorHideRule != null && record.hasGeneratorDoses(generatorHideRule.getValue_lmshww$(PrimitiveClasses$stringClass))) {
      return recordDoses;
    }
    var birthdateBeforeHideDate = (tmp$_1 = (tmp$_0 = this.getRule_kcn2v3$(11)) != null ? tmp$_0.getValue_lmshww$(getKClass(DateModifier)) : null) != null ? tmp$_1.toLocalDate_8be2vx$() : null;
    if (birthdateBeforeHideDate != null && record.birthdate.isBefore(birthdateBeforeHideDate)) {
      return recordDoses;
    }
    var birthdateAfterHideDate = (tmp$_3 = (tmp$_2 = this.getRule_kcn2v3$(13)) != null ? tmp$_2.getValue_lmshww$(getKClass(DateModifier)) : null) != null ? tmp$_3.toLocalDate_8be2vx$() : null;
    if (birthdateAfterHideDate != null && record.birthdate.isAfter(birthdateAfterHideDate)) {
      return recordDoses;
    }
    sortWith(recordDoses, new Comparator$ObjectLiteral_1(DoseGenerator$getDoses$lambda));
    var quantity = 1;
    var finiteRecurringDates = ArrayList_init_0();
    var finiteRecurringRule = this.getRule_kcn2v3$(6);
    if (finiteRecurringRule != null) {
      finiteRecurringDates.addAll_brywnq$(finiteRecurringRule.getListValue_lmshww$(getKClass(DateModifier)));
    }
    quantity = quantity + finiteRecurringDates.size | 0;
    var infiniteRecurringRule = this.getRule_kcn2v3$(7);
    if (infiniteRecurringRule != null) {
      quantity = recordDoses.size + 1 | 0;
    }
    var date = this.age.apply(record.birthdate);
    if (!recordDoses.isEmpty() && finiteRecurringRule == null && infiniteRecurringRule == null) {
      recordDoses.get_za3lpa$(0).recommendedDate = date;
    }
    tmp$_4 = recordDoses.size;
    tmp$_5 = quantity;
    for (var i = tmp$_4; i < tmp$_5; i++) {
      var lastDose = null;
      if (!recordDoses.isEmpty()) {
        lastDose = recordDoses.get_za3lpa$(recordDoses.size - 1 | 0);
      }
      var newDate;
      if (lastDose != null) {
        if (finiteRecurringRule != null) {
          tmp$_8 = finiteRecurringDates.get_za3lpa$(recordDoses.size - 1 | 0).apply(lastDose.overallDate);
        }
         else if (infiniteRecurringRule != null) {
          var tmp$_11;
          if ((tmp$_7 = (tmp$_6 = infiniteRecurringRule.getValue_lmshww$(getKClass(DateModifier))) != null ? tmp$_6.apply(lastDose.overallDate) : null) != null)
            tmp$_11 = tmp$_7;
          else {
            throw IllegalStateException_init('Unable to parse rule date'.toString());
          }
          tmp$_8 = tmp$_11;
        }
         else {
          Log_getInstance().e_xnh3o3$('DoseGenerator', 'Multiple doses without a recurring rule');
          continue;
        }
        newDate = tmp$_8;
      }
       else {
        newDate = date;
      }
      var diseaseReschedulingRule = this.getRule_kcn2v3$(3);
      if (diseaseReschedulingRule != null) {
        var value = diseaseReschedulingRule.getValue_lmshww$(getKClass(Rule$IdDate));
        var doses = ArrayList_init_0();
        JavelinManager$Companion_getInstance().dm_8be2vx$.operateList(getKClass(Dose), (new QueryBuilder(Type_getInstance().DOSE)).where_puj7f4$('recordId', record.recordId), DoseGenerator$getDoses$lambda_0(value, doses));
        if (!doses.isEmpty()) {
          sortWith(doses, new Comparator$ObjectLiteral_2(DoseGenerator$getDoses$lambda_1));
          var rescheduledDate = (tmp$_9 = value != null ? value.interval : null) != null ? tmp$_9.apply(doses.get_za3lpa$(0).overallDate) : null;
          if (rescheduledDate != null && newDate.isBefore(rescheduledDate)) {
            newDate = rescheduledDate;
          }
        }
      }
      var recurringDayRule = this.getRule_kcn2v3$(8);
      if (recurringDayRule != null) {
        newDate = this.findClosestDate_0(infiniteRecurringRule == null ? newDate : Date_getInstance().now_8be2vx$(), (tmp$_10 = lastDose != null ? lastDose.overallDate : null) != null ? tmp$_10 : date, false, recurringDayRule.getValue_lmshww$(getKClass(DateModifier)));
      }
      var dose = Dose_init_1(record, this.genericConcept, this.generatorId, this.collectionId, this.scheduleId, newDate);
      if (dose.isIgnored(record) && infiniteRecurringRule != null) {
        quantity = quantity + 1 | 0;
      }
      recordDoses.add_11rb$(dose);
    }
    return recordDoses;
  };
  DoseGenerator.prototype.findClosestDate_0 = function (desiredDate, minDate, isFutureOnly, day) {
    var tmp$;
    if (day == null) {
      throw IllegalStateException_init('Day was null'.toString());
    }
    var currentYear = Date_getInstance().of_cub51b$(desiredDate.year, day.months, day.days);
    var previousYear = currentYear.minusYears(1);
    var nextYear = currentYear.plusYears(1);
    var desiredDateMillis = desiredDate.toMillis();
    var currentInterval = abs(desiredDateMillis.subtract(currentYear.toMillis()));
    var previousInterval = abs(desiredDateMillis.subtract(previousYear.toMillis()));
    var nextInterval = abs(desiredDateMillis.subtract(nextYear.toMillis()));
    var newDate;
    if (currentInterval.compareTo_11rb$(previousInterval) <= 0 && currentInterval.compareTo_11rb$(nextInterval) <= 0) {
      tmp$ = currentYear;
    }
     else if (previousInterval.compareTo_11rb$(currentInterval) <= 0 && previousInterval.compareTo_11rb$(nextInterval) <= 0) {
      tmp$ = previousYear;
    }
     else {
      tmp$ = nextYear;
    }
    newDate = tmp$;
    while (!minDate.isBefore(newDate))
      newDate = newDate.plusYears(1);
    if (isFutureOnly) {
      while (newDate.isPast) {
        newDate = newDate.plusYears(1);
      }
    }
    return newDate;
  };
  DoseGenerator.prototype.getExpectedDoses_tjuny1$ = function (record) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3;
    var today = Date_getInstance().now_8be2vx$();
    var startDate = this.age.apply(record.birthdate);
    if (startDate.isAfter(today)) {
      return 0;
    }
    var infiniteRecurringRule = this.getRule_kcn2v3$(7);
    var recurringRule = this.getRule_kcn2v3$(6);
    if (infiniteRecurringRule == null && recurringRule == null) {
      return 1;
    }
    var recurringDateModifiers = ArrayList_init_0();
    if (recurringRule != null) {
      recurringDateModifiers.addAll_brywnq$(recurringRule.getListValue_lmshww$(getKClass(DateModifier)));
    }
    var endDate = today;
    var ignoreAgeRule = this.getRule_kcn2v3$(4);
    if (ignoreAgeRule != null) {
      var tmp$_4;
      if ((tmp$_0 = (tmp$ = ignoreAgeRule.getValue_lmshww$(getKClass(DateModifier))) != null ? tmp$.apply(record.birthdate) : null) != null)
        tmp$_4 = tmp$_0;
      else {
        throw IllegalStateException_init('IgnoreAge date was null'.toString());
      }
      var ignoreDate = tmp$_4;
      if (ignoreDate.isPast) {
        if (recurringRule != null) {
          return 1 + recurringDateModifiers.size | 0;
        }
        endDate = ignoreDate;
      }
    }
    var total = 0;
    var currentDate = startDate;
    while (currentDate.isBefore(endDate)) {
      if (recurringRule != null) {
        tmp$_3 = recurringDateModifiers.get_za3lpa$(total).apply(currentDate);
      }
       else {
        var tmp$_5;
        if ((tmp$_2 = (tmp$_1 = infiniteRecurringRule != null ? infiniteRecurringRule.getValue_lmshww$(getKClass(DateModifier)) : null) != null ? tmp$_1.apply(currentDate) : null) != null)
          tmp$_5 = tmp$_2;
        else {
          throw IllegalStateException_init('Infinite Recurring rule has a null DateModifier'.toString());
        }
        tmp$_3 = tmp$_5;
      }
      currentDate = tmp$_3;
      total = total + 1 | 0;
    }
    return total;
  };
  DoseGenerator.prototype.isApproaching_tjuny1$ = function (record) {
    var tmp$, tmp$_0, tmp$_1;
    tmp$ = this.getRule_kcn2v3$(5);
    if (tmp$ == null) {
      return false;
    }
    var approachingRule = tmp$;
    var lower = this.age.apply(record.birthdate);
    var tmp$_2;
    if ((tmp$_1 = (tmp$_0 = approachingRule.getValue_lmshww$(getKClass(DateModifier))) != null ? tmp$_0.apply(record.birthdate) : null) != null)
      tmp$_2 = tmp$_1;
    else {
      throw IllegalStateException_init('Date on approaching rule was null'.toString());
    }
    var upper = tmp$_2;
    return !lower.isFuture && !upper.isPast;
  };
  Object.defineProperty(DoseGenerator.prototype, 'isRecurring', {
    get: function () {
      return this.getRule_kcn2v3$(6) != null || this.getRule_kcn2v3$(7) != null;
    }
  });
  DoseGenerator.prototype.isEquivalent_br4uqj$ = function (generator) {
    var tmp$;
    if (generator == null) {
      return false;
    }
    if (equals(generator.scheduleId, this.scheduleId)) {
      return false;
    }
    if (!equals(generator.conceptId, this.conceptId)) {
      return false;
    }
    if (!((tmp$ = generator.age) != null ? tmp$.equals(this.age) : null)) {
      return false;
    }
    var approachingRule = this.getRule_kcn2v3$(5);
    var generatorApproachingRule = generator.getRule_kcn2v3$(5);
    return equals(approachingRule, generatorApproachingRule);
  };
  DoseGenerator.prototype.equals = function (other) {
    return Kotlin.isType(other, DoseGenerator) && equals(other.generatorId, this.generatorId);
  };
  function DoseGenerator$genericConcept$lambda(this$DoseGenerator) {
    return function () {
      var tmp$;
      var tmp$_0;
      if ((tmp$ = JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(GenericConcept), (new QueryBuilder(Type_getInstance().GENERIC_CONCEPT)).where_puj7f4$('conceptId', this$DoseGenerator.conceptId))) != null)
        tmp$_0 = tmp$;
      else {
        throw IllegalStateException_init('Dose GenericConcept was null'.toString());
      }
      return tmp$_0;
    };
  }
  DoseGenerator.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'DoseGenerator',
    interfaces: []
  };
  function FAQ(faqId, parentId, parentType, questions, answers, index) {
    this.faqId = faqId;
    this.parentId = parentId;
    this.parentType = parentType;
    this.questions = questions;
    this.answers = answers;
    this.index = index;
  }
  Object.defineProperty(FAQ.prototype, 'question', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.questions, Language_getInstance().get_8be2vx$());
    }
  });
  Object.defineProperty(FAQ.prototype, 'answer', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.answers, Language_getInstance().get_8be2vx$());
    }
  });
  FAQ.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'FAQ',
    interfaces: []
  };
  function GeneratorCollection(collectionId, scheduleId, names, descriptions, min, max, isActive, canAddDoses, childIndexes, adultIndexes) {
    this.collectionId = collectionId;
    this.scheduleId = scheduleId;
    this.names = names;
    this.descriptions = descriptions;
    this.min = min;
    this.max = max;
    this.isActive = isActive;
    this.canAddDoses = canAddDoses;
    this.childIndexes = childIndexes;
    this.adultIndexes = adultIndexes;
  }
  Object.defineProperty(GeneratorCollection.prototype, 'name', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.names, Language_getInstance().get_8be2vx$());
    }
  });
  Object.defineProperty(GeneratorCollection.prototype, 'description', {
    get: function () {
      return this.descriptions.get_11rb$(Language_getInstance().get_8be2vx$());
    }
  });
  Object.defineProperty(GeneratorCollection.prototype, 'childIndex', {
    get: function () {
      var tmp$;
      return (tmp$ = this.childIndexes.get_11rb$(Language_getInstance().get_8be2vx$())) != null ? tmp$ : -1;
    }
  });
  Object.defineProperty(GeneratorCollection.prototype, 'adultIndex', {
    get: function () {
      var tmp$;
      return (tmp$ = this.adultIndexes.get_11rb$(Language_getInstance().get_8be2vx$())) != null ? tmp$ : -1;
    }
  });
  GeneratorCollection.prototype.getMinDate_jho0x0$ = function (record) {
    var tmp$;
    return (tmp$ = this.min) != null ? tmp$.apply(record.birthdate) : null;
  };
  GeneratorCollection.prototype.getMaxDate_jho0x0$ = function (record) {
    var tmp$;
    return (tmp$ = this.max) != null ? tmp$.apply(record.birthdate) : null;
  };
  GeneratorCollection.prototype.equals = function (other) {
    return Kotlin.isType(other, GeneratorCollection) && equals(other.collectionId, this.collectionId);
  };
  GeneratorCollection.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'GeneratorCollection',
    interfaces: []
  };
  function Rule(ruleId, generatorId, name, jsonValue) {
    this.ruleId = ruleId;
    this.generatorId = generatorId;
    this.name = name;
    this.jsonValue = jsonValue;
  }
  Rule.prototype.getValue_lmshww$ = function (aClass) {
    return Json_getInstance().from_z6hou8$(this.jsonValue, aClass);
  };
  Rule.prototype.getListValue_lmshww$ = function (aClass) {
    return Json_getInstance().listFrom_z6hou8$(this.jsonValue, aClass);
  };
  Rule.prototype.equals = function (other) {
    return Kotlin.isType(other, Rule) && other.name === this.name && equals(other.jsonValue, this.jsonValue);
  };
  function Rule$IdDate(id, interval) {
    this.id = id;
    this.interval = interval;
  }
  Rule$IdDate.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'IdDate',
    interfaces: []
  };
  function Rule$Name() {
    Rule$Name_instance = this;
    this.GENDER = 0;
    this.GENERATOR_HIDE_IF_PRESENT = 1;
    this.GENERATOR_IGNORE_IF_PRESENT = 2;
    this.DISEASE_RESCHEDULE_IF_PRESENT = 3;
    this.RECORD_IGNORE_IF_AGE = 4;
    this.RECORD_APPROACHING_WITHIN_INTERVAL = 5;
    this.RECURRING = 6;
    this.RECURRING_INFINITE = 7;
    this.RECURRING_SET_DAY = 8;
    this.HIDE_OVERDUE_DATE = 9;
    this.RECORD_IGNORE_IF_BIRTHDATE_BEFORE = 10;
    this.RECORD_HIDE_IF_BIRTHDATE_BEFORE = 11;
    this.RECORD_IGNORE_IF_BIRTHDATE_AFTER = 12;
    this.RECORD_HIDE_IF_BIRTHDATE_AFTER = 13;
  }
  Rule$Name.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Name',
    interfaces: []
  };
  var Rule$Name_instance = null;
  function Rule$Name_getInstance() {
    if (Rule$Name_instance === null) {
      new Rule$Name();
    }
    return Rule$Name_instance;
  }
  Rule.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Rule',
    interfaces: []
  };
  function Schedule(scheduleId, names, descriptions, links, region, startDate, endDate) {
    Schedule$Companion_getInstance();
    this.scheduleId = scheduleId;
    this.names = names;
    this.descriptions = descriptions;
    this.links = links;
    this.region = region;
    this.startDate = startDate;
    this.endDate = endDate;
  }
  Object.defineProperty(Schedule.prototype, 'name', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.names, Language_getInstance().get_8be2vx$());
    }
  });
  Object.defineProperty(Schedule.prototype, 'description', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.descriptions, Language_getInstance().get_8be2vx$());
    }
  });
  Object.defineProperty(Schedule.prototype, 'link', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.links, Language_getInstance().get_8be2vx$());
    }
  });
  Schedule.prototype.equals = function (other) {
    return Kotlin.isType(other, Schedule) && equals(other.scheduleId, this.scheduleId);
  };
  function Schedule$Companion() {
    Schedule$Companion_instance = this;
  }
  function Schedule$Companion$findSchedules$lambda(o1, o2) {
    return Kotlin.compareTo(o1.name.toLowerCase(), o2.name.toLowerCase());
  }
  function Schedule$Companion$findSchedules$lambda_0(o1, o2) {
    return Kotlin.compareTo(o1.name.toLowerCase(), o2.name.toLowerCase());
  }
  function Comparator$ObjectLiteral_3(closure$comparison) {
    this.closure$comparison = closure$comparison;
  }
  Comparator$ObjectLiteral_3.prototype.compare = function (a, b) {
    return this.closure$comparison(a, b);
  };
  Comparator$ObjectLiteral_3.$metadata$ = {kind: Kind_CLASS, interfaces: [Comparator]};
  function Comparator$ObjectLiteral_4(closure$comparison) {
    this.closure$comparison = closure$comparison;
  }
  Comparator$ObjectLiteral_4.prototype.compare = function (a, b) {
    return this.closure$comparison(a, b);
  };
  Comparator$ObjectLiteral_4.$metadata$ = {kind: Kind_CLASS, interfaces: [Comparator]};
  Schedule$Companion.prototype.findSchedules = function (schedules, region, birthdate) {
    var tmp$;
    var applicableSchedules = ArrayList_init_0();
    var currentSchedules = ArrayList_init_0();
    tmp$ = schedules.iterator();
    while (tmp$.hasNext()) {
      var schedule = tmp$.next();
      if (region == null || equals_0(region, schedule.region, true)) {
        if (schedule.endDate == null) {
          currentSchedules.add_11rb$(schedule);
        }
        if (birthdate == null || (birthdate.isAfter(schedule.startDate) && (schedule.endDate == null || birthdate.isBefore(schedule.endDate)))) {
          applicableSchedules.add_11rb$(schedule);
        }
      }
    }
    if (applicableSchedules.isEmpty()) {
      sortWith(currentSchedules, new Comparator$ObjectLiteral_3(Schedule$Companion$findSchedules$lambda));
      return currentSchedules;
    }
    sortWith(applicableSchedules, new Comparator$ObjectLiteral_4(Schedule$Companion$findSchedules$lambda_0));
    return applicableSchedules;
  };
  Schedule$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var Schedule$Companion_instance = null;
  function Schedule$Companion_getInstance() {
    if (Schedule$Companion_instance === null) {
      new Schedule$Companion();
    }
    return Schedule$Companion_instance;
  }
  Schedule.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Schedule',
    interfaces: []
  };
  function Vaccine(vaccineId, conceptId, displayTerms, abbreviations, descriptions, faqs, isTravel) {
    this.vaccineId = vaccineId;
    this.conceptId = conceptId;
    this.displayTerms = displayTerms;
    this.abbreviations = abbreviations;
    this.descriptions = descriptions;
    this.faqs = faqs;
    this.isTravel = isTravel;
    this.concept_pu4mp6$_0 = lazy(Vaccine$concept$lambda(this));
  }
  Object.defineProperty(Vaccine.prototype, 'concept', {
    get: function () {
      return this.concept_pu4mp6$_0.value;
    }
  });
  var isBlank = Kotlin.kotlin.text.isBlank_gw00vp$;
  Object.defineProperty(Vaccine.prototype, 'displayTerm', {
    get: function () {
      var tmp$;
      var displayTerm = this.displayTerms.get_11rb$(Language_getInstance().get_8be2vx$());
      var tmp$_0 = displayTerm != null;
      if (tmp$_0) {
        tmp$_0 = !isBlank(displayTerm);
      }
      if (tmp$_0) {
        tmp$ = displayTerm;
      }
       else {
        tmp$ = this.concept.conceptDisplayTerm;
      }
      return tmp$;
    }
  });
  Object.defineProperty(Vaccine.prototype, 'abbreviation', {
    get: function () {
      var tmp$;
      var abbreviation = this.abbreviations.get_11rb$(Language_getInstance().get_8be2vx$());
      var tmp$_0 = abbreviation != null;
      if (tmp$_0) {
        tmp$_0 = !isBlank(abbreviation);
      }
      if (tmp$_0) {
        tmp$ = abbreviation;
      }
       else {
        tmp$ = this.concept.conceptAbbreviation;
      }
      return tmp$;
    }
  });
  Object.defineProperty(Vaccine.prototype, 'description', {
    get: function () {
      return Help_getInstance().getMapValue_ije21m$(this.descriptions, Language_getInstance().get_8be2vx$());
    }
  });
  function Vaccine$concept$lambda(this$Vaccine) {
    return function () {
      var tmp$;
      var tmp$_0;
      if ((tmp$ = JavelinManager$Companion_getInstance().dm_8be2vx$.getVaccineConcept(this$Vaccine.conceptId)) != null)
        tmp$_0 = tmp$;
      else {
        throw IllegalStateException_init(('Concept ' + this$Vaccine.conceptId + ' not found for Vaccine').toString());
      }
      return tmp$_0;
    };
  }
  Vaccine.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Vaccine',
    interfaces: []
  };
  function Consent(consentId, parentId, parentType, name, date, version) {
    this.consentId = consentId;
    this.parentId = parentId;
    this.parentType = parentType;
    this.name = name;
    this.date = date;
    this.version = version;
  }
  function Consent$Name() {
    Consent$Name_instance = this;
    this.SYNC = 'Sync';
    this.RECORD = 'Record';
  }
  Consent$Name.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Name',
    interfaces: []
  };
  var Consent$Name_instance = null;
  function Consent$Name_getInstance() {
    if (Consent$Name_instance === null) {
      new Consent$Name();
    }
    return Consent$Name_instance;
  }
  Consent.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Consent',
    interfaces: []
  };
  function Consent_init(parentId, parentType, name, date, version, $this) {
    $this = $this || Object.create(Consent.prototype);
    Consent.call($this, Help_getInstance().randomId(), parentId, parentType, name, date, version);
    return $this;
  }
  function Consent_init_0(parentId, parentType, date, version, $this) {
    $this = $this || Object.create(Consent.prototype);
    Consent.call($this, Help_getInstance().randomId(), parentId, parentType, parentType, date, version);
    return $this;
  }
  function Consent_init_1(consent, recordId, $this) {
    $this = $this || Object.create(Consent.prototype);
    Consent.call($this, Help_getInstance().randomId(), recordId, Type_getInstance().RECORD, consent.name, consent.date, consent.version);
    return $this;
  }
  function Dose() {
    Dose$Companion_getInstance();
    this.doseId = null;
    this.lastUpdated = null;
    this.recordId = null;
    this.conceptId = null;
    this.generatorId = null;
    this.pageId = null;
    this.scheduleId = null;
    this.date = null;
    this.isReceived = false;
    this.gtin = null;
    this.lotNumber = null;
    this.expiry = null;
    this.comments = null;
    this.recommendedDate = null;
  }
  Object.defineProperty(Dose.prototype, 'displayTerm', {
    get: function () {
      return this.concept().displayTerm;
    }
  });
  Object.defineProperty(Dose.prototype, 'abbreviation', {
    get: function () {
      return this.concept().abbreviation;
    }
  });
  Object.defineProperty(Dose.prototype, 'color', {
    get: function () {
      return this.concept().color;
    }
  });
  Dose.prototype.concept = function () {
    var tmp$;
    var tmp$_0;
    if ((tmp$ = JavelinManager$Companion_getInstance().dm_8be2vx$.getVaccineConcept(this.conceptId)) != null)
      tmp$_0 = tmp$;
    else {
      throw IllegalStateException_init(('Concept ' + this.conceptId + ' not found for Dose').toString());
    }
    return tmp$_0;
  };
  Dose.prototype.schedule = function () {
    var tmp$;
    tmp$ = this.scheduleId;
    if (tmp$ == null) {
      return null;
    }
    var scheduleId = tmp$;
    return JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(Schedule), (new QueryBuilder(Type_getInstance().SCHEDULE)).where_puj7f4$('scheduleId', scheduleId));
  };
  Dose.prototype.collection = function () {
    return JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(GeneratorCollection), (new QueryBuilder(Type_getInstance().COLLECTION)).where_puj7f4$('collectionId', this.pageId));
  };
  Dose.prototype.generator = function () {
    var tmp$;
    tmp$ = this.generatorId;
    if (tmp$ == null) {
      return null;
    }
    var generatorId = tmp$;
    return JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(DoseGenerator), (new QueryBuilder(Type_getInstance().GENERATOR)).where_puj7f4$('generatorId', generatorId));
  };
  Object.defineProperty(Dose.prototype, 'overallDate', {
    get: function () {
      var tmp$, tmp$_0;
      var tmp$_1;
      if ((tmp$_0 = (tmp$ = this.date) != null ? tmp$ : this.recommendedDate) != null)
        tmp$_1 = tmp$_0;
      else {
        throw IllegalStateException_init('Null date & recommended date for Dose'.toString());
      }
      return tmp$_1;
    }
  });
  Dose.prototype.isUserIgnored = function (record) {
    return record.isDoseIgnored_7efafy$(this.generatedId);
  };
  Dose.prototype.isIgnored = function (record) {
    return this.scheduleId != null && (this.isGeneratorIgnored(record) || this.isUserIgnored(record));
  };
  Object.defineProperty(Dose.prototype, 'overallComments', {
    get: function () {
      var tmp$, tmp$_0;
      var $receiver = this.comments;
      if ($receiver == null || $receiver.length === 0) {
        tmp$_0 = (tmp$ = JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(Record), (new QueryBuilder(Type_getInstance().RECORD)).where_puj7f4$('recordId', this.recordId))) != null ? tmp$.getDoseComment_7efafy$(this.generatedId) : null;
      }
       else {
        tmp$_0 = this.comments;
      }
      return tmp$_0;
    }
  });
  var trim = Kotlin.kotlin.text.trim_gw00vp$;
  Dose.prototype.getDescription = function (record) {
    var description = '';
    var generator = this.generator();
    var collection = this.collection();
    var schedule = this.schedule();
    if (generator == null || collection == null)
      return description;
    if (schedule != null && !equals(this.scheduleId, record.scheduleId)) {
      description = Str_getInstance().get_ge7pzc$(Id_getInstance().dose_other_province, [JavelinManager$Companion_getInstance().dm_8be2vx$.getRegionName(schedule.region), collection.name]) + '\n';
    }
    var $receiver = generator.description;
    if (!($receiver == null || $receiver.length === 0)) {
      description += generator.description;
    }
    var $receiver_0 = description;
    var tmp$;
    return trim(Kotlin.isCharSequence(tmp$ = $receiver_0) ? tmp$ : throwCCE()).toString();
  };
  Dose.prototype.save = function (record, page, date, isScheduled, isReceived, concept, gtin, lotNumber, expiry, comments, isIgnored) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    var localIgnored = isIgnored;
    if (isReceived) {
      localIgnored = false;
    }
    var conceptId = concept.conceptId;
    if (localIgnored) {
      if (record.addIgnoredDose_yhrpff$(this)) {
        record.saveFieldChanges(listOf(10));
      }
    }
     else {
      record.removeIgnoredDose_yhrpff$(this);
    }
    var tmp$_3;
    if (comments != null) {
      var tmp$_4;
      tmp$_3 = trim(Kotlin.isCharSequence(tmp$_4 = comments) ? tmp$_4 : throwCCE()).toString();
    }
     else
      tmp$_3 = null;
    var commentsLocal = tmp$_3;
    var tmp$_5;
    if (gtin != null) {
      var tmp$_6;
      tmp$_5 = trim(Kotlin.isCharSequence(tmp$_6 = gtin) ? tmp$_6 : throwCCE()).toString();
    }
     else
      tmp$_5 = null;
    var gtinLocal = tmp$_5;
    var tmp$_7;
    if (lotNumber != null) {
      var tmp$_8;
      tmp$_7 = trim(Kotlin.isCharSequence(tmp$_8 = lotNumber) ? tmp$_8 : throwCCE()).toString();
    }
     else
      tmp$_7 = null;
    var lotNumberLocal = tmp$_7;
    var expiryLocal = expiry;
    var existed = JavelinManager$Companion_getInstance().dm_8be2vx$.exists(getKClass(Dose), (new QueryBuilder(Type_getInstance().DOSE)).where_puj7f4$('doseId', this.doseId));
    if (!isScheduled) {
      this.date = null;
      this.isReceived = false;
      var conceptLocal = this.concept().parentConcept;
      this.conceptId = conceptLocal.conceptId;
      this.gtin = null;
      this.expiry = null;
      this.lotNumber = null;
      this.comments = null;
      record.addDoseComment_6q4ff3$(this.generatedId, commentsLocal);
      if (existed) {
        record.removeDose_yhrpff$(this);
      }
       else {
        JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().UI_UPDATE, this.recordId);
      }
      return null;
    }
    var error = (tmp$_1 = (tmp$_0 = (tmp$ = this.validateDateAndReceived_0(record, date, isReceived)) != null ? tmp$ : this.validateGTIN_0(gtinLocal)) != null ? tmp$_0 : this.validateLotNumber_0(lotNumberLocal)) != null ? tmp$_1 : this.validateComments_0(commentsLocal);
    if (error != null) {
      return error;
    }
    if (!Kotlin.isType(concept, TradeNameConcept)) {
      gtinLocal = null;
      expiryLocal = null;
      lotNumberLocal = null;
    }
    var fieldChanges = ArrayList_init_0();
    if (Help_getInstance().isFieldChanged_kmul3d$(this.date, date, 1, fieldChanges)) {
      this.date = date;
    }
    if (Help_getInstance().isFieldChanged_kmul3d$(this.isReceived, isReceived, 2, fieldChanges)) {
      this.isReceived = isReceived;
    }
    if (Help_getInstance().isFieldChanged_kmul3d$(this.conceptId, conceptId, 0, fieldChanges)) {
      this.conceptId = concept.conceptId;
    }
    if (Help_getInstance().isFieldChanged_kmul3d$(this.gtin, gtinLocal, 3, fieldChanges)) {
      this.gtin = gtinLocal;
    }
    if (Help_getInstance().isFieldChanged_kmul3d$(this.lotNumber, lotNumberLocal, 4, fieldChanges)) {
      this.lotNumber = lotNumberLocal;
    }
    if (Help_getInstance().isFieldChanged_kmul3d$(this.expiry, expiryLocal, 5, fieldChanges)) {
      this.expiry = expiryLocal;
    }
    if (Help_getInstance().isFieldChanged_kmul3d$(this.comments, commentsLocal, 6, fieldChanges)) {
      this.comments = commentsLocal;
    }
    if (!existed) {
      if (this.generatorId == null) {
        var tmp$_9;
        if ((tmp$_2 = page != null ? page.doses : null) != null) {
          var firstOrNull$result;
          firstOrNull$break: do {
            var tmp$_10;
            tmp$_10 = tmp$_2.iterator();
            while (tmp$_10.hasNext()) {
              var element = tmp$_10.next();
              if (!element.isScheduled && equals(element.concept().parentConceptId, this.concept().parentConceptId)) {
                firstOrNull$result = element;
                break firstOrNull$break;
              }
            }
            firstOrNull$result = null;
          }
           while (false);
          tmp$_9 = firstOrNull$result;
        }
         else
          tmp$_9 = null;
        var dose = tmp$_9;
        if (dose != null) {
          this.scheduleId = dose.scheduleId;
          this.generatorId = dose.generatorId;
        }
      }
      record.removeDoseComment_7efafy$(this.generatedId);
      record.addDose_yhrpff$(this);
    }
     else {
      JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().UPDATE, this, fieldChanges);
    }
    return null;
  };
  Dose.prototype.receive = function (record, page, date) {
    return this.save(record, page, date, true, true, this.concept(), this.gtin, this.lotNumber, this.expiry, this.comments, false);
  };
  Dose.prototype.unreceive = function (record) {
    return this.save(record, null, this.date, true, false, this.concept(), this.gtin, this.lotNumber, this.expiry, this.comments, false);
  };
  Dose.prototype.ignore = function (record) {
    return this.save(record, null, this.date, this.date != null, this.isReceived, this.concept(), this.gtin, this.lotNumber, this.expiry, this.comments, true);
  };
  Object.defineProperty(Dose.prototype, 'generatedId', {
    get: function () {
      var tmp$;
      tmp$ = this.generator();
      if (tmp$ == null) {
        return null;
      }
      var generator = tmp$;
      var id = this.generatorId;
      if (this.recommendedDate != null && generator.isRecurring) {
        var tmp$_0;
        id = id + toString((tmp$_0 = this.recommendedDate) != null ? tmp$_0.string : null);
      }
      return id;
    }
  });
  Object.defineProperty(Dose.prototype, 'isScheduled', {
    get: function () {
      return JavelinManager$Companion_getInstance().dm_8be2vx$.exists(getKClass(Dose), (new QueryBuilder(Type_getInstance().DOSE)).where_puj7f4$('doseId', this.doseId));
    }
  });
  Dose.prototype.isMaxAgePast = function (record) {
    var tmp$, tmp$_0, tmp$_1;
    var generator = this.generator();
    if (generator != null) {
      var rule = generator.getRule_kcn2v3$(4);
      if (rule != null) {
        var tmp$_2;
        if ((tmp$_1 = (tmp$_0 = (tmp$ = rule.getValue_lmshww$(getKClass(DateModifier))) != null ? tmp$.apply(record.birthdate) : null) != null ? tmp$_0.isPast : null) != null)
          tmp$_2 = tmp$_1;
        else {
          throw IllegalStateException_init('Date on the IgnoreIfAge rule was null'.toString());
        }
        return tmp$_2;
      }
    }
    return false;
  };
  Dose.prototype.isGeneratorIgnored = function (record) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3;
    tmp$ = this.generator();
    if (tmp$ == null) {
      return false;
    }
    var generator = tmp$;
    if (this.isMaxAgePast(record))
      return true;
    var generatorRule = generator.getRule_kcn2v3$(2);
    if (generatorRule != null && record.hasGeneratorDoses(generatorRule.getValue_lmshww$(PrimitiveClasses$stringClass))) {
      return true;
    }
    var beforeBirthdate = (tmp$_1 = (tmp$_0 = generator.getRule_kcn2v3$(10)) != null ? tmp$_0.getValue_lmshww$(getKClass(DateModifier)) : null) != null ? tmp$_1.toLocalDate_8be2vx$() : null;
    if (beforeBirthdate != null && record.birthdate.isBefore(beforeBirthdate)) {
      return true;
    }
    var afterBirthdate = (tmp$_3 = (tmp$_2 = generator.getRule_kcn2v3$(12)) != null ? tmp$_2.getValue_lmshww$(getKClass(DateModifier)) : null) != null ? tmp$_3.toLocalDate_8be2vx$() : null;
    if (afterBirthdate != null && record.birthdate.isAfter(afterBirthdate)) {
      return true;
    }
    return false;
  };
  Dose.prototype.isIgnorable = function (record, received) {
    if (received === void 0)
      received = this.isReceived;
    return !received && this.generatorId != null && !this.isGeneratorIgnored(record);
  };
  Dose.prototype.validateDateAndReceived_0 = function (record, date, isReceived) {
    if (date == null) {
      return Error$Companion_getInstance().id(Id_getInstance().dose_error_date_missing);
    }
    if (isReceived && date.isFuture) {
      return Error$Companion_getInstance().id(Id_getInstance().dose_error_future_date_on_receive);
    }
    if (date.isBefore(record.birthdate)) {
      return Error$Companion_getInstance().string(Str_getInstance().get_ge7pzc$(Id_getInstance().dose_error_before_birthdate, [record.firstName]));
    }
    return null;
  };
  Dose.prototype.validateGTIN_0 = function (gtin) {
    if (Validation_getInstance().isOverMaxLength_9g2trk$(gtin, 50)) {
      return Error$Companion_getInstance().string(Str_getInstance().get_ge7pzc$(Id_getInstance().error_gtin_length, [toString(gtin != null ? gtin.length : null)]));
    }
    return null;
  };
  Dose.prototype.validateLotNumber_0 = function (lotNumber) {
    if (Validation_getInstance().isOverMaxLength_9g2trk$(lotNumber, 50)) {
      return Error$Companion_getInstance().string(Str_getInstance().get_ge7pzc$(Id_getInstance().error_lot_length, [toString(lotNumber != null ? lotNumber.length : null)]));
    }
    return null;
  };
  Dose.prototype.validateComments_0 = function (comments) {
    if (Validation_getInstance().isOverMaxLength_9g2trk$(comments, 2048)) {
      return Error$Companion_getInstance().string(Str_getInstance().get_ge7pzc$(Id_getInstance().error_dose_comments_length, [toString(comments != null ? comments.length : null)]));
    }
    return null;
  };
  Dose.prototype.equals = function (other) {
    return Kotlin.isType(other, Dose) && equals(this.doseId, other.doseId);
  };
  function Dose$Companion() {
    Dose$Companion_instance = this;
    this.MAX_GTIN = 50;
    this.MAX_LOT = 50;
    this.MAX_COMMENTS = 2048;
  }
  Dose$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var Dose$Companion_instance = null;
  function Dose$Companion_getInstance() {
    if (Dose$Companion_instance === null) {
      new Dose$Companion();
    }
    return Dose$Companion_instance;
  }
  Dose.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Dose',
    interfaces: []
  };
  function Dose_init(doseId, lastUpdated, recordId, conceptId, generatorId, pageId, scheduleId, date, isReceived, gtin, lotNumber, expiry, comments, $this) {
    $this = $this || Object.create(Dose.prototype);
    Dose.call($this);
    $this.lastUpdated = lastUpdated;
    $this.doseId = doseId;
    $this.recordId = recordId;
    $this.conceptId = conceptId;
    $this.generatorId = generatorId;
    $this.pageId = pageId;
    $this.scheduleId = scheduleId;
    $this.date = date;
    $this.isReceived = isReceived;
    $this.gtin = gtin;
    $this.lotNumber = lotNumber;
    $this.expiry = expiry;
    $this.comments = comments;
    return $this;
  }
  function Dose_init_0(recordId, pageId, concept, generatorId, scheduleId, $this) {
    if (generatorId === void 0)
      generatorId = null;
    if (scheduleId === void 0)
      scheduleId = null;
    $this = $this || Object.create(Dose.prototype);
    Dose_init(Help_getInstance().randomId(), null, recordId, concept.conceptId, generatorId, pageId, scheduleId, Date_getInstance().now_8be2vx$(), false, null, null, null, null, $this);
    return $this;
  }
  function Dose_init_1(record, concept, generatorId, pageId, scheduleId, recommendedDate, $this) {
    $this = $this || Object.create(Dose.prototype);
    Dose_init_0(record.recordId, pageId, concept, generatorId, scheduleId, $this);
    $this.date = null;
    $this.recommendedDate = recommendedDate;
    return $this;
  }
  function Dose_init_2(dose, recordId, $this) {
    $this = $this || Object.create(Dose.prototype);
    Dose_init(Help_getInstance().randomId(), null, recordId, dose.conceptId, dose.generatorId, dose.pageId, dose.scheduleId, dose.date, dose.isReceived, dose.gtin, dose.lotNumber, dose.expiry, dose.comments, $this);
    return $this;
  }
  function Field() {
    Field_instance = this;
    this.FIRST_NAME = 0;
    this.LAST_NAME = 1;
    this.GENDER = 2;
    this.BIRTHDATE = 3;
    this.REGION = 4;
    this.SCHEDULE = 5;
    this.DOCTOR = 6;
    this.CITY = 7;
    this.RELATIONSHIP = 8;
    this.NOTES = 9;
    this.IGNORED_GENERATORS = 10;
    this.DOSE_COMMENTS = 11;
    this.CONCEPT = 0;
    this.DATE = 1;
    this.RECEIVED = 2;
    this.GTIN = 3;
    this.LOT_NUMBER = 4;
    this.EXPIRY = 5;
    this.COMMENTS = 6;
    this.NAME = 0;
    this.MFA_ENABLED = 1;
    this.PUSH_ENABLED = 2;
    this.CONSENT = 4;
  }
  Field.prototype.getRecordField_ine9n2$ = function (record, field) {
    switch (field) {
      case 0:
        return record.firstName;
      case 1:
        return record.lastName;
      case 2:
        return record.gender.toString();
      case 3:
        return record.birthdate.toJson();
      case 4:
        return record.region;
      case 5:
        return record.scheduleId;
      case 8:
        return record.relationship.toString();
      case 6:
        return record.doctor;
      case 7:
        return record.cityId;
      case 9:
        return record.notes;
      case 10:
        return Json_getInstance().to_8ea4ql$(record.ignoredGenerators);
      case 11:
        return Json_getInstance().to_8ea4ql$(record.doseComments);
      default:throw AssertionError_init('Unknown record field: ' + field);
    }
  };
  Field.prototype.getDoseField_oqmg62$ = function (dose, field) {
    var tmp$, tmp$_0;
    switch (field) {
      case 0:
        return dose.conceptId;
      case 1:
        return (tmp$ = dose.date) != null ? tmp$.toJson() : null;
      case 2:
        return dose.isReceived.toString();
      case 3:
        return dose.gtin;
      case 4:
        return dose.lotNumber;
      case 5:
        return (tmp$_0 = dose.expiry) != null ? tmp$_0.toJson() : null;
      case 6:
        return dose.comments;
      default:throw AssertionError_init('Unknown dose field: ' + field);
    }
  };
  Field.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Field',
    interfaces: []
  };
  var Field_instance = null;
  function Field_getInstance() {
    if (Field_instance === null) {
      new Field();
    }
    return Field_instance;
  }
  function Record() {
    Record$Companion_getInstance();
    this.recordId = null;
    this.lastUpdated = null;
    this.lastSyncTimestamp = null;
    this.firstName_paojkh$_0 = null;
    this.lastName_hwcrnr$_0 = null;
    this.gender_xzle6f$_0 = 2;
    this.birthdate_neh7i9$_0 = null;
    this.region_hr4t70$_0 = null;
    this.scheduleId_pij846$_0 = null;
    this.relationship_5htzbk$_0 = -1;
    this.doctor_5gwjvb$_0 = null;
    this.cityId_mq5ny6$_0 = null;
    this.notes_riflhx$_0 = null;
    this.consents = null;
    this.doses_w8wgfe$_0 = null;
    this.integrations = null;
    this.ignoredGenerators = null;
    this.doseComments = null;
    this.initialized_0 = false;
    this.isIgnoredPagesHidden_y9ew8y$_0 = false;
    this.fullName_rwcx4e$_0 = '';
    this.ageInMonths_ofsi7f$_0 = 0;
    this.isChild_hxj16i$_0 = true;
    this.consentDate_xms144$_0 = null;
  }
  Object.defineProperty(Record.prototype, 'firstName', {
    get: function () {
      return this.firstName_paojkh$_0;
    },
    set: function (firstName) {
      this.firstName_paojkh$_0 = firstName;
    }
  });
  Object.defineProperty(Record.prototype, 'lastName', {
    get: function () {
      return this.lastName_hwcrnr$_0;
    },
    set: function (lastName) {
      this.lastName_hwcrnr$_0 = lastName;
    }
  });
  Object.defineProperty(Record.prototype, 'gender', {
    get: function () {
      return this.gender_xzle6f$_0;
    },
    set: function (gender) {
      this.gender_xzle6f$_0 = gender;
    }
  });
  Object.defineProperty(Record.prototype, 'birthdate', {
    get: function () {
      return this.birthdate_neh7i9$_0;
    },
    set: function (birthdate) {
      this.birthdate_neh7i9$_0 = birthdate;
    }
  });
  Object.defineProperty(Record.prototype, 'region', {
    get: function () {
      return this.region_hr4t70$_0;
    },
    set: function (region) {
      this.region_hr4t70$_0 = region;
    }
  });
  Object.defineProperty(Record.prototype, 'scheduleId', {
    get: function () {
      return this.scheduleId_pij846$_0;
    },
    set: function (scheduleId) {
      this.scheduleId_pij846$_0 = scheduleId;
    }
  });
  Object.defineProperty(Record.prototype, 'relationship', {
    get: function () {
      return this.relationship_5htzbk$_0;
    },
    set: function (relationship) {
      this.relationship_5htzbk$_0 = relationship;
    }
  });
  Object.defineProperty(Record.prototype, 'doctor', {
    get: function () {
      return this.doctor_5gwjvb$_0;
    },
    set: function (doctor) {
      this.doctor_5gwjvb$_0 = doctor;
    }
  });
  Object.defineProperty(Record.prototype, 'cityId', {
    get: function () {
      return this.cityId_mq5ny6$_0;
    },
    set: function (cityId) {
      this.cityId_mq5ny6$_0 = cityId;
    }
  });
  Object.defineProperty(Record.prototype, 'notes', {
    get: function () {
      return this.notes_riflhx$_0;
    },
    set: function (notes) {
      this.notes_riflhx$_0 = notes;
    }
  });
  function Record$get_Record$doses$lambda(o1, o2) {
    var date1 = o1.date;
    var date2 = o2.date;
    if (date1 == null && date2 == null)
      return 0;
    else if (date1 == null)
      return 1;
    else if (date2 == null)
      return -1;
    else
      return date2.compareTo(date1);
  }
  function Comparator$ObjectLiteral_5(closure$comparison) {
    this.closure$comparison = closure$comparison;
  }
  Comparator$ObjectLiteral_5.prototype.compare = function (a, b) {
    return this.closure$comparison(a, b);
  };
  Comparator$ObjectLiteral_5.$metadata$ = {kind: Kind_CLASS, interfaces: [Comparator]};
  Object.defineProperty(Record.prototype, 'doses', {
    get: function () {
      sortWith(this.doses_w8wgfe$_0, new Comparator$ObjectLiteral_5(Record$get_Record$doses$lambda));
      return this.doses_w8wgfe$_0;
    },
    set: function (doses) {
      this.doses_w8wgfe$_0 = doses;
    }
  });
  Object.defineProperty(Record.prototype, 'isIgnoredPagesHidden', {
    get: function () {
      return this.isIgnoredPagesHidden_y9ew8y$_0;
    },
    set: function (value) {
      if (this.isIgnoredPagesHidden_y9ew8y$_0 === value)
        return;
      this.isIgnoredPagesHidden_y9ew8y$_0 = value;
      if (!this.initialized_0)
        return;
      JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(Action_getInstance().UPDATE, this);
      JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(Action_getInstance().UI_UPDATE, this.recordId);
    }
  });
  Record.prototype.schedule = function () {
    var tmp$;
    tmp$ = this.scheduleId;
    if (tmp$ == null) {
      return null;
    }
    var scheduleId = tmp$;
    return JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(Schedule), (new QueryBuilder(Type_getInstance().SCHEDULE)).where_puj7f4$('scheduleId', scheduleId));
  };
  Record.prototype.city = function () {
    var tmp$;
    tmp$ = this.cityId;
    if (tmp$ == null) {
      return null;
    }
    var cityId = tmp$;
    return JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(City), (new QueryBuilder(Type_getInstance().CITY)).where_puj7f4$('cityId', cityId));
  };
  Record.prototype.addDose_yhrpff$ = function (dose) {
    this.doses.add_11rb$(dose);
    JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().CREATE, dose);
  };
  Record.prototype.removeDose_yhrpff$ = function (dose) {
    this.doses.remove_11rb$(dose);
    JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().DELETE, dose);
  };
  Record.prototype.addIntegration_8t4x4e$ = function (integration) {
    this.integrations.add_11rb$(integration);
    JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().CREATE, integration);
    JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().UI_UPDATE, this.recordId);
  };
  Record.prototype.removeIntegration_8t4x4e$ = function (integration) {
    this.integrations.remove_11rb$(integration);
    JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().DELETE, integration);
    JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().UI_UPDATE, this.recordId);
  };
  Record.prototype.getDoseComment_7efafy$ = function (doseId) {
    return doseId == null ? null : this.doseComments.get_11rb$(doseId);
  };
  Record.prototype.getPHUIntegration = function (phuId) {
    var tmp$, tmp$_0, tmp$_1;
    var $receiver = this.integrations;
    var firstOrNull$result;
    firstOrNull$break: do {
      var tmp$_2;
      tmp$_2 = $receiver.iterator();
      while (tmp$_2.hasNext()) {
        var element = tmp$_2.next();
        if (Kotlin.isType(element, PHUIntegration) && equals(element.phuId, phuId)) {
          firstOrNull$result = element;
          break firstOrNull$break;
        }
      }
      firstOrNull$result = null;
    }
     while (false);
    return (tmp$_1 = (tmp$ = firstOrNull$result) == null || Kotlin.isType(tmp$, PHUIntegration) ? tmp$ : throwCCE()) != null ? tmp$_1 : Kotlin.isType(tmp$_0 = Integration$Companion_getInstance().newIntegration_iwx8jd$(Type_getInstance().PHU_INTEGRATION, this, phuId), PHUIntegration) ? tmp$_0 : throwCCE();
  };
  Record.prototype.isDoseIgnored_7efafy$ = function (generatedId) {
    return generatedId != null && this.ignoredGenerators.contains_11rb$(generatedId);
  };
  function Record$setFirstName$lambda(closure$firstName, this$Record) {
    return function () {
      var tmp$ = this$Record;
      var $receiver = ensureNotNull(closure$firstName);
      var tmp$_0;
      tmp$.firstName = trim(Kotlin.isCharSequence(tmp$_0 = $receiver) ? tmp$_0 : throwCCE()).toString();
      return Unit;
    };
  }
  Record.prototype.setFirstName = function (firstName) {
    var result = this.validateNullableField_0(getCallableRef('validateFirstName', function ($receiver, firstName) {
      return $receiver.validateFirstName(firstName);
    }.bind(null, this)), 0, firstName, this.firstName);
    return this.saveField_0(result, Record$setFirstName$lambda(firstName, this));
  };
  function Record$setLastName$lambda(closure$lastName, this$Record) {
    return function () {
      var tmp$;
      var tmp$_0 = this$Record;
      var tmp$_1;
      if (closure$lastName != null) {
        var $receiver = closure$lastName;
        var tmp$_2;
        tmp$_1 = trim(Kotlin.isCharSequence(tmp$_2 = $receiver) ? tmp$_2 : throwCCE()).toString();
      }
       else
        tmp$_1 = null;
      tmp$_0.lastName = (tmp$ = tmp$_1) != null ? tmp$ : '';
      return Unit;
    };
  }
  Record.prototype.setLastName = function (lastName) {
    var result = this.validateNullableField_0(getCallableRef('validateLastName', function ($receiver, lastName) {
      return $receiver.validateLastName(lastName);
    }.bind(null, this)), 1, lastName, this.lastName);
    return this.saveField_0(result, Record$setLastName$lambda(lastName, this));
  };
  function Record$setGender$lambda(closure$gender, this$Record) {
    return function () {
      this$Record.gender = closure$gender;
      return Unit;
    };
  }
  Record.prototype.setGender = function (gender) {
    var result = this.validateField_0(getCallableRef('validateGender', function ($receiver, gender) {
      return $receiver.validateGender(gender);
    }.bind(null, this)), 2, gender, this.gender);
    return this.saveField_0(result, Record$setGender$lambda(gender, this));
  };
  function Record$setBirthdate$lambda(closure$birthdate, this$Record) {
    return function () {
      this$Record.birthdate = ensureNotNull(closure$birthdate);
      return Unit;
    };
  }
  Record.prototype.setBirthdate = function (birthdate) {
    var result = this.validateNullableField_0(getCallableRef('validateBirthdate', function ($receiver, birthdate) {
      return $receiver.validateBirthdate(birthdate);
    }.bind(null, this)), 3, birthdate, this.birthdate);
    return this.saveField_0(result, Record$setBirthdate$lambda(birthdate, this));
  };
  function Record$setDoctor$lambda(closure$doctor, this$Record) {
    return function () {
      var tmp$;
      var tmp$_0 = this$Record;
      var tmp$_1;
      if (closure$doctor != null) {
        var $receiver = closure$doctor;
        var tmp$_2;
        tmp$_1 = trim(Kotlin.isCharSequence(tmp$_2 = $receiver) ? tmp$_2 : throwCCE()).toString();
      }
       else
        tmp$_1 = null;
      tmp$_0.doctor = (tmp$ = tmp$_1) != null ? tmp$ : '';
      return Unit;
    };
  }
  Record.prototype.setDoctor = function (doctor) {
    var result = this.validateNullableField_0(getCallableRef('validateDoctor', function ($receiver, doctor) {
      return $receiver.validateDoctor(doctor);
    }.bind(null, this)), 6, doctor, this.doctor);
    return this.saveField_0(result, Record$setDoctor$lambda(doctor, this));
  };
  function Record$setCity$lambda(closure$cityId, this$Record) {
    return function () {
      this$Record.cityId = closure$cityId;
      return Unit;
    };
  }
  Record.prototype.setCity = function (cityId) {
    var result = this.validateNullableField_0(getCallableRef('validateCity', function ($receiver, cityId) {
      return $receiver.validateCity(cityId);
    }.bind(null, this)), 7, cityId, this.cityId);
    return this.saveField_0(result, Record$setCity$lambda(cityId, this));
  };
  function Record$setNotes$lambda(closure$notes, this$Record) {
    return function () {
      var tmp$;
      var tmp$_0 = this$Record;
      var tmp$_1;
      if (closure$notes != null) {
        var $receiver = closure$notes;
        var tmp$_2;
        tmp$_1 = trim(Kotlin.isCharSequence(tmp$_2 = $receiver) ? tmp$_2 : throwCCE()).toString();
      }
       else
        tmp$_1 = null;
      tmp$_0.notes = (tmp$ = tmp$_1) != null ? tmp$ : '';
      return Unit;
    };
  }
  Record.prototype.setNotes = function (notes) {
    var result = this.validateNullableField_0(getCallableRef('validateNotes', function ($receiver, notes) {
      return $receiver.validateNotes(notes);
    }.bind(null, this)), 9, notes, this.notes);
    return this.saveField_0(result, Record$setNotes$lambda(notes, this));
  };
  function Record$setRegionAndSchedule$lambda(closure$region, this$Record) {
    return function () {
      this$Record.region = closure$region;
      return Unit;
    };
  }
  function Record$setRegionAndSchedule$lambda_0(closure$scheduleId, this$Record) {
    return function () {
      this$Record.scheduleId = closure$scheduleId;
      return Unit;
    };
  }
  Record.prototype.setRegionAndSchedule = function (region, scheduleId) {
    var regionResult = this.validateNullableField_0(getCallableRef('validateRegion', function ($receiver, region) {
      return $receiver.validateRegion(region);
    }.bind(null, this)), 4, region, this.region);
    if (regionResult.first != null) {
      return regionResult.first;
    }
    var scheduleResult = this.validateNullableField_0(getCallableRef('validateSchedule', function ($receiver, scheduleId) {
      return $receiver.validateSchedule(scheduleId);
    }.bind(null, this)), 5, scheduleId, this.scheduleId);
    if (scheduleResult.first != null) {
      return scheduleResult.first;
    }
    this.saveField_0(regionResult, Record$setRegionAndSchedule$lambda(region, this));
    this.saveField_0(scheduleResult, Record$setRegionAndSchedule$lambda_0(scheduleId, this));
    return null;
  };
  function Record$setRelationshipAndConsent$lambda(closure$relationship, this$Record) {
    return function () {
      this$Record.relationship = closure$relationship;
      return Unit;
    };
  }
  Record.prototype.setRelationshipAndConsent = function (relationship, consentDate) {
    var relationshipResult = this.validateField_0(getCallableRef('validateRelationship', function ($receiver, relationship) {
      return $receiver.validateRelationship(relationship);
    }.bind(null, this)), 8, relationship, this.relationship);
    if (relationshipResult.first != null) {
      return relationshipResult.first;
    }
    var result = this.setConsent_0(consentDate, false);
    if (result.first != null) {
      return result.first;
    }
    this.saveField_0(relationshipResult, Record$setRelationshipAndConsent$lambda(relationship, this));
    if (relationshipResult.second == null) {
      this.saveFieldChanges(emptyList());
    }
    return null;
  };
  Record.prototype.setConsent_0 = function (consentDate, isNew, birthdate, relationship) {
    if (birthdate === void 0)
      birthdate = this.birthdate;
    if (relationship === void 0)
      relationship = this.relationship;
    var error = this.validateConsent(birthdate, relationship, consentDate);
    if (error != null) {
      return new Pair(error, false);
    }
    if (isNew && consentDate != null) {
      this.consents.add_11rb$(Consent_init(this.recordId, Type_getInstance().RECORD, Consent$Name_getInstance().RECORD, consentDate, 1));
    }
     else if (!isNew) {
      var consentUpdate = false;
      var consent = this.getConsent_0(Consent$Name_getInstance().RECORD);
      if (consentDate == null && consent != null) {
        this.consents.remove_11rb$(consent);
        JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().DELETE, consent);
        consentUpdate = true;
      }
       else if (consentDate != null && consent == null) {
        consent = Consent_init(this.recordId, Type_getInstance().RECORD, Consent$Name_getInstance().RECORD, consentDate, 1);
        this.consents.add_11rb$(consent);
        JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().CREATE, consent);
        consentUpdate = true;
      }
      return new Pair(null, consentUpdate);
    }
    return new Pair(null, false);
  };
  Record.prototype.saveRecord = function (firstName, lastName, gender, birthdate, region, scheduleId, relationship, doctor, cityId, notes, consentDate, isNew) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4, tmp$_5, tmp$_6, tmp$_7;
    var fieldChanges = ArrayList_init_0();
    var error = (tmp$_7 = (tmp$_6 = (tmp$_5 = (tmp$_4 = (tmp$_3 = (tmp$_2 = (tmp$_1 = (tmp$_0 = (tmp$ = this.addChangedField_0(this.validateNullableField_0(getCallableRef('validateFirstName', function ($receiver, firstName) {
      return $receiver.validateFirstName(firstName);
    }.bind(null, this)), 0, firstName, this.firstName), fieldChanges)) != null ? tmp$ : this.addChangedField_0(this.validateNullableField_0(getCallableRef('validateLastName', function ($receiver, lastName) {
      return $receiver.validateLastName(lastName);
    }.bind(null, this)), 1, lastName, this.lastName), fieldChanges)) != null ? tmp$_0 : this.addChangedField_0(this.validateField_0(getCallableRef('validateGender', function ($receiver, gender) {
      return $receiver.validateGender(gender);
    }.bind(null, this)), 2, gender, this.gender), fieldChanges)) != null ? tmp$_1 : this.addChangedField_0(this.validateNullableField_0(getCallableRef('validateBirthdate', function ($receiver, birthdate) {
      return $receiver.validateBirthdate(birthdate);
    }.bind(null, this)), 3, birthdate, this.birthdate), fieldChanges)) != null ? tmp$_2 : this.addChangedField_0(this.validateNullableField_0(getCallableRef('validateRegion', function ($receiver, region) {
      return $receiver.validateRegion(region);
    }.bind(null, this)), 4, region, this.region), fieldChanges)) != null ? tmp$_3 : this.addChangedField_0(this.validateNullableField_0(getCallableRef('validateSchedule', function ($receiver, scheduleId) {
      return $receiver.validateSchedule(scheduleId);
    }.bind(null, this)), 5, scheduleId, this.scheduleId), fieldChanges)) != null ? tmp$_4 : this.addChangedField_0(this.validateField_0(getCallableRef('validateRelationship', function ($receiver, relationship) {
      return $receiver.validateRelationship(relationship);
    }.bind(null, this)), 8, relationship, this.relationship), fieldChanges)) != null ? tmp$_5 : this.addChangedField_0(this.validateNullableField_0(getCallableRef('validateDoctor', function ($receiver, doctor) {
      return $receiver.validateDoctor(doctor);
    }.bind(null, this)), 6, doctor, this.doctor), fieldChanges)) != null ? tmp$_6 : this.addChangedField_0(this.validateNullableField_0(getCallableRef('validateCity', function ($receiver, cityId) {
      return $receiver.validateCity(cityId);
    }.bind(null, this)), 7, cityId, this.cityId), fieldChanges)) != null ? tmp$_7 : this.addChangedField_0(this.validateNullableField_0(getCallableRef('validateNotes', function ($receiver, notes) {
      return $receiver.validateNotes(notes);
    }.bind(null, this)), 9, notes, this.notes), fieldChanges);
    var consentUpdate = false;
    if (error == null) {
      var result = this.setConsent_0(consentDate, isNew, birthdate, relationship);
      error = result.first;
      consentUpdate = result.second;
    }
    if (error != null) {
      return error;
    }
    var tmp$_8;
    tmp$_8 = fieldChanges.iterator();
    while (tmp$_8.hasNext()) {
      var element = tmp$_8.next();
      var tmp$_9, tmp$_10, tmp$_11;
      switch (element) {
        case 0:
          var $receiver = ensureNotNull(firstName);
          var tmp$_12;
          this.firstName = trim(Kotlin.isCharSequence(tmp$_12 = $receiver) ? tmp$_12 : throwCCE()).toString();
          break;
        case 1:
          var tmp$_13;
          if (lastName != null) {
            var tmp$_14;
            tmp$_13 = trim(Kotlin.isCharSequence(tmp$_14 = lastName) ? tmp$_14 : throwCCE()).toString();
          }
           else
            tmp$_13 = null;
          this.lastName = (tmp$_9 = tmp$_13) != null ? tmp$_9 : '';
          break;
        case 2:
          this.gender = gender;
          break;
        case 3:
          this.birthdate = ensureNotNull(birthdate);
          break;
        case 4:
          this.region = region;
          break;
        case 5:
          this.scheduleId = scheduleId;
          break;
        case 8:
          this.relationship = relationship;
          break;
        case 6:
          var tmp$_15;
          if (doctor != null) {
            var tmp$_16;
            tmp$_15 = trim(Kotlin.isCharSequence(tmp$_16 = doctor) ? tmp$_16 : throwCCE()).toString();
          }
           else
            tmp$_15 = null;
          this.doctor = (tmp$_10 = tmp$_15) != null ? tmp$_10 : '';
          break;
        case 7:
          this.cityId = cityId;
          break;
        case 9:
          var tmp$_17;
          if (notes != null) {
            var tmp$_18;
            tmp$_17 = trim(Kotlin.isCharSequence(tmp$_18 = notes) ? tmp$_18 : throwCCE()).toString();
          }
           else
            tmp$_17 = null;
          this.notes = (tmp$_11 = tmp$_17) != null ? tmp$_11 : '';
          break;
      }
    }
    if (!isNew) {
      if (!fieldChanges.isEmpty() || consentUpdate) {
        this.saveFieldChanges(fieldChanges);
        JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().UI_UPDATE, this.recordId);
      }
    }
     else {
      JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().CREATE, this);
    }
    return null;
  };
  Record.prototype.addIgnoredDose_yhrpff$ = function (dose) {
    var generatedId = dose.generatedId;
    if (generatedId != null && !this.ignoredGenerators.contains_11rb$(generatedId)) {
      this.ignoredGenerators.add_11rb$(generatedId);
      return true;
    }
    return false;
  };
  Record.prototype.removeIgnoredDose_yhrpff$ = function (dose) {
    var tmp$;
    tmp$ = dose.generatedId;
    if (tmp$ == null) {
      return;
    }
    var generatedId = tmp$;
    if (this.ignoredGenerators.contains_11rb$(generatedId)) {
      this.ignoredGenerators.remove_11rb$(generatedId);
      this.saveFieldChanges(listOf(10));
    }
  };
  Record.prototype.addDoseComment_6q4ff3$ = function (generatedId, comments) {
    if (generatedId == null)
      return;
    if (comments == null || comments.length === 0) {
      this.removeDoseComment_7efafy$(generatedId);
      return;
    }
    if (comments == null) {
      return;
    }
    var doseComments = comments;
    if (!equals(this.doseComments.get_11rb$(generatedId), doseComments)) {
      this.doseComments.put_xwzc9p$(generatedId, doseComments);
      this.saveFieldChanges(listOf(11));
    }
  };
  Record.prototype.removeDoseComment_7efafy$ = function (generatedId) {
    if (generatedId != null) {
      var oldValue = this.doseComments.remove_11rb$(generatedId);
      if (oldValue != null) {
        this.saveFieldChanges(listOf(11));
      }
    }
  };
  Record.prototype.saveFieldChanges = function (fieldChanges) {
    JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().UPDATE, this, fieldChanges);
  };
  Record.prototype.save_0 = function (fieldChange) {
    JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().UPDATE, this, listOf(fieldChange));
  };
  Record.prototype.delete = function (inputtedName) {
    if (!equals_0(this.firstName, inputtedName, true)) {
      return Error$Companion_getInstance().id(Id_getInstance().error_delete_name);
    }
    this.delete_vft4zs$(false);
    return null;
  };
  Record.prototype.delete_vft4zs$ = function (clientOnly) {
    if (clientOnly) {
      JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(Action_getInstance().DELETE, this);
    }
     else {
      JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().DELETE, this);
    }
  };
  Object.defineProperty(Record.prototype, 'fullName', {
    get: function () {
      return this.firstName + ' ' + this.lastName;
    },
    set: function (fullName) {
      this.fullName_rwcx4e$_0 = fullName;
    }
  });
  Object.defineProperty(Record.prototype, 'ageInMonths', {
    get: function () {
      return this.birthdate.dateInMonths();
    },
    set: function (ageInMonths) {
      this.ageInMonths_ofsi7f$_0 = ageInMonths;
    }
  });
  Object.defineProperty(Record.prototype, 'isChild', {
    get: function () {
      return this.ageInMonths < 216;
    },
    set: function (isChild) {
      this.isChild_hxj16i$_0 = isChild;
    }
  });
  Record.prototype.getConsent_0 = function (name) {
    var $receiver = this.consents;
    var firstOrNull$result;
    firstOrNull$break: do {
      var tmp$;
      tmp$ = $receiver.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        if (equals(element.name, name)) {
          firstOrNull$result = element;
          break firstOrNull$break;
        }
      }
      firstOrNull$result = null;
    }
     while (false);
    return firstOrNull$result;
  };
  Object.defineProperty(Record.prototype, 'consentDate', {
    get: function () {
      var tmp$;
      return (tmp$ = this.getConsent_0(Consent$Name_getInstance().RECORD)) != null ? tmp$.date : null;
    },
    set: function (consentDate) {
      this.consentDate_xms144$_0 = consentDate;
    }
  });
  Record.prototype.hasConsent = function () {
    if (!Record$Companion_getInstance().needsConsent(this.relationship, this.birthdate))
      return true;
    return this.getConsent_0(Consent$Name_getInstance().RECORD) != null;
  };
  Record.prototype.copyLocalFields_tjuny1$ = function (record) {
    this.isIgnoredPagesHidden = record.isIgnoredPagesHidden;
  };
  Record.prototype.hasGeneratorDoses = function (generatorId) {
    if (generatorId == null)
      return false;
    var $receiver = this.doses;
    var any$result;
    any$break: do {
      var tmp$;
      if (Kotlin.isType($receiver, Collection) && $receiver.isEmpty()) {
        any$result = false;
        break any$break;
      }
      tmp$ = $receiver.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        if (element.generatorId != null && equals(element.generatorId, generatorId)) {
          any$result = true;
          break any$break;
        }
      }
      any$result = false;
    }
     while (false);
    return any$result;
  };
  Record.prototype.fullClean = function () {
    var record = Record_init_0(this);
    JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(Action_getInstance().DELETE, this);
    var tmp$;
    tmp$ = this.doses.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      record.doses.add_11rb$(Dose_init_2(element, record.recordId));
    }
    var tmp$_0;
    tmp$_0 = this.consents.iterator();
    while (tmp$_0.hasNext()) {
      var element_0 = tmp$_0.next();
      record.consents.add_11rb$(Consent_init_1(element_0, record.recordId));
    }
    JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(Action_getInstance().CREATE, record);
  };
  Record.prototype.validateNullableField_0 = function (validator, field, newValue, oldValue) {
    var error = validator(newValue);
    if (error != null) {
      return new Pair(error, null);
    }
    var changedField = null;
    if (!equals(newValue, oldValue)) {
      changedField = field;
    }
    return new Pair(null, changedField);
  };
  function Record$validateField$lambda(closure$validator, closure$newValue) {
    return function (it) {
      return closure$validator(closure$newValue);
    };
  }
  Record.prototype.validateField_0 = function (validator, field, newValue, oldValue) {
    return this.validateNullableField_0(Record$validateField$lambda(validator, newValue), field, newValue, oldValue);
  };
  Record.prototype.saveField_0 = function (result, setter) {
    var field = result.second;
    if (field != null) {
      setter();
      this.save_0(field);
    }
    return result.first;
  };
  Record.prototype.addChangedField_0 = function (result, fields) {
    var error = result.component1()
    , changedField = result.component2();
    if (error == null && changedField != null) {
      fields.add_11rb$(changedField);
    }
    return error;
  };
  Record.prototype.equals = function (other) {
    return Kotlin.isType(other, Record) && equals(other.recordId, this.recordId);
  };
  Record.prototype.validateFirstName = function (firstName) {
    var tmp$;
    if (firstName != null) {
      var tmp$_0;
      tmp$ = trim(Kotlin.isCharSequence(tmp$_0 = firstName) ? tmp$_0 : throwCCE()).toString();
    }
     else
      tmp$ = null;
    var trimmedFirstName = tmp$;
    if (trimmedFirstName == null || trimmedFirstName.length === 0) {
      return Error$Companion_getInstance().id(Id_getInstance().error_missing_first_name);
    }
     else if (Validation_getInstance().isOverMaxLength_9g2trk$(trimmedFirstName, 150)) {
      return Error$Companion_getInstance().string(Str_getInstance().get_ge7pzc$(Id_getInstance().error_first_name_length, [toString(trimmedFirstName != null ? trimmedFirstName.length : null)]));
    }
    return null;
  };
  Record.prototype.validateLastName = function (lastName) {
    var tmp$;
    var tmp$_0;
    if (lastName != null) {
      var tmp$_1;
      tmp$_0 = trim(Kotlin.isCharSequence(tmp$_1 = lastName) ? tmp$_1 : throwCCE()).toString();
    }
     else
      tmp$_0 = null;
    var trimmedLastName = (tmp$ = tmp$_0) != null ? tmp$ : '';
    if (Validation_getInstance().isOverMaxLength_9g2trk$(trimmedLastName, 150)) {
      return Error$Companion_getInstance().string(Str_getInstance().get_ge7pzc$(Id_getInstance().error_last_name_length, [trimmedLastName.length.toString()]));
    }
    var tmp$_2;
    tmp$_2 = this.integrations.iterator();
    while (tmp$_2.hasNext()) {
      var element = tmp$_2.next();
      var result = element.validateLastName_8kj6y5$(true, trimmedLastName);
      if (result != null) {
        return result;
      }
    }
    return null;
  };
  Record.prototype.validateGender = function (gender) {
    if (gender !== 0 && gender !== 1) {
      return Error$Companion_getInstance().id(Id_getInstance().error_missing_sex);
    }
    return null;
  };
  Record.prototype.validateBirthdate = function (birthdate) {
    if (birthdate == null) {
      return Error$Companion_getInstance().id(Id_getInstance().error_date_missing);
    }
    if (birthdate.isFuture) {
      return Error$Companion_getInstance().id(Id_getInstance().error_date_future);
    }
    var $receiver = this.doses;
    var destination = ArrayList_init_0();
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      var date = element.date;
      if (date != null && birthdate.isAfter(date))
        destination.add_11rb$(element);
    }
    var tmp$_0;
    tmp$_0 = destination.iterator();
    while (tmp$_0.hasNext()) {
      var element_0 = tmp$_0.next();
      return Error$Companion_getInstance().id(Id_getInstance().error_date_before_dose);
    }
    var tmp$_1;
    tmp$_1 = this.integrations.iterator();
    while (tmp$_1.hasNext()) {
      var element_1 = tmp$_1.next();
      var result = element_1.validateBirthdate_mhd02g$(true, birthdate);
      if (result != null) {
        return result;
      }
    }
    return null;
  };
  Record.prototype.validateRegion = function (region) {
    var tmp$;
    if (region != null) {
      var tmp$_0;
      tmp$ = trim(Kotlin.isCharSequence(tmp$_0 = region) ? tmp$_0 : throwCCE()).toString();
    }
     else
      tmp$ = null;
    var trimmedRegion = tmp$;
    var tmp$_1 = JavelinManager$Companion_getInstance().dm_8be2vx$.isRegionRequired;
    if (tmp$_1) {
      tmp$_1 = trimmedRegion == null || trimmedRegion.length === 0;
    }
    if (tmp$_1) {
      return Error$Companion_getInstance().id(Id_getInstance().error_missing_region);
    }
    var tmp$_2;
    tmp$_2 = this.integrations.iterator();
    while (tmp$_2.hasNext()) {
      var element = tmp$_2.next();
      var result = element.validateRegion_ifx8ge$(true, trimmedRegion);
      if (result != null) {
        return result;
      }
    }
    return null;
  };
  Record.prototype.validateSchedule = function (scheduleId) {
    if (JavelinManager$Companion_getInstance().dm_8be2vx$.isScheduleRequired && scheduleId == null) {
      return Error$Companion_getInstance().id(Id_getInstance().error_missing_region);
    }
    return null;
  };
  Record.prototype.validateRelationship = function (relationship) {
    if (relationship === -1) {
      return Error$Companion_getInstance().id(Id_getInstance().error_relationship);
    }
    var tmp$;
    tmp$ = this.integrations.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      var result = element.validateRelationship_eltk6l$(true, relationship);
      if (result != null) {
        return result;
      }
    }
    return null;
  };
  Record.prototype.validateDoctor = function (doctor) {
    var tmp$;
    if (doctor != null) {
      var tmp$_0;
      tmp$ = trim(Kotlin.isCharSequence(tmp$_0 = doctor) ? tmp$_0 : throwCCE()).toString();
    }
     else
      tmp$ = null;
    var trimmedDoctor = tmp$;
    if (Validation_getInstance().isOverMaxLength_9g2trk$(trimmedDoctor, 255)) {
      return Error$Companion_getInstance().string(Str_getInstance().get_ge7pzc$(Id_getInstance().error_hcp_length, [toString(trimmedDoctor != null ? trimmedDoctor.length : null)]));
    }
    return null;
  };
  Record.prototype.validateCity = function (cityId) {
    var tmp$;
    tmp$ = this.integrations.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      var result = element.validateCityId_ifx8ge$(true, cityId);
      if (result != null) {
        return result;
      }
    }
    return null;
  };
  Record.prototype.validateNotes = function (notes) {
    var tmp$;
    if (notes != null) {
      var tmp$_0;
      tmp$ = trim(Kotlin.isCharSequence(tmp$_0 = notes) ? tmp$_0 : throwCCE()).toString();
    }
     else
      tmp$ = null;
    var trimmedNotes = tmp$;
    if (Validation_getInstance().isOverMaxLength_9g2trk$(trimmedNotes, 2048)) {
      return Error$Companion_getInstance().string(Str_getInstance().get_ge7pzc$(Id_getInstance().error_record_notes_length, [toString(trimmedNotes != null ? trimmedNotes.length : null)]));
    }
    return null;
  };
  Record.prototype.validateConsent = function (birthdate, relationship, consentDate) {
    if (Record$Companion_getInstance().needsConsent(relationship, birthdate) && consentDate == null) {
      return Error$Companion_getInstance().id(Id_getInstance().error_record_consent);
    }
    return null;
  };
  function Record$Companion() {
    Record$Companion_instance = this;
    this.MAX_FIRST_NAME = 150;
    this.MAX_LAST_NAME = 150;
    this.MAX_DOCTOR = 255;
    this.MAX_NOTES = 2048;
  }
  Record$Companion.prototype.needsConsent = function (relationship, birthdate) {
    if (relationship === 0)
      return false;
    if (birthdate == null)
      return false;
    if (relationship === 1 && birthdate.dateInYears() < 16) {
      return false;
    }
    return true;
  };
  Record$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var Record$Companion_instance = null;
  function Record$Companion_getInstance() {
    if (Record$Companion_instance === null) {
      new Record$Companion();
    }
    return Record$Companion_instance;
  }
  Record.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Record',
    interfaces: []
  };
  function Record_init(recordId, lastUpdated, lastSyncTimestamp, firstName, lastName, gender, birthdate, region, scheduleId, relationship, doctor, cityId, notes, doses, consents, integrations, ignoredGenerators, doseComments, isIgnoredPagesHidden, $this) {
    $this = $this || Object.create(Record.prototype);
    Record.call($this);
    $this.recordId = recordId;
    $this.lastUpdated = lastUpdated;
    $this.lastSyncTimestamp = lastSyncTimestamp;
    $this.firstName = firstName;
    $this.lastName = lastName;
    $this.gender = gender;
    $this.birthdate = birthdate;
    $this.region = region;
    $this.scheduleId = scheduleId;
    $this.relationship = relationship;
    $this.doctor = doctor;
    $this.cityId = cityId;
    $this.notes = notes;
    $this.doses = toMutableList(doses);
    $this.consents = toMutableList(consents);
    $this.integrations = toMutableList(integrations);
    $this.ignoredGenerators = toMutableList(ignoredGenerators);
    $this.doseComments = toMutableMap(doseComments);
    $this.isIgnoredPagesHidden = isIgnoredPagesHidden;
    $this.initialized_0 = true;
    return $this;
  }
  function Record_init_0(record, $this) {
    $this = $this || Object.create(Record.prototype);
    Record_init(Help_getInstance().randomId(), null, null, record.firstName, record.lastName, record.gender, record.birthdate, record.region, record.scheduleId, record.relationship, record.doctor, record.cityId, record.notes, ArrayList_init_0(), ArrayList_init_0(), ArrayList_init_0(), record.ignoredGenerators, record.doseComments, record.isIgnoredPagesHidden, $this);
    return $this;
  }
  function Record_init_1($this) {
    $this = $this || Object.create(Record.prototype);
    Record.call($this);
    $this.recordId = Help_getInstance().randomId();
    $this.lastUpdated = null;
    $this.lastSyncTimestamp = null;
    $this.lastName = '';
    $this.relationship = -1;
    $this.doctor = '';
    $this.notes = '';
    $this.doses = ArrayList_init_0();
    $this.integrations = ArrayList_init_0();
    $this.consents = ArrayList_init_0();
    $this.ignoredGenerators = ArrayList_init_0();
    $this.doseComments = LinkedHashMap_init();
    $this.firstName = '';
    $this.birthdate = Date_getInstance().now_8be2vx$();
    return $this;
  }
  function Integration(integrationId, type, recordId, consents, isNew) {
    Integration$Companion_getInstance();
    if (isNew === void 0)
      isNew = false;
    this.integrationId = integrationId;
    this.type = type;
    this.recordId = recordId;
    this.consents = consents;
    this.isNew = isNew;
  }
  Integration.prototype.record = function () {
    var tmp$;
    var tmp$_0;
    if ((tmp$ = JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(Record), (new QueryBuilder(Type_getInstance().RECORD)).where_puj7f4$('recordId', this.recordId))) != null)
      tmp$_0 = tmp$;
    else {
      throw IllegalStateException_init('Record was null for Integration'.toString());
    }
    return tmp$_0;
  };
  Integration.prototype.addConsent_ww9v1r$ = function (consent) {
    this.consents.add_11rb$(consent);
  };
  Integration.prototype.disable = function () {
    this.record().removeIntegration_8t4x4e$(this);
  };
  Integration.prototype.validateLastName_8kj6y5$ = function (generic, lastName) {
    return null;
  };
  Integration.prototype.validateBirthdate_mhd02g$ = function (generic, birthdate) {
    return null;
  };
  Integration.prototype.validateRelationship_eltk6l$ = function (generic, relationship) {
    return null;
  };
  Integration.prototype.validateRegion_ifx8ge$ = function (generic, region) {
    return null;
  };
  Integration.prototype.validateCityId_ifx8ge$ = function (generic, cityId) {
    return null;
  };
  Integration.prototype.checkMinimumEligibility = function () {
    return null;
  };
  Integration.prototype.checkEligibility = function () {
    return this.checkMinimumEligibility();
  };
  function Integration$Companion() {
    Integration$Companion_instance = this;
  }
  Integration$Companion.prototype.newIntegration_iwx8jd$ = function (type, record, id) {
    if (equals(type, Type_getInstance().PHU_INTEGRATION))
      return PHUIntegration_init_0(record, id);
    else
      throw new JavelinException('Unknown Integration Type: ' + type);
  };
  Integration$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var Integration$Companion_instance = null;
  function Integration$Companion_getInstance() {
    if (Integration$Companion_instance === null) {
      new Integration$Companion();
    }
    return Integration$Companion_instance;
  }
  Integration.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Integration',
    interfaces: []
  };
  function Integration_init(type, record, $this) {
    $this = $this || Object.create(Integration.prototype);
    Integration.call($this, Help_getInstance().randomId(), type, record.recordId, ArrayList_init_0(), true);
    return $this;
  }
  function PHUIntegration() {
    PHUIntegration$Companion_getInstance();
    this.phuId = null;
    this.guardianFirstName_dhkwde$_0 = null;
    this.guardianLastName_sb3wfe$_0 = null;
    this.ohip_k8r7k8$_0 = null;
    this.phoneNumber_hz254l$_0 = null;
    this.address1_4hmbor$_0 = null;
    this.address2_4hmbpm$_0 = null;
    this.postalCode_u3xb0w$_0 = null;
    this.phuConfig_b9eifn$_0 = null;
  }
  Object.defineProperty(PHUIntegration.prototype, 'guardianFirstName', {
    get: function () {
      return this.guardianFirstName_dhkwde$_0;
    },
    set: function (guardianFirstName) {
      this.guardianFirstName_dhkwde$_0 = guardianFirstName;
    }
  });
  Object.defineProperty(PHUIntegration.prototype, 'guardianLastName', {
    get: function () {
      return this.guardianLastName_sb3wfe$_0;
    },
    set: function (guardianLastName) {
      this.guardianLastName_sb3wfe$_0 = guardianLastName;
    }
  });
  Object.defineProperty(PHUIntegration.prototype, 'ohip', {
    get: function () {
      return this.ohip_k8r7k8$_0;
    },
    set: function (ohip) {
      this.ohip_k8r7k8$_0 = ohip;
    }
  });
  Object.defineProperty(PHUIntegration.prototype, 'phoneNumber', {
    get: function () {
      return this.phoneNumber_hz254l$_0;
    },
    set: function (phoneNumber) {
      this.phoneNumber_hz254l$_0 = phoneNumber;
    }
  });
  Object.defineProperty(PHUIntegration.prototype, 'address1', {
    get: function () {
      return this.address1_4hmbor$_0;
    },
    set: function (address1) {
      this.address1_4hmbor$_0 = address1;
    }
  });
  Object.defineProperty(PHUIntegration.prototype, 'address2', {
    get: function () {
      return this.address2_4hmbpm$_0;
    },
    set: function (address2) {
      this.address2_4hmbpm$_0 = address2;
    }
  });
  Object.defineProperty(PHUIntegration.prototype, 'postalCode', {
    get: function () {
      return this.postalCode_u3xb0w$_0;
    },
    set: function (postalCode) {
      this.postalCode_u3xb0w$_0 = postalCode;
    }
  });
  Object.defineProperty(PHUIntegration.prototype, 'phuConfig', {
    get: function () {
      return JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(PHUConfig), (new QueryBuilder(Type_getInstance().PHU_CONFIG)).where_puj7f4$('phuId', this.phuId));
    },
    set: function (phuConfig) {
      this.phuConfig_b9eifn$_0 = phuConfig;
    }
  });
  Object.defineProperty(PHUIntegration.prototype, 'isConsentValid', {
    get: function () {
      if (this.isNew) {
        return true;
      }
      if (this.isUserTooOld) {
        return true;
      }
      var consent = null;
      if (!this.consents.isEmpty()) {
        consent = this.consents.get_za3lpa$(0);
      }
      if ((consent != null ? consent.version : null) === 2) {
        return true;
      }
      if ((consent != null ? consent.version : null) === 1 && this.record().birthdate.dateInYears() < 16) {
        return true;
      }
      return false;
    }
  });
  Object.defineProperty(PHUIntegration.prototype, 'isUserTooOld', {
    get: function () {
      return this.validateBirthdate_mhd02g$(false, this.record().birthdate) != null;
    }
  });
  PHUIntegration.prototype.save = function (guardianFirstName, guardianLastName, ohip, phone, address1, address2, postalCode, cityId) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4, tmp$_5, tmp$_6, tmp$_7, tmp$_8, tmp$_9, tmp$_10, tmp$_11, tmp$_12, tmp$_13;
    var tmp$_14;
    if (ohip != null) {
      var tmp$_15;
      tmp$_14 = trim(Kotlin.isCharSequence(tmp$_15 = ohip) ? tmp$_15 : throwCCE()).toString();
    }
     else
      tmp$_14 = null;
    var ohipLocal = (tmp$ = tmp$_14) != null ? tmp$ : '';
    var tmp$_16;
    if (guardianFirstName != null) {
      var tmp$_17;
      tmp$_16 = trim(Kotlin.isCharSequence(tmp$_17 = guardianFirstName) ? tmp$_17 : throwCCE()).toString();
    }
     else
      tmp$_16 = null;
    var guardianFirstNameLocal = (tmp$_0 = tmp$_16) != null ? tmp$_0 : '';
    var tmp$_18;
    if (guardianLastName != null) {
      var tmp$_19;
      tmp$_18 = trim(Kotlin.isCharSequence(tmp$_19 = guardianLastName) ? tmp$_19 : throwCCE()).toString();
    }
     else
      tmp$_18 = null;
    var guardianLastNameLocal = (tmp$_1 = tmp$_18) != null ? tmp$_1 : '';
    var tmp$_20;
    if (address1 != null) {
      var tmp$_21;
      tmp$_20 = trim(Kotlin.isCharSequence(tmp$_21 = address1) ? tmp$_21 : throwCCE()).toString();
    }
     else
      tmp$_20 = null;
    var address1Local = (tmp$_2 = tmp$_20) != null ? tmp$_2 : '';
    var tmp$_22;
    if (address2 != null) {
      var tmp$_23;
      tmp$_22 = trim(Kotlin.isCharSequence(tmp$_23 = address2) ? tmp$_23 : throwCCE()).toString();
    }
     else
      tmp$_22 = null;
    var address2Local = (tmp$_3 = tmp$_22) != null ? tmp$_3 : '';
    var numericPhone = (tmp$_4 = phone != null ? Regex_init('[^0-9]').replace_x2uqeu$(phone, '') : null) != null ? tmp$_4 : '';
    var postalCodeLocal = (tmp$_6 = (tmp$_5 = postalCode != null ? postalCode.toUpperCase() : null) != null ? replace(tmp$_5, ' ', '') : null) != null ? tmp$_6 : '';
    var error = (tmp$_13 = (tmp$_12 = (tmp$_11 = (tmp$_10 = (tmp$_9 = (tmp$_8 = (tmp$_7 = this.validateCityId_ifx8ge$(false, cityId)) != null ? tmp$_7 : this.validateOHIP(ohipLocal)) != null ? tmp$_8 : this.validateGuardianFirstName(guardianFirstNameLocal)) != null ? tmp$_9 : this.validateGuardianLastName(guardianLastNameLocal)) != null ? tmp$_10 : this.validatePhone(numericPhone)) != null ? tmp$_11 : this.validateAddress1(address1Local)) != null ? tmp$_12 : this.validateAddress2(address2Local)) != null ? tmp$_13 : this.validatePostalCode(postalCodeLocal);
    if (error != null) {
      return error;
    }
    var record = this.record();
    record.setCity(cityId);
    var updatedField = false;
    if (!equals(this.guardianFirstName, guardianFirstNameLocal)) {
      updatedField = true;
      this.guardianFirstName = guardianFirstNameLocal;
    }
    if (!equals(this.guardianLastName, guardianLastNameLocal)) {
      updatedField = true;
      this.guardianLastName = guardianLastNameLocal;
    }
    if (!equals(this.ohip, ohipLocal)) {
      updatedField = true;
      this.ohip = ohipLocal;
    }
    var first3Digits = substring(numericPhone, new IntRange(0, 2));
    var mid3Digits = substring(numericPhone, new IntRange(3, 5));
    var last4Digits = substring(numericPhone, new IntRange(6, 9));
    var phoneString = first3Digits + '-' + mid3Digits + '-' + last4Digits;
    if (!equals(this.phoneNumber, phoneString)) {
      updatedField = true;
      this.phoneNumber = phoneString;
    }
    if (!equals(this.address1, address1Local)) {
      updatedField = true;
      this.address1 = address1Local;
    }
    if (!equals(this.address2, address2Local)) {
      updatedField = true;
      this.address2 = address2Local;
    }
    if (!equals(this.postalCode, postalCodeLocal)) {
      updatedField = true;
      this.postalCode = postalCodeLocal;
    }
    if (this.isNew) {
      this.addConsent_ww9v1r$(Consent_init_0(this.integrationId, Type_getInstance().PHU_INTEGRATION, Date_getInstance().nowZoned_8be2vx$(), 2));
      record.addIntegration_8t4x4e$(this);
      this.isNew = false;
    }
     else if (updatedField) {
      JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().UPDATE, this);
    }
    return null;
  };
  PHUIntegration.prototype.updateConsent = function () {
    var tmp$;
    tmp$ = this.consents.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(Action_getInstance().DELETE, element);
    }
    this.consents.clear();
    this.addConsent_ww9v1r$(Consent_init_0(this.integrationId, Type_getInstance().PHU_INTEGRATION, Date_getInstance().nowZoned_8be2vx$(), 2));
    JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().UPDATE, this);
  };
  PHUIntegration.prototype.error_0 = function (generic, error) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    tmp$_2 = Error$Companion_getInstance();
    if (generic) {
      tmp$_1 = Str_getInstance().get_ge7pzc$(Id_getInstance().phu_enabled_profile_change_error, [(tmp$_0 = (tmp$ = this.phuConfig) != null ? tmp$.phuName : null) != null ? tmp$_0 : '']);
    }
     else
      tmp$_1 = error;
    return tmp$_2.string(tmp$_1);
  };
  PHUIntegration.prototype.validateLastName_8kj6y5$ = function (generic, lastName) {
    var tmp$, tmp$_0;
    var tmp$_1;
    if (trim(Kotlin.isCharSequence(tmp$_1 = lastName) ? tmp$_1 : throwCCE()).toString().length === 0) {
      return this.error_0(generic, Str_getInstance().get_ge7pzc$(Id_getInstance().phu_last_name_required, [(tmp$_0 = (tmp$ = this.phuConfig) != null ? tmp$.phuName : null) != null ? tmp$_0 : '']));
    }
    return Integration.prototype.validateLastName_8kj6y5$.call(this, generic, lastName);
  };
  PHUIntegration.prototype.validateGuardianFirstName = function (guardianFirstName) {
    if (guardianFirstName.length === 0) {
      return Error$Companion_getInstance().id(Id_getInstance().error_phu_first_name);
    }
     else if (Validation_getInstance().isOverMaxLength_9g2trk$(guardianFirstName, 250)) {
      return Error$Companion_getInstance().string(Str_getInstance().get_ge7pzc$(Id_getInstance().error_guardian_first_length, [guardianFirstName.length.toString()]));
    }
    return null;
  };
  PHUIntegration.prototype.validateGuardianLastName = function (guardianLastName) {
    if (guardianLastName.length === 0) {
      return Error$Companion_getInstance().id(Id_getInstance().error_phu_last_name);
    }
     else if (Validation_getInstance().isOverMaxLength_9g2trk$(guardianLastName, 250)) {
      return Error$Companion_getInstance().string(Str_getInstance().get_ge7pzc$(Id_getInstance().error_guardian_last_length, [guardianLastName.length.toString()]));
    }
    return null;
  };
  PHUIntegration.prototype.validatePhone = function (phone) {
    if (phone.length !== 10) {
      return Error$Companion_getInstance().id(Id_getInstance().phu_valid_phone_number);
    }
     else if (toInt(String.fromCharCode(first(phone))) === 1) {
      return Error$Companion_getInstance().id(Id_getInstance().phu_phone_number_containing);
    }
    return null;
  };
  PHUIntegration.prototype.validateAddress1 = function (address1) {
    if (address1.length === 0) {
      return Error$Companion_getInstance().id(Id_getInstance().phu_enter_address);
    }
     else if (Validation_getInstance().isOverMaxLength_9g2trk$(address1, 124)) {
      return Error$Companion_getInstance().string(Str_getInstance().get_ge7pzc$(Id_getInstance().error_address_1_length, [address1.length.toString()]));
    }
    return null;
  };
  PHUIntegration.prototype.validateAddress2 = function (address2) {
    if (Validation_getInstance().isOverMaxLength_9g2trk$(address2, 124)) {
      Error$Companion_getInstance().id(Str_getInstance().get_ge7pzc$(Id_getInstance().error_address_2_length, [address2.length.toString()]));
    }
    return null;
  };
  PHUIntegration.prototype.validatePostalCode = function (postalCode) {
    var pattern = Regex_init('^[ABCEGHJKLMNPRSTVXY]\\d([ABCEGHJKLMNPRSTVWXYZ]\\d){2}$');
    if (!pattern.containsMatchIn_6bul2c$(postalCode)) {
      return Error$Companion_getInstance().id(Id_getInstance().phu_valid_postal_code);
    }
    return null;
  };
  PHUIntegration.prototype.validateBirthdate_mhd02g$ = function (generic, birthdate) {
    var tmp$, tmp$_0;
    var maxAge = (tmp$_0 = (tmp$ = this.phuConfig) != null ? tmp$.maxAge : null) != null ? tmp$_0 : -1;
    if (birthdate.dateInYears() > maxAge) {
      return this.error_0(generic, Str_getInstance().get_ge7pzc$(Id_getInstance().error_phu_age, [maxAge.toString()]));
    }
    return Integration.prototype.validateBirthdate_mhd02g$.call(this, generic, birthdate);
  };
  PHUIntegration.prototype.validateRelationship_eltk6l$ = function (generic, relationship) {
    var tmp$, tmp$_0;
    if (relationship !== 1 && relationship !== 0) {
      return this.error_0(generic, Str_getInstance().get_ge7pzc$(Id_getInstance().error_phu_relationship, [(tmp$_0 = (tmp$ = this.phuConfig) != null ? tmp$.phuName : null) != null ? tmp$_0 : '']));
    }
    return Integration.prototype.validateRelationship_eltk6l$.call(this, generic, relationship);
  };
  PHUIntegration.prototype.validateRegion_ifx8ge$ = function (generic, region) {
    if (region == null || !equals_0(region, 'ON', true)) {
      return this.error_0(generic, Str_getInstance().get_y4putb$(Id_getInstance().phu_must_live_ontario));
    }
    return Integration.prototype.validateRegion_ifx8ge$.call(this, generic, region);
  };
  PHUIntegration.prototype.validateCityId_ifx8ge$ = function (generic, cityId) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    if (cityId == null) {
      return this.error_0(generic, Str_getInstance().get_y4putb$(Id_getInstance().phu_select_city));
    }
    if (((tmp$_0 = (tmp$ = this.phuConfig) != null ? tmp$.cityIds : null) != null ? tmp$_0.contains_11rb$(cityId) : null) !== true) {
      return this.error_0(generic, Str_getInstance().get_ge7pzc$(Id_getInstance().phu_must_live_listed_area, [this.record().firstName, (tmp$_2 = (tmp$_1 = this.phuConfig) != null ? tmp$_1.phuName : null) != null ? tmp$_2 : '']));
    }
    return Integration.prototype.validateCityId_ifx8ge$.call(this, generic, cityId);
  };
  PHUIntegration.prototype.validateOHIP = function (ohip) {
    var tmp$;
    if (ohip.length === 0) {
      return Error$Companion_getInstance().id(Id_getInstance().phu_valid_ohip);
    }
    if (!Regex_init('[0-9]+').matches_6bul2c$(ohip)) {
      return Error$Companion_getInstance().id(Id_getInstance().phu_ohip_only_numeric);
    }
    if (ohip.length !== 10) {
      return Error$Companion_getInstance().id(Id_getInstance().phu_valid_ohip);
    }
    var $receiver = toList(ohip);
    var destination = ArrayList_init(collectionSizeOrDefault($receiver, 10));
    var tmp$_0;
    tmp$_0 = $receiver.iterator();
    while (tmp$_0.hasNext()) {
      var item = tmp$_0.next();
      destination.add_11rb$(toInt(String.fromCharCode(unboxChar(item))));
    }
    var digits = destination;
    var sum = 0;
    var lastDigit = -1;
    for (var i = 0; i !== digits.size; ++i) {
      var currentDigit = digits.get_za3lpa$(i);
      if (i % 2 === 0) {
        currentDigit = currentDigit * 2 | 0;
        if (currentDigit > 9) {
          var newDigit = 0;
          while (currentDigit !== 0) {
            newDigit = newDigit + currentDigit % 10 | 0;
            currentDigit = currentDigit / 10 | 0;
          }
          currentDigit = newDigit;
        }
      }
      if (i === 9) {
        lastDigit = currentDigit;
      }
       else {
        sum = sum + currentDigit | 0;
      }
    }
    sum = sum * 9 | 0;
    var mod10 = sum % 10;
    if (mod10 !== lastDigit) {
      return Error$Companion_getInstance().id(Id_getInstance().phu_valid_ohip);
    }
    var builder = (new QueryBuilder(Type_getInstance().PHU_INTEGRATION)).where_puj7f4$('type', Type_getInstance().PHU_INTEGRATION).and_puj7f4$('ohip', ohip).andNot_puj7f4$('recordId', this.recordId);
    if (JavelinManager$Companion_getInstance().dm_8be2vx$.exists(getKClass(PHUIntegration), builder)) {
      return Error$Companion_getInstance().string(Str_getInstance().get_ge7pzc$(Id_getInstance().phu_unique_ohip, [(tmp$ = this.phuConfig) != null ? tmp$.phuName : null]));
    }
    return null;
  };
  PHUIntegration.prototype.checkMinimumEligibility = function () {
    var tmp$, tmp$_0;
    var result = Integration.prototype.checkMinimumEligibility.call(this);
    if (result != null)
      return result;
    var record = this.record();
    return (tmp$_0 = (tmp$ = this.validateBirthdate_mhd02g$(false, record.birthdate)) != null ? tmp$ : this.validateRegion_ifx8ge$(false, record.region)) != null ? tmp$_0 : this.validateCityId_ifx8ge$(false, record.cityId);
  };
  PHUIntegration.prototype.checkEligibility = function () {
    var tmp$;
    var result = Integration.prototype.checkEligibility.call(this);
    if (result != null)
      return result;
    var record = this.record();
    return (tmp$ = this.validateLastName_8kj6y5$(false, record.lastName)) != null ? tmp$ : this.validateRelationship_eltk6l$(false, record.relationship);
  };
  function PHUIntegration$Companion() {
    PHUIntegration$Companion_instance = this;
    this.MAX_GUARDIAN_FIRST = 250;
    this.MAX_GUARDIAN_LAST = 250;
    this.MAX_ADDRESS_1 = 124;
    this.MAX_ADDRESS_2 = 124;
  }
  PHUIntegration$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var PHUIntegration$Companion_instance = null;
  function PHUIntegration$Companion_getInstance() {
    if (PHUIntegration$Companion_instance === null) {
      new PHUIntegration$Companion();
    }
    return PHUIntegration$Companion_instance;
  }
  PHUIntegration.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'PHUIntegration',
    interfaces: [Integration]
  };
  function PHUIntegration_init(integrationId, type, recordId, consents, phuId, guardianFirstName, guardianLastName, ohip, phoneNumber, address1, address2, postalCode, $this) {
    $this = $this || Object.create(PHUIntegration.prototype);
    Integration.call($this, integrationId, type, recordId, consents);
    PHUIntegration.call($this);
    $this.phuId = phuId.toUpperCase();
    $this.guardianFirstName = guardianFirstName;
    $this.guardianLastName = guardianLastName;
    $this.ohip = ohip;
    $this.phoneNumber = phoneNumber;
    $this.address1 = address1;
    $this.address2 = address2;
    $this.postalCode = postalCode.toUpperCase();
    return $this;
  }
  function PHUIntegration_init_0(record, phuId, $this) {
    $this = $this || Object.create(PHUIntegration.prototype);
    Integration_init(Type_getInstance().PHU_INTEGRATION, record, $this);
    PHUIntegration.call($this);
    $this.phuId = phuId.toUpperCase();
    $this.guardianFirstName = '';
    $this.guardianLastName = '';
    $this.ohip = '';
    $this.phoneNumber = '';
    $this.address1 = '';
    $this.address2 = '';
    $this.postalCode = '';
    return $this;
  }
  function Action() {
    Action_instance = this;
    this.CREATE = 'CREATE';
    this.READ = 'READ';
    this.UPDATE = 'UPDATE';
    this.DELETE = 'DELETE';
    this.UI_UPDATE = 'UI_UPDATE';
    this.REGENERATE_PAGES = 'REGENERATE_PAGES';
    this.RECORD_FETCH = 'RECORD_FETCH';
  }
  Action.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Action',
    interfaces: []
  };
  var Action_instance = null;
  function Action_getInstance() {
    if (Action_instance === null) {
      new Action();
    }
    return Action_instance;
  }
  function QueryBuilder(type) {
    this.type = type;
    this.builder = StringBuilder_init().append_gw00v9$('SELECT * FROM ').append_gw00v9$(this.type);
    this.items = ArrayList_init_0();
  }
  QueryBuilder.prototype.where_puj7f4$ = function (property, value) {
    if (value === void 0)
      value = 'true';
    this.addCondition_0('WHERE', property, value);
    return this;
  };
  QueryBuilder.prototype.and_puj7f4$ = function (property, value) {
    if (value === void 0)
      value = 'true';
    this.addCondition_0('AND', property, value);
    return this;
  };
  QueryBuilder.prototype.andNot_puj7f4$ = function (property, value) {
    this.addCondition_0('AND NOT', property, value);
    return this;
  };
  QueryBuilder.prototype.addCondition_0 = function (methodName, property, value) {
    this.items.add_11rb$(new QueryBuilder$Item(methodName, property, value));
  };
  QueryBuilder.prototype.build = function () {
    var builder = StringBuilder_init().append_gw00v9$('SELECT * FROM ').append_gw00v9$(this.type);
    var tmp$;
    tmp$ = this.items.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      builder.append_gw00v9$(' ');
      builder.append_gw00v9$(element.methodName);
      builder.append_gw00v9$(' ');
      builder.append_gw00v9$(element.property);
      builder.append_gw00v9$(" = '");
      builder.append_gw00v9$(element.value);
      builder.append_gw00v9$("'");
    }
    return builder.append_gw00v9$(';').toString();
  };
  function QueryBuilder$Item(methodName, property, value) {
    this.methodName = methodName;
    this.property = property;
    this.value = value;
  }
  QueryBuilder$Item.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Item',
    interfaces: []
  };
  QueryBuilder.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'QueryBuilder',
    interfaces: []
  };
  function Type() {
    Type_instance = this;
    this.RECORD = 'Record';
    this.DOSE = 'Dose';
    this.PHU_INTEGRATION = 'PHUIntegration';
    this.PHU_CONFIG = 'PHUConfig';
    this.CONSENT = 'Consent';
    this.VACCINE = 'Vaccine';
    this.DISEASE = 'Disease';
    this.SCHEDULE = 'Schedule';
    this.COLLECTION = 'Collection';
    this.GENERATOR = 'Generator';
    this.GENERIC_CONCEPT = 'GenericConcept';
    this.TRADE_NAME_CONCEPT = 'TradeNameConcept';
    this.DISEASE_CONCEPT = 'DiseaseConcept';
    this.CITY = 'City';
    this.BANNER = 'Banner';
  }
  function Type$Simple() {
    Type$Simple_instance = this;
    this.LANGUAGE = 'Language';
  }
  Type$Simple.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Simple',
    interfaces: []
  };
  var Type$Simple_instance = null;
  function Type$Simple_getInstance() {
    if (Type$Simple_instance === null) {
      new Type$Simple();
    }
    return Type$Simple_instance;
  }
  Type.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Type',
    interfaces: []
  };
  var Type_instance = null;
  function Type_getInstance() {
    if (Type_instance === null) {
      new Type();
    }
    return Type_instance;
  }
  function DataManager(dataInterface) {
    this.dataInterface_0 = dataInterface;
    this.log_0 = new Logger('DataManager');
    this.regions_1ubqhs$_0 = lazy(DataManager$regions$lambda(this));
  }
  Object.defineProperty(DataManager.prototype, 'regions_0', {
    get: function () {
      return this.regions_1ubqhs$_0.value;
    }
  });
  DataManager.prototype.onBroadcastReceived_2urz0g$ = function (action, obj, fields) {
    if (Kotlin.isType(obj, Record) && (equals(action, Action_getInstance().CREATE) || equals(action, Action_getInstance().DELETE) || fields.contains_11rb$(3) || fields.contains_11rb$(5) || fields.contains_11rb$(2) || fields.contains_11rb$(10))) {
      JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(Action_getInstance().REGENERATE_PAGES, obj.recordId);
    }
     else if (Kotlin.isType(obj, Dose)) {
      if (equals(action, Action_getInstance().CREATE) || equals(action, Action_getInstance().DELETE) || fields.contains_11rb$(1) || fields.contains_11rb$(0) || fields.contains_11rb$(2)) {
        JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(Action_getInstance().REGENERATE_PAGES, obj.recordId);
      }
       else {
        JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(Action_getInstance().UI_UPDATE, obj.recordId);
      }
    }
  };
  function DataManager$getRegionNames$lambda(o1, o2) {
    return Kotlin.compareTo(o1.name.toLowerCase(), o2.name.toLowerCase());
  }
  function Comparator$ObjectLiteral_6(closure$comparison) {
    this.closure$comparison = closure$comparison;
  }
  Comparator$ObjectLiteral_6.prototype.compare = function (a, b) {
    return this.closure$comparison(a, b);
  };
  Comparator$ObjectLiteral_6.$metadata$ = {kind: Kind_CLASS, interfaces: [Comparator]};
  DataManager.prototype.getRegionNames = function () {
    var regions = sortedWith(this.regions_0, new Comparator$ObjectLiteral_6(DataManager$getRegionNames$lambda));
    var destination = ArrayList_init(collectionSizeOrDefault(regions, 10));
    var tmp$;
    tmp$ = regions.iterator();
    while (tmp$.hasNext()) {
      var item = tmp$.next();
      destination.add_11rb$(item.key);
    }
    return destination;
  };
  Object.defineProperty(DataManager.prototype, 'isRegionRequired', {
    get: function () {
      return this.dataInterface_0.isRegionRequired;
    }
  });
  Object.defineProperty(DataManager.prototype, 'isScheduleRequired', {
    get: function () {
      return this.dataInterface_0.isScheduleRequired;
    }
  });
  DataManager.prototype.querySingle = function (aClass, query) {
    return this.dataInterface_0.querySingle(aClass, query);
  };
  DataManager.prototype.queryList = function (aClass, query) {
    return this.dataInterface_0.queryList(aClass, query);
  };
  DataManager.prototype.operateList = function (aClass, query, operation) {
    this.dataInterface_0.operateList(aClass, query, operation);
  };
  DataManager.prototype.deleteList = function (aClass, query) {
    this.dataInterface_0.deleteList(aClass, query);
  };
  DataManager.prototype.exists = function (aClass, query) {
    return this.dataInterface_0.exists(aClass, query);
  };
  DataManager.prototype.getVaccineConcept = function (conceptId) {
    var concept = this.querySingle(getKClass(GenericConcept), (new QueryBuilder(Type_getInstance().GENERIC_CONCEPT)).where_puj7f4$('conceptId', conceptId));
    if (concept != null) {
      return concept;
    }
    return this.querySingle(getKClass(TradeNameConcept), (new QueryBuilder(Type_getInstance().TRADE_NAME_CONCEPT)).where_puj7f4$('conceptId', conceptId));
  };
  DataManager.prototype.updateRecord = function (record, shouldUpdate) {
    var oldRecord = this.querySingle(getKClass(Record), (new QueryBuilder(Type_getInstance().RECORD)).where_puj7f4$('recordId', record.recordId));
    if (oldRecord != null) {
      record.copyLocalFields_tjuny1$(oldRecord);
    }
    JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(oldRecord == null ? Action_getInstance().CREATE : Action_getInstance().UPDATE, record);
    if (shouldUpdate) {
      JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(Action_getInstance().REGENERATE_PAGES, record.recordId);
    }
     else {
      JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(Action_getInstance().RECORD_FETCH, record.recordId);
    }
  };
  var addAll = Kotlin.kotlin.collections.addAll_ipc267$;
  DataManager.prototype.getDose = function (pages, doseId, generatedId) {
    var generatedIdDose = {v: null};
    var destination = ArrayList_init_0();
    var tmp$;
    tmp$ = pages.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      var list = element.doses;
      addAll(destination, list);
    }
    var tmp$_0;
    tmp$_0 = destination.iterator();
    while (tmp$_0.hasNext()) {
      var element_0 = tmp$_0.next();
      if (equals(element_0.doseId, doseId)) {
        return element_0;
      }
       else if (generatedId != null && equals(generatedId, element_0.generatedId)) {
        generatedIdDose.v = element_0;
      }
    }
    if (generatedIdDose.v != null) {
      return generatedIdDose.v;
    }
    this.log_0.i_y4putb$('Dose not found in getDose()');
    return null;
  };
  DataManager.prototype.getRegionName = function (region) {
    var tmp$;
    var $receiver = this.regions_0;
    var firstOrNull$result;
    firstOrNull$break: do {
      var tmp$_0;
      tmp$_0 = $receiver.iterator();
      while (tmp$_0.hasNext()) {
        var element = tmp$_0.next();
        if (equals_0(element.key, region, true)) {
          firstOrNull$result = element;
          break firstOrNull$break;
        }
      }
      firstOrNull$result = null;
    }
     while (false);
    return (tmp$ = firstOrNull$result) != null ? tmp$.name : null;
  };
  function DataManager$regions$lambda(this$DataManager) {
    return function () {
      var regions = ArrayList_init_0();
      var tmp$;
      tmp$ = this$DataManager.dataInterface_0.regions.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        regions.add_11rb$(new Region(element));
      }
      return regions;
    };
  }
  DataManager.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'DataManager',
    interfaces: []
  };
  function NotificationManager() {
    NotificationManager_instance = this;
  }
  NotificationManager.prototype.getDateStatus_0 = function (date) {
    if (!date.isFuture)
      return 0;
    else if (date.isWithinWeeks(2))
      return 1;
    else
      return 3;
  };
  NotificationManager.prototype.getDoseStatus_0 = function (record, dose, isReceived, isIgnored) {
    if (isReceived === void 0)
      isReceived = dose.isReceived;
    if (isIgnored === void 0)
      isIgnored = dose.isIgnored(record);
    if (isReceived)
      return 2;
    else if (isIgnored || dose.isGeneratorIgnored(record))
      return 4;
    else {
      var tmp$, tmp$_0;
      if ((tmp$_0 = (tmp$ = dose.generator()) != null ? tmp$.isApproaching_tjuny1$(record) : null) != null ? tmp$_0 : false)
        return 1;
      else
        return this.getDateStatus_0(dose.overallDate);
    }
  };
  NotificationManager.prototype.getDosesStatus_0 = function (record, doses, influenzaVaccineConceptIds) {
    var tmp$, tmp$_0;
    var receivedOrIgnored = true;
    var ignored = true;
    var approaching = false;
    var withinSixMonths = false;
    var flu = true;
    tmp$ = doses.iterator();
    while (tmp$.hasNext()) {
      var dose = tmp$.next();
      var status = this.getDoseStatus_0(record, dose);
      switch (status) {
        case 0:
          return 0;
        case 1:
          approaching = true;
          receivedOrIgnored = false;
          ignored = false;
          break;
        case 3:
          receivedOrIgnored = false;
          ignored = false;
          if (dose.overallDate.isBefore(Date_getInstance().now_8be2vx$().plusMonths(6))) {
            withinSixMonths = true;
          }

          break;
        case 2:
          ignored = false;
          break;
      }
      if (!influenzaVaccineConceptIds.contains_11rb$(dose.concept().parentConceptId)) {
        flu = false;
      }
    }
    if (ignored)
      tmp$_0 = 4;
    else if (receivedOrIgnored)
      tmp$_0 = 2;
    else if (approaching)
      tmp$_0 = 1;
    else if (flu && !withinSixMonths)
      tmp$_0 = 2;
    else
      tmp$_0 = 3;
    return tmp$_0;
  };
  NotificationManager.prototype.getPageStatus = function (record, page, influenzaVaccineConceptIds) {
    return this.getDosesStatus_0(record, page.doses, influenzaVaccineConceptIds);
  };
  NotificationManager.prototype.getDoseBoxNotification = function (record, dose, isReceived, isIgnored, date) {
    if (isReceived === void 0)
      isReceived = dose.isReceived;
    if (isIgnored === void 0)
      isIgnored = dose.isIgnored(record);
    if (date === void 0)
      date = dose.date;
    var tmp$, tmp$_0;
    var status = this.getDoseStatus_0(record, dose, isReceived, isIgnored);
    var title;
    switch (status) {
      case 3:
        title = date != null ? Str_getInstance().get_ge7pzc$(Id_getInstance().notification_scheduled_for, [date.longDateString]) : Str_getInstance().get_ge7pzc$(Id_getInstance().notification_recommended_on, [dose.overallDate.longDateString]);
        break;
      case 1:
        title = Str_getInstance().get_y4putb$(Id_getInstance().notification_approaching);
        break;
      case 0:
        if (((tmp$ = dose.generator()) != null ? tmp$.isOverdueDateShown : null) === false) {
          title = Str_getInstance().get_y4putb$(Id_getInstance().notification_recommended_asap);
        }
         else {
          var interval = this.getDateIntervalDescription_unjduw$(date != null ? date : dose.overallDate);
          if (interval == null) {
            if (date != null) {
              tmp$_0 = Str_getInstance().get_ge7pzc$(Id_getInstance().notification_scheduled_for, [date.mediumDateString]);
            }
             else {
              tmp$_0 = Str_getInstance().get_y4putb$(Id_getInstance().notification_recommended_asap);
            }
          }
           else {
            tmp$_0 = Str_getInstance().get_ge7pzc$(Id_getInstance().notification_time_overdue, [interval]);
          }
          title = tmp$_0;
        }

        break;
      case 2:
        title = Str_getInstance().get_ge7pzc$(Id_getInstance().notification_received_on, [date != null ? date.longDateString : null]);
        break;
      case 4:
        title = Str_getInstance().get_y4putb$(dose.isMaxAgePast(record) ? Id_getInstance().dose_ignored_max_age_past : Id_getInstance().ignored);
        break;
      default:throw new JavelinException('Not a valid status: ' + status);
    }
    return new Notification(record, title, status);
  };
  NotificationManager.prototype.getDoseNotification_0 = function (record, dose) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3;
    var status = this.getDoseStatus_0(record, dose);
    var title;
    switch (status) {
      case 1:
        if (dose.isScheduled) {
          tmp$_0 = Str_getInstance().get_ge7pzc$(Id_getInstance().notification_scheduled_on_date, [dose.concept().abbreviation, (tmp$ = dose.date) != null ? tmp$.mediumDateString : null]);
        }
         else {
          tmp$_0 = Str_getInstance().get_ge7pzc$(Id_getInstance().notification_recommended_on_date, [dose.concept().abbreviation, dose.overallDate.mediumDateString]);
        }

        title = tmp$_0;
        break;
      case 0:
        if (((tmp$_1 = dose.generator()) != null ? tmp$_1.isOverdueDateShown : null) === false) {
          title = Str_getInstance().get_ge7pzc$(Id_getInstance().notification_is_recommended_asap, [dose.concept().abbreviation]);
        }
         else {
          var interval = this.getDateIntervalDescription_unjduw$(dose.overallDate);
          if (interval == null) {
            if (dose.isScheduled) {
              tmp$_3 = Str_getInstance().get_ge7pzc$(Id_getInstance().notification_scheduled_overdue, [dose.concept().abbreviation, (tmp$_2 = dose.date) != null ? tmp$_2.mediumDateString : null]);
            }
             else {
              tmp$_3 = Str_getInstance().get_ge7pzc$(Id_getInstance().notification_is_overdue, [dose.concept().abbreviation]);
            }
          }
           else {
            tmp$_3 = Str_getInstance().get_ge7pzc$(Id_getInstance().notification_is_overdue_time, [dose.concept().abbreviation, interval]);
          }
          title = tmp$_3;
        }

        break;
      default:return null;
    }
    return new Notification(record, title, status, dose);
  };
  var wrapFunction = Kotlin.wrapFunction;
  var mapNotNullTo$lambda = wrapFunction(function () {
    return function (closure$transform, closure$destination) {
      return function (element) {
        var tmp$;
        if ((tmp$ = closure$transform(element)) != null) {
          closure$destination.add_11rb$(tmp$);
        }
        return Unit;
      };
    };
  });
  NotificationManager.prototype.getPageNotifications_0 = function (record, page) {
    var notifications = ArrayList_init_0();
    var tmp$;
    tmp$ = page.doses.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      var tmp$_0;
      if ((tmp$_0 = this.getDoseNotification_0(record, element)) != null) {
        notifications.add_11rb$(tmp$_0);
      }
    }
    return notifications;
  };
  NotificationManager.prototype.getRecordNotifications = function (record, pages, influenzaVaccineConceptIds) {
    var tmp$, tmp$_0;
    var notifications = ArrayList_init_0();
    var type = record.isChild ? 0 : 1;
    tmp$ = SchedulerManager_getInstance().getPages(pages, type, record).iterator();
    pageLoop: while (tmp$.hasNext()) {
      var page = tmp$.next();
      var $receiver = page.doses;
      var any$result;
      any$break: do {
        var tmp$_1;
        if (Kotlin.isType($receiver, Collection) && $receiver.isEmpty()) {
          any$result = false;
          break any$break;
        }
        tmp$_1 = $receiver.iterator();
        while (tmp$_1.hasNext()) {
          var element = tmp$_1.next();
          if (element.isReceived || element.isScheduled) {
            any$result = true;
            break any$break;
          }
        }
        any$result = false;
      }
       while (false);
      var receivedOrScheduled = any$result;
      if (receivedOrScheduled) {
        notifications.addAll_brywnq$(this.getPageNotifications_0(record, page));
      }
       else {
        var collectionStatus = this.getDosesStatus_0(record, page.doses, influenzaVaccineConceptIds);
        switch (collectionStatus) {
          case 1:
            tmp$_0 = Str_getInstance().get_ge7pzc$(Id_getInstance().notification_is_approaching, [page.name]);
            break;
          case 0:
            var interval = this.getDateIntervalDescription_unjduw$(page.getPageDate(record));
            if (interval == null)
              tmp$_0 = Str_getInstance().get_ge7pzc$(Id_getInstance().notification_is_recommended_asap, [page.name]);
            else
              tmp$_0 = Str_getInstance().get_ge7pzc$(Id_getInstance().notification_is_overdue, [page.name, interval]);
            break;
          default:continue pageLoop;
        }
        var title = tmp$_0;
        notifications.add_11rb$(new Notification(record, title, collectionStatus, page));
      }
    }
    var firstOrNull$result;
    firstOrNull$break: do {
      var tmp$_2;
      tmp$_2 = pages.iterator();
      while (tmp$_2.hasNext()) {
        var element_0 = tmp$_2.next();
        if (equals(element_0.pageId, OtherPage$Companion_getInstance().TRAVEL_ID)) {
          firstOrNull$result = element_0;
          break firstOrNull$break;
        }
      }
      firstOrNull$result = null;
    }
     while (false);
    var travel = firstOrNull$result;
    if (travel != null) {
      notifications.addAll_brywnq$(this.getPageNotifications_0(record, travel));
    }
    var firstOrNull$result_0;
    firstOrNull$break: do {
      var tmp$_3;
      tmp$_3 = pages.iterator();
      while (tmp$_3.hasNext()) {
        var element_1 = tmp$_3.next();
        if (equals(element_1.pageId, OtherPage$Companion_getInstance().OTHER_ID)) {
          firstOrNull$result_0 = element_1;
          break firstOrNull$break;
        }
      }
      firstOrNull$result_0 = null;
    }
     while (false);
    var other = firstOrNull$result_0;
    if (other != null) {
      notifications.addAll_brywnq$(this.getPageNotifications_0(record, other));
    }
    return notifications;
  };
  NotificationManager.prototype.getRecordStatus = function (record, notifications) {
    var tmp$;
    var count$result;
    count$break: do {
      var tmp$_0;
      if (Kotlin.isType(notifications, Collection) && notifications.isEmpty()) {
        count$result = 0;
        break count$break;
      }
      var count = 0;
      tmp$_0 = notifications.iterator();
      while (tmp$_0.hasNext()) {
        var element = tmp$_0.next();
        if (element.status === 0) {
          count = count + 1 | 0;
        }
      }
      count$result = count;
    }
     while (false);
    var overdue = count$result;
    var count$result_0;
    count$break: do {
      var tmp$_1;
      if (Kotlin.isType(notifications, Collection) && notifications.isEmpty()) {
        count$result_0 = 0;
        break count$break;
      }
      var count_0 = 0;
      tmp$_1 = notifications.iterator();
      while (tmp$_1.hasNext()) {
        var element_0 = tmp$_1.next();
        if (element_0.status === 1) {
          count_0 = count_0 + 1 | 0;
        }
      }
      count$result_0 = count_0;
    }
     while (false);
    var approaching = count$result_0;
    if (overdue > 0)
      tmp$ = new Notification(record, Str_getInstance().get_ge7pzc$(Id_getInstance().notifications_status_overdue, [record.firstName, (overdue + approaching | 0).toString()]), 0);
    else if (approaching > 0)
      tmp$ = new Notification(record, Str_getInstance().get_ge7pzc$(Id_getInstance().notifications_status_approaching, [record.firstName, approaching.toString()]), 1);
    else
      tmp$ = new Notification(record, Str_getInstance().get_ge7pzc$(Id_getInstance().notifications_status_none, [record.firstName]), 2);
    return tmp$;
  };
  NotificationManager.prototype.getFluNotification = function (influenzaVaccineConceptIds, record, pages) {
    var tmp$, tmp$_0;
    if (record.birthdate.dateInMonths() < 6) {
      var year = record.birthdate.year;
      if (record.birthdate.monthValue > 5) {
        year = year + 1 | 0;
      }
      return new Notification(record, Str_getInstance().get_ge7pzc$(Id_getInstance().notification_flu_shot_young, [record.firstName, year]), 3);
    }
    var today = Date_getInstance().now_8be2vx$();
    if (today.monthValue > 9 || today.monthValue < 4) {
      var destination = ArrayList_init_0();
      var tmp$_1;
      tmp$_1 = pages.iterator();
      while (tmp$_1.hasNext()) {
        var element = tmp$_1.next();
        var list = element.doses;
        addAll(destination, list);
      }
      var destination_0 = ArrayList_init_0();
      var tmp$_2;
      tmp$_2 = destination.iterator();
      while (tmp$_2.hasNext()) {
        var element_0 = tmp$_2.next();
        if (influenzaVaccineConceptIds.contains_11rb$(element_0.concept().parentConceptId))
          destination_0.add_11rb$(element_0);
      }
      var fluDoses = toMutableList(destination_0);
      var approaching = false;
      var receivedThisSeason = false;
      tmp$ = fluDoses.iterator();
      while (tmp$.hasNext()) {
        var dose = tmp$.next();
        if (dose.isReceived) {
          var currentMonth = today.monthValue;
          var currentYear = today.year;
          var doseMonth = ensureNotNull(dose.date).monthValue;
          var doseYear = ensureNotNull(dose.date).year;
          if (currentMonth > 9 && doseYear === currentYear && doseMonth > 9) {
            receivedThisSeason = true;
            break;
          }
          if (currentMonth < 4 && (doseYear === (currentYear - 1 | 0) && doseMonth > 9 || doseYear === currentYear)) {
            receivedThisSeason = true;
            break;
          }
        }
         else if (this.getDoseStatus_0(record, dose) === 1) {
          approaching = true;
        }
      }
      var female = record.gender === 1;
      if (receivedThisSeason) {
        tmp$_0 = new Notification(record, Str_getInstance().get_ge7pzc$(female ? Id_getInstance().notification_flu_shot_received_female : Id_getInstance().notification_flu_shot_received_male, [record.firstName]), 2);
      }
       else
        tmp$_0 = new Notification(record, Str_getInstance().get_ge7pzc$(female ? Id_getInstance().notification_flu_shot_required_female : Id_getInstance().notification_flu_shot_required_male, [record.firstName]), approaching ? 1 : 0);
      return tmp$_0;
    }
    return new Notification(record, Str_getInstance().get_ge7pzc$(Id_getInstance().notification_flu_shot_fall_next, [record.firstName, today.year]), 3);
  };
  NotificationManager.prototype.getDiseaseDoses_0 = function (conceptIds, pages) {
    var doses = ArrayList_init_0();
    var destination = ArrayList_init_0();
    var tmp$;
    tmp$ = pages.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      var list = element.doses;
      addAll(destination, list);
    }
    var tmp$_0;
    tmp$_0 = destination.iterator();
    while (tmp$_0.hasNext()) {
      var element_0 = tmp$_0.next();
      var destination_0 = ArrayList_init_0();
      var tmp$_1;
      tmp$_1 = conceptIds.iterator();
      while (tmp$_1.hasNext()) {
        var element_1 = tmp$_1.next();
        if (element_0.concept().hasDiseaseConceptId_pdl1vj$(element_1))
          destination_0.add_11rb$(element_1);
      }
      var tmp$_2;
      tmp$_2 = destination_0.iterator();
      while (tmp$_2.hasNext()) {
        var element_2 = tmp$_2.next();
        doses.add_11rb$(element_0);
      }
    }
    return doses;
  };
  NotificationManager.prototype.getTetanusNotification = function (tetanusDiseaseConceptIds, record, pages) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    var tetanusDoses = this.getDiseaseDoses_0(tetanusDiseaseConceptIds, pages);
    var lastDose = null;
    var nextDose = null;
    tmp$ = tetanusDoses.iterator();
    while (tmp$.hasNext()) {
      var dose = tmp$.next();
      if (dose.isReceived) {
        if (lastDose == null || ((tmp$_0 = lastDose.date) != null ? tmp$_0.isBefore(ensureNotNull(dose.date)) : null) === true) {
          lastDose = dose;
        }
      }
       else if (dose.overallDate.isFuture) {
        if (nextDose == null || nextDose.overallDate.isAfter(dose.overallDate)) {
          nextDose = dose;
        }
      }
    }
    if (nextDose == null && lastDose == null) {
      tmp$_2 = new Notification(record, Str_getInstance().get_ge7pzc$(Id_getInstance().notifications_no_tetanus_vaccines, [record.firstName]), 3);
    }
     else if (nextDose == null) {
      tmp$_2 = new Notification(record, Str_getInstance().get_ge7pzc$(Id_getInstance().notifications_last_tetanus_on_date, [record.firstName, (tmp$_1 = lastDose != null ? lastDose.overallDate : null) != null ? tmp$_1.longDateString : null]), 3);
    }
     else if (lastDose == null) {
      tmp$_2 = new Notification(record, Str_getInstance().get_ge7pzc$(Id_getInstance().notifications_no_tetanus_vaccines, [record.firstName]) + ' ' + Str_getInstance().get_ge7pzc$(Id_getInstance().notifications_next_tetanus_on_date, [record.firstName, nextDose.overallDate.longDateString]), 3);
    }
     else {
      tmp$_2 = new Notification(record, Str_getInstance().get_ge7pzc$(Id_getInstance().notifications_last_tetanus_on_date, [record.firstName, lastDose.overallDate.longDateString]) + ' ' + Str_getInstance().get_ge7pzc$(Id_getInstance().notifications_next_tetanus_on_date, [record.firstName, nextDose.overallDate.longDateString]), 3);
    }
    return tmp$_2;
  };
  NotificationManager.prototype.getDiseaseTotals = function (concept, record, pages) {
    var tmp$;
    var doses = this.getDiseaseDoses_0(listOf(concept.conceptId), pages);
    var totalExpectedDoses = 0;
    var totalReceivedDoses = 0;
    var generators = ArrayList_init_0();
    tmp$ = doses.iterator();
    while (tmp$.hasNext()) {
      var dose = tmp$.next();
      var status = this.getDoseStatus_0(record, dose);
      if (status === 2) {
        totalReceivedDoses = totalReceivedDoses + 1 | 0;
      }
      var generator = dose.generator();
      if (generator != null && !contains(generators, dose.generatorId)) {
        totalExpectedDoses = totalExpectedDoses + generator.getExpectedDoses_tjuny1$(record) | 0;
        var generatorId = dose.generatorId;
        if (generatorId != null) {
          generators.add_11rb$(generatorId);
        }
      }
    }
    return new Pair(totalReceivedDoses, totalExpectedDoses);
  };
  NotificationManager.prototype.getDiseaseNotification = function (concept, record, pages) {
    var totals = this.getDiseaseTotals(concept, record, pages);
    var title = Str_getInstance().get_ge7pzc$(Id_getInstance().records_status_disease, [record.firstName, totals.first.toString(), concept.preferredTerm, record.region, totals.second.toString()]);
    var status = totals.second > totals.first ? 0 : 2;
    return new Notification(record, title, status, concept);
  };
  NotificationManager.prototype.getDateIntervalDescription_unjduw$ = function (date) {
    if (date == null)
      return null;
    var future = date.isFuture;
    var startDate = future ? Date_getInstance().now_8be2vx$() : date;
    var endDate = future ? date : Date_getInstance().now_8be2vx$();
    var years = startDate.dateInYears() - endDate.dateInYears() | 0;
    var months = startDate.dateInMonths() - endDate.dateInMonths() | 0;
    var weeks = startDate.dateInWeeks() - endDate.dateInWeeks() | 0;
    var unitStringId;
    var amount;
    if (years >= 1) {
      amount = years;
      unitStringId = years === 1 ? Id_getInstance().year : Id_getInstance().years;
    }
     else if (months >= 1) {
      amount = months;
      unitStringId = months === 1 ? Id_getInstance().month : Id_getInstance().months;
    }
     else if (weeks >= 1) {
      amount = weeks;
      unitStringId = weeks === 1 ? Id_getInstance().week : Id_getInstance().weeks;
    }
     else
      return null;
    return amount.toString() + ' ' + Str_getInstance().get_y4putb$(unitStringId);
  };
  NotificationManager.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'NotificationManager',
    interfaces: []
  };
  var NotificationManager_instance = null;
  function NotificationManager_getInstance() {
    if (NotificationManager_instance === null) {
      new NotificationManager();
    }
    return NotificationManager_instance;
  }
  function SchedulerManager() {
    SchedulerManager_instance = this;
  }
  function SchedulerManager$getPages$lambda(closure$type) {
    return function (o1, o2) {
      return o1.getPageIndex(closure$type) - o2.getPageIndex(closure$type) | 0;
    };
  }
  function Comparator$ObjectLiteral_7(closure$comparison) {
    this.closure$comparison = closure$comparison;
  }
  Comparator$ObjectLiteral_7.prototype.compare = function (a, b) {
    return this.closure$comparison(a, b);
  };
  Comparator$ObjectLiteral_7.$metadata$ = {kind: Kind_CLASS, interfaces: [Comparator]};
  SchedulerManager.prototype.getPages = function (pages, type, record) {
    if (type === -1) {
      return pages;
    }
    var destination = ArrayList_init_0();
    var tmp$;
    tmp$ = pages.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      if ((!record.isIgnoredPagesHidden || !element.isIgnored(record)) && element.isOnPage(type))
        destination.add_11rb$(element);
    }
    var recordPages = toMutableList(destination);
    sortWith(recordPages, new Comparator$ObjectLiteral_7(SchedulerManager$getPages$lambda(type)));
    return recordPages;
  };
  SchedulerManager.prototype.generatePages = function (record) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    var pages = ArrayList_init_0();
    var recordDoses = ArrayList_init_0();
    recordDoses.addAll_brywnq$(record.doses);
    var scheduleId = record.scheduleId;
    if (scheduleId != null) {
      var query = (new QueryBuilder(Type_getInstance().COLLECTION)).where_puj7f4$('scheduleId', scheduleId).and_puj7f4$('active');
      tmp$ = JavelinManager$Companion_getInstance().dm_8be2vx$.queryList(getKClass(GeneratorCollection), query).iterator();
      while (tmp$.hasNext()) {
        var collection = tmp$.next();
        var page = new CollectionPage(record, collection);
        query = (new QueryBuilder(Type_getInstance().GENERATOR)).where_puj7f4$('collectionId', collection.collectionId);
        tmp$_0 = JavelinManager$Companion_getInstance().dm_8be2vx$.queryList(getKClass(DoseGenerator), query).iterator();
        while (tmp$_0.hasNext()) {
          var generator = tmp$_0.next();
          var generatorDoses = this.getGeneratorDoses_0(recordDoses, generator);
          page.addDoses(generator.getDoses_9xc4wl$(record, generatorDoses));
        }
        if (page.hasDoses())
          pages.add_11rb$(page);
      }
    }
    var travelDoses = ArrayList_init_0();
    var otherDoses = ArrayList_init_0();
    var postSortingDoses = ArrayList_init_0();
    tmp$_1 = recordDoses.iterator();
    while (tmp$_1.hasNext()) {
      var dose = tmp$_1.next();
      switch (dose.pageId) {
        case '-2':
          travelDoses.add_11rb$(dose);
          break;
        case '-1':
          otherDoses.add_11rb$(dose);
          break;
        default:tmp$_2 = pages.iterator();
          while (tmp$_2.hasNext()) {
            var page_0 = tmp$_2.next();
            if (equals(page_0.pageId, dose.pageId)) {
              page_0.addDoses(listOf(dose));
              postSortingDoses.add_11rb$(dose);
              break;
            }
          }

          break;
      }
    }
    recordDoses.removeAll_brywnq$(travelDoses);
    recordDoses.removeAll_brywnq$(otherDoses);
    recordDoses.removeAll_brywnq$(postSortingDoses);
    otherDoses.addAll_brywnq$(recordDoses);
    pages.add_11rb$(new OtherPage(record, true, otherDoses));
    pages.add_11rb$(new OtherPage(record, false, travelDoses));
    return pages;
  };
  SchedulerManager.prototype.getGeneratorDoses_0 = function (doses, generator) {
    var tmp$;
    var generatorDoses = ArrayList_init_0();
    tmp$ = doses.iterator();
    while (tmp$.hasNext()) {
      var dose = tmp$.next();
      if (dose.generatorId != null && equals(dose.generatorId, generator.generatorId)) {
        generatorDoses.add_11rb$(dose);
      }
       else if (generator.isEquivalent_br4uqj$(dose.generator())) {
        generatorDoses.add_11rb$(dose);
      }
    }
    doses.removeAll_brywnq$(generatorDoses);
    return generatorDoses;
  };
  SchedulerManager.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'SchedulerManager',
    interfaces: []
  };
  var SchedulerManager_instance = null;
  function SchedulerManager_getInstance() {
    if (SchedulerManager_instance === null) {
      new SchedulerManager();
    }
    return SchedulerManager_instance;
  }
  function LocalNotificationInterface() {
  }
  LocalNotificationInterface.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'LocalNotificationInterface',
    interfaces: []
  };
  function LocalNotification(id, recordId, text, date) {
    this.id = id;
    this.recordId = recordId;
    this.text = text;
    this.date = date;
  }
  LocalNotification.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'LocalNotification',
    interfaces: []
  };
  function LocalNotificationManager(localNotificationInterface) {
    this.localNotificationInterface_0 = localNotificationInterface;
  }
  function LocalNotificationManager$generateNotifications$lambda(closure$holders, this$LocalNotificationManager) {
    return function (record) {
      closure$holders.addAll_brywnq$(this$LocalNotificationManager.createRecordNotifications_0(record));
      return Unit;
    };
  }
  function LocalNotificationManager$generateNotifications$lambda_0(o1, o2) {
    return o1.date.compareTo(o2.date);
  }
  function Comparator$ObjectLiteral_8(closure$comparison) {
    this.closure$comparison = closure$comparison;
  }
  Comparator$ObjectLiteral_8.prototype.compare = function (a, b) {
    return this.closure$comparison(a, b);
  };
  Comparator$ObjectLiteral_8.$metadata$ = {kind: Kind_CLASS, interfaces: [Comparator]};
  LocalNotificationManager.prototype.generateNotifications = function () {
    var tmp$, tmp$_0;
    var holders = ArrayList_init_0();
    if (JavelinManager$Companion_getInstance().instance_8be2vx$.platform === 1) {
      this.localNotificationInterface_0.cancelAllLocalNotifications();
    }
     else {
      tmp$ = this.localNotificationInterface_0.loadMaxNotificationIndex();
      for (var i = 0; i < tmp$; i++) {
        this.localNotificationInterface_0.cancelLocalNotification_za3lpa$(i);
      }
    }
    JavelinManager$Companion_getInstance().dm_8be2vx$.operateList(getKClass(Record), new QueryBuilder(Type_getInstance().RECORD), LocalNotificationManager$generateNotifications$lambda(holders, this));
    sortWith(holders, new Comparator$ObjectLiteral_8(LocalNotificationManager$generateNotifications$lambda_0));
    var size = holders.size > 50 ? 50 : holders.size;
    var notifications = ArrayList_init_0();
    for (var i_0 = 0; i_0 < size; i_0++) {
      var holder = holders.get_za3lpa$(i_0);
      notifications.add_11rb$(new LocalNotification(i_0, holder.recordId, holder.text, holder.date));
    }
    this.localNotificationInterface_0.saveMaxNotificationId_za3lpa$(size - 1 | 0);
    tmp$_0 = notifications.iterator();
    while (tmp$_0.hasNext()) {
      var notification = tmp$_0.next();
      this.localNotificationInterface_0.generateLocalNotification_nj2dov$(notification);
    }
  };
  LocalNotificationManager.prototype.cancelLocalNotifications = function () {
    var tmp$;
    if (JavelinManager$Companion_getInstance().instance_8be2vx$.platform === 1) {
      this.localNotificationInterface_0.cancelAllLocalNotifications();
    }
     else if (JavelinManager$Companion_getInstance().instance_8be2vx$.platform === 0) {
      tmp$ = this.localNotificationInterface_0.loadMaxNotificationIndex();
      for (var i = 0; i < tmp$; i++) {
        this.localNotificationInterface_0.cancelLocalNotification_za3lpa$(i);
      }
    }
  };
  function LocalNotificationManager$createRecordNotifications$lambda(o1, o2) {
    return o1.date.compareTo(o2.date);
  }
  function Comparator$ObjectLiteral_9(closure$comparison) {
    this.closure$comparison = closure$comparison;
  }
  Comparator$ObjectLiteral_9.prototype.compare = function (a, b) {
    return this.closure$comparison(a, b);
  };
  Comparator$ObjectLiteral_9.$metadata$ = {kind: Kind_CLASS, interfaces: [Comparator]};
  LocalNotificationManager.prototype.createRecordNotifications_0 = function (record) {
    var tmp$, tmp$_0, tmp$_1;
    var notifications = ArrayList_init_0();
    if (record.isChild) {
      tmp$ = 4;
    }
     else {
      tmp$ = 5;
    }
    var type = tmp$;
    var recordPages = SchedulerManager_getInstance().getPages(this.localNotificationInterface_0.getRecordPages_jho0x0$(record), type, record);
    tmp$_0 = recordPages.iterator();
    while (tmp$_0.hasNext()) {
      var page = tmp$_0.next();
      var $receiver = page.doses;
      var any$result;
      any$break: do {
        var tmp$_2;
        if (Kotlin.isType($receiver, Collection) && $receiver.isEmpty()) {
          any$result = false;
          break any$break;
        }
        tmp$_2 = $receiver.iterator();
        while (tmp$_2.hasNext()) {
          var element = tmp$_2.next();
          if (element.isReceived || element.isScheduled) {
            any$result = true;
            break any$break;
          }
        }
        any$result = false;
      }
       while (false);
      var receivedOrScheduled = any$result;
      if (receivedOrScheduled) {
        tmp$_1 = page.doses.iterator();
        while (tmp$_1.hasNext()) {
          var dose = tmp$_1.next();
          notifications.addAll_brywnq$(this.getDoseNotifications_0(record, dose));
        }
      }
       else {
        notifications.addAll_brywnq$(this.getPageNotifications_0(record, page));
      }
    }
    sortWith(notifications, new Comparator$ObjectLiteral_9(LocalNotificationManager$createRecordNotifications$lambda));
    var end = notifications.size > 50 ? 50 : notifications.size;
    return notifications.subList_vux9f0$(0, end);
  };
  LocalNotificationManager.prototype.getPageNotifications_0 = function (record, page) {
    var tmp$;
    var notifications = ArrayList_init_0();
    if (NotificationManager_getInstance().getPageStatus(record, page, emptyList()) !== 4) {
      tmp$ = page.getPageDate(record);
      if (tmp$ == null) {
        return notifications;
      }
      var pageDate = tmp$;
      var date = this.getDate_0(pageDate, true);
      if (date != null) {
        notifications.add_11rb$(new LocalNotificationManager$NotificationHolder(this, record.recordId, Str_getInstance().get_ge7pzc$(Id_getInstance().notification_visit_is_approaching, [record.firstName, page.name]), date));
      }
      date = this.getDate_0(pageDate, false);
      if (date != null) {
        notifications.add_11rb$(new LocalNotificationManager$NotificationHolder(this, record.recordId, Str_getInstance().get_ge7pzc$(Id_getInstance().notification_visit_is_overdue, [record.firstName, page.name]), date));
      }
    }
    return notifications;
  };
  LocalNotificationManager.prototype.getDoseNotifications_0 = function (record, dose) {
    var notifications = ArrayList_init_0();
    if (!dose.isIgnored(record)) {
      var date = this.getDate_0(dose.overallDate, true);
      if (date != null) {
        var text = Str_getInstance().get_ge7pzc$(Id_getInstance().notification_recommended_2_weeks, [dose.concept().abbreviation, record.firstName]);
        notifications.add_11rb$(new LocalNotificationManager$NotificationHolder(this, record.recordId, text, date));
      }
      date = this.getDate_0(dose.overallDate, false);
      if (date != null) {
        var text_0 = Str_getInstance().get_ge7pzc$(Id_getInstance().notification_recommended_for_asap, [dose.concept().abbreviation, record.firstName]);
        notifications.add_11rb$(new LocalNotificationManager$NotificationHolder(this, record.recordId, text_0, date));
      }
    }
    return notifications;
  };
  LocalNotificationManager.prototype.getDate_0 = function (date, isUpcoming) {
    var tmp$;
    if (isUpcoming) {
      tmp$ = date.minusWeeks(2);
    }
     else {
      tmp$ = date;
    }
    var aDate = tmp$;
    return aDate.isFuture ? aDate : null;
  };
  function LocalNotificationManager$NotificationHolder($outer, recordId, text, date) {
    this.$outer = $outer;
    this.recordId = recordId;
    this.text = text;
    this.date = date;
  }
  LocalNotificationManager$NotificationHolder.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'NotificationHolder',
    interfaces: []
  };
  LocalNotificationManager.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'LocalNotificationManager',
    interfaces: []
  };
  function SyncInterface() {
  }
  SyncInterface.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'SyncInterface',
    interfaces: []
  };
  function Account(accountId, lastSyncTimestamp, name, email, phone, isPushEnabled, isMFAEnabled, isPhoneVerified, consentVersion) {
    this.accountId = accountId;
    this.lastSyncTimestamp = lastSyncTimestamp;
    this.name = name;
    this.email = email;
    this.phone = phone;
    this.isPushEnabled = isPushEnabled;
    this.isMFAEnabled = isMFAEnabled;
    this.isPhoneVerified = isPhoneVerified;
    this.consentVersion = consentVersion;
  }
  Account.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Account',
    interfaces: []
  };
  function Lock() {
    Lock_instance = this;
    this.INVALID_TOKEN = 'INVALID_TOKEN';
    this.APP_UPDATE = 'APP_UPDATE';
    this.ERROR = 'ERROR';
  }
  Lock.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Lock',
    interfaces: []
  };
  var Lock_instance = null;
  function Lock_getInstance() {
    if (Lock_instance === null) {
      new Lock();
    }
    return Lock_instance;
  }
  function RequestCallback() {
  }
  RequestCallback.prototype.onSuccess = function (message, callback$default) {
    if (message === void 0)
      message = null;
    callback$default ? callback$default(message) : this.onSuccess$default(message);
  };
  RequestCallback.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'RequestCallback',
    interfaces: []
  };
  function ResponseCallback(callback) {
    this.callback_ehecz8$_0 = callback;
  }
  ResponseCallback.prototype.onFailure$default = function (stringId) {
    var tmp$;
    (tmp$ = this.callback_ehecz8$_0) != null ? (tmp$.onError(Error$Companion_getInstance().id(stringId)), Unit) : null;
  };
  ResponseCallback.prototype.onFailure = function (stringId, callback$default) {
    if (stringId === void 0)
      stringId = Id_getInstance().error_sync_general;
    callback$default ? callback$default(stringId) : this.onFailure$default(stringId);
  };
  ResponseCallback.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'ResponseCallback',
    interfaces: []
  };
  function SyncBroadcast() {
    SyncBroadcast_instance = this;
    this.LOCK = 'LOCK';
  }
  SyncBroadcast.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'SyncBroadcast',
    interfaces: []
  };
  var SyncBroadcast_instance = null;
  function SyncBroadcast_getInstance() {
    if (SyncBroadcast_instance === null) {
      new SyncBroadcast();
    }
    return SyncBroadcast_instance;
  }
  function Transaction() {
    this.transactionId = null;
    this.timestamp = null;
    this.recordId = null;
    this.objectId = null;
    this.objectType = 0;
    this.action = 0;
    this.field = null;
    this.newValue = null;
  }
  Transaction.prototype.clean = function () {
    Transaction_init_1(this);
    JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(Action_getInstance().DELETE, this);
  };
  Transaction.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Transaction',
    interfaces: []
  };
  function Transaction_init(transactionId, timestamp, recordId, objectId, objectType, action, field, newValue, $this) {
    $this = $this || Object.create(Transaction.prototype);
    Transaction.call($this);
    $this.transactionId = transactionId;
    $this.timestamp = timestamp;
    $this.recordId = recordId;
    $this.objectId = objectId;
    $this.objectType = objectType;
    $this.action = action;
    $this.field = field;
    $this.newValue = newValue;
    return $this;
  }
  function Transaction_init_0(recordId, objectId, objectType, action, field, value, $this) {
    $this = $this || Object.create(Transaction.prototype);
    Transaction.call($this);
    $this.transactionId = Help_getInstance().randomId();
    $this.timestamp = Date_getInstance().nowZoned_8be2vx$();
    $this.recordId = recordId;
    $this.objectId = objectId;
    $this.objectType = objectType;
    switch (action) {
      case 'CREATE':
        $this.action = 0;
        break;
      case 'UPDATE':
        $this.action = 1;
        break;
      case 'DELETE':
        $this.action = 2;
        break;
      default:throw new JavelinException('Unknown broadcast action: ' + action);
    }
    $this.field = field;
    if (value == null || equals(value, 'null')) {
      $this.newValue = null;
    }
     else {
      $this.newValue = value;
    }
    return $this;
  }
  function Transaction_init_1(transaction, $this) {
    $this = $this || Object.create(Transaction.prototype);
    Transaction_init(Help_getInstance().randomId(), transaction.timestamp, transaction.recordId, transaction.objectId, transaction.objectType, transaction.action, transaction.field, transaction.newValue, $this);
    JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(Action_getInstance().CREATE, $this);
    return $this;
  }
  function Transaction_init_2(record, action, $this) {
    $this = $this || Object.create(Transaction.prototype);
    Transaction_init_0(record.recordId, record.recordId, 0, action, null, equals(action, Action_getInstance().CREATE) ? Json_getInstance().to_8ea4ql$(record) : record.recordId, $this);
    return $this;
  }
  function Transaction_init_3(record, field, $this) {
    $this = $this || Object.create(Transaction.prototype);
    Transaction_init_0(record.recordId, record.recordId, 0, Action_getInstance().UPDATE, field, Field_getInstance().getRecordField_ine9n2$(record, field), $this);
    return $this;
  }
  function Transaction_init_4(dose, action, $this) {
    $this = $this || Object.create(Transaction.prototype);
    Transaction_init_0(dose.recordId, dose.doseId, 1, action, null, equals(action, Action_getInstance().CREATE) ? Json_getInstance().to_8ea4ql$(dose) : dose.doseId, $this);
    return $this;
  }
  function Transaction_init_5(dose, field, $this) {
    $this = $this || Object.create(Transaction.prototype);
    Transaction_init_0(dose.recordId, dose.doseId, 1, Action_getInstance().UPDATE, field, Field_getInstance().getDoseField_oqmg62$(dose, field), $this);
    return $this;
  }
  function Transaction_init_6(consent, action, $this) {
    $this = $this || Object.create(Transaction.prototype);
    Transaction_init_0(consent.parentId, consent.consentId, 3, action, null, equals(action, Action_getInstance().DELETE) ? consent.consentId : Json_getInstance().to_8ea4ql$(consent), $this);
    return $this;
  }
  function Transaction_init_7(integration, action, $this) {
    $this = $this || Object.create(Transaction.prototype);
    Transaction_init_0(integration.recordId, integration.integrationId, 2, action, null, equals(action, Action_getInstance().DELETE) ? integration.integrationId : Json_getInstance().to_8ea4ql$(integration), $this);
    return $this;
  }
  function Transaction_init_8(field, newValue, $this) {
    $this = $this || Object.create(Transaction.prototype);
    Transaction_init_0(null, null, 4, Action_getInstance().UPDATE, field, newValue, $this);
    return $this;
  }
  function AccountValidation() {
    AccountValidation_instance = this;
  }
  AccountValidation.prototype.validatePassword_pdl1vj$ = function (password) {
    var tmp$;
    var tmp$_0;
    if (password != null) {
      var tmp$_1;
      tmp$_0 = trim(Kotlin.isCharSequence(tmp$_1 = password) ? tmp$_1 : throwCCE()).toString();
    }
     else
      tmp$_0 = null;
    var passwordClean = (tmp$ = tmp$_0) != null ? tmp$ : '';
    if (passwordClean.length === 0) {
      return Error$Companion_getInstance().id(Id_getInstance().error_password);
    }
    if (passwordClean.length > 20)
      return Error$Companion_getInstance().id(Id_getInstance().error_password);
    else if (passwordClean.length < 8)
      return Error$Companion_getInstance().id(Id_getInstance().error_password);
    var hasUppercase = Regex_init('^.*[A-Z].*$').matches_6bul2c$(passwordClean);
    var hasLowercase = Regex_init('^.*[a-z].*$').matches_6bul2c$(passwordClean);
    var hasNumber = Regex_init('^.*[0-9].*$').matches_6bul2c$(passwordClean);
    var hasSpace = contains_0(passwordClean, ' ');
    if (!hasUppercase || !hasLowercase || !hasNumber || hasSpace) {
      return Error$Companion_getInstance().id(Id_getInstance().error_password);
    }
    return null;
  };
  AccountValidation.prototype.validateNewPassword_rkkr90$ = function (password, confirmPassword) {
    var tmp$;
    if (confirmPassword != null) {
      var tmp$_0;
      tmp$ = trim(Kotlin.isCharSequence(tmp$_0 = confirmPassword) ? tmp$_0 : throwCCE()).toString();
    }
     else
      tmp$ = null;
    var confirmPasswordClean = tmp$;
    var error = this.validatePassword_pdl1vj$(password);
    if (error != null) {
      return Error$Companion_getInstance().id(Id_getInstance().error_password_rules);
    }
    if (confirmPasswordClean == null || confirmPasswordClean.length === 0) {
      return Error$Companion_getInstance().id(Id_getInstance().error_password_confirm);
    }
    if (!equals(password, confirmPasswordClean)) {
      return Error$Companion_getInstance().id(Id_getInstance().error_password_confirm);
    }
    return null;
  };
  AccountValidation.prototype.validateName_pdl1vj$ = function (name) {
    if (name == null || name.length === 0) {
      return Error$Companion_getInstance().id(Id_getInstance().error_name);
    }
    return null;
  };
  AccountValidation.prototype.validateAccountInfo = function (name, email, password, confirmPassword) {
    var tmp$, tmp$_0;
    return (tmp$_0 = (tmp$ = this.validateName_pdl1vj$(name)) != null ? tmp$ : Validation_getInstance().validateEmail(email)) != null ? tmp$_0 : this.validateNewPassword_rkkr90$(password, confirmPassword);
  };
  AccountValidation.prototype.validateLocation = function (postalCode, city, country) {
    if (postalCode === void 0)
      postalCode = null;
    if (city === void 0)
      city = null;
    if (country === void 0)
      country = null;
    var tmp$, tmp$_0;
    var tmp$_1;
    if (postalCode != null) {
      var tmp$_2;
      tmp$_1 = trim(Kotlin.isCharSequence(tmp$_2 = postalCode) ? tmp$_2 : throwCCE()).toString();
    }
     else
      tmp$_1 = null;
    var postalCodeClean = (tmp$_0 = (tmp$ = tmp$_1) != null ? tmp$.toUpperCase() : null) != null ? tmp$_0 : '';
    if (postalCodeClean.length === 0 && city == null && country == null) {
      return Error$Companion_getInstance().id(Id_getInstance().error_location);
    }
    if (city == null && country == null) {
      var pattern = Regex_init('^[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJKLMNPRSTVWXYZ]$');
      if (!pattern.matches_6bul2c$(postalCodeClean)) {
        return Error$Companion_getInstance().id(Id_getInstance().error_location);
      }
    }
    return null;
  };
  AccountValidation.prototype.validatePostalCodeAndCity_706umf$ = function (postalCode, city) {
    return this.validateLocation(postalCode, city);
  };
  AccountValidation.prototype.validateCountry_a9c2cf$ = function (country) {
    if (this.validateLocation(void 0, void 0, country) != null) {
      return Error$Companion_getInstance().id(Id_getInstance().error_country);
    }
    return null;
  };
  AccountValidation.prototype.validatePhone_pdl1vj$ = function (phone) {
    if (!Validation_getInstance().isPhoneValid(phone)) {
      return Error$Companion_getInstance().id(Id_getInstance().error_phone);
    }
    return null;
  };
  AccountValidation.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'AccountValidation',
    interfaces: []
  };
  var AccountValidation_instance = null;
  function AccountValidation_getInstance() {
    if (AccountValidation_instance === null) {
      new AccountValidation();
    }
    return AccountValidation_instance;
  }
  function RequestType(name, ordinal) {
    Enum.call(this);
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function RequestType_initFields() {
    RequestType_initFields = function () {
    };
    RequestType$GET_instance = new RequestType('GET', 0);
    RequestType$POST_instance = new RequestType('POST', 1);
    RequestType$PUT_instance = new RequestType('PUT', 2);
  }
  var RequestType$GET_instance;
  function RequestType$GET_getInstance() {
    RequestType_initFields();
    return RequestType$GET_instance;
  }
  var RequestType$POST_instance;
  function RequestType$POST_getInstance() {
    RequestType_initFields();
    return RequestType$POST_instance;
  }
  var RequestType$PUT_instance;
  function RequestType$PUT_getInstance() {
    RequestType_initFields();
    return RequestType$PUT_instance;
  }
  RequestType.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'RequestType',
    interfaces: [Enum]
  };
  function RequestType$values() {
    return [RequestType$GET_getInstance(), RequestType$POST_getInstance(), RequestType$PUT_getInstance()];
  }
  RequestType.values = RequestType$values;
  function RequestType$valueOf(name) {
    switch (name) {
      case 'GET':
        return RequestType$GET_getInstance();
      case 'POST':
        return RequestType$POST_getInstance();
      case 'PUT':
        return RequestType$PUT_getInstance();
      default:throwISE('No enum constant ca.ohri.javelin.sync.util.RequestType.' + name);
    }
  }
  RequestType.valueOf_61zpoe$ = RequestType$valueOf;
  function SyncManager(syncInterface) {
    this.syncInterface_0 = syncInterface;
    this.log_0 = new Logger('SyncManager');
  }
  SyncManager.prototype.onBroadcastReceived = function (action, obj, fields) {
    var tmp$, tmp$_0;
    if (!this.isLoggedIn) {
      return;
    }
    if (Kotlin.isType(obj, Record)) {
      if (equals(action, Action_getInstance().CREATE) || equals(action, Action_getInstance().DELETE)) {
        this.addTransaction_0(Transaction_init_2(obj, action), obj.recordId, true);
      }
       else {
        var destination = ArrayList_init_0();
        var tmp$_1;
        tmp$_1 = fields.iterator();
        while (tmp$_1.hasNext()) {
          var item = tmp$_1.next();
          destination.add_11rb$(Transaction_init_3(obj, item));
        }
        var transactions = destination;
        this.addTransactions_0(transactions, obj.recordId, true);
      }
    }
     else if (Kotlin.isType(obj, Dose)) {
      if (equals(action, Action_getInstance().CREATE) || equals(action, Action_getInstance().DELETE)) {
        this.addTransaction_0(Transaction_init_4(obj, action), obj.recordId, true);
      }
       else {
        var destination_0 = ArrayList_init_0();
        var tmp$_2;
        tmp$_2 = fields.iterator();
        while (tmp$_2.hasNext()) {
          var item_0 = tmp$_2.next();
          destination_0.add_11rb$(Transaction_init_5(obj, item_0));
        }
        var transactions_0 = destination_0;
        this.addTransactions_0(transactions_0, obj.recordId, true);
      }
    }
     else if (Kotlin.isType(obj, Consent)) {
      if (equals(obj.name, Consent$Name_getInstance().RECORD)) {
        tmp$ = Transaction_init_6(obj, action);
        var tmp$_3;
        if ((tmp$_0 = obj.parentId) != null)
          tmp$_3 = tmp$_0;
        else {
          throw IllegalStateException_init('ParentId on Consent is null'.toString());
        }
        this.addTransaction_0(tmp$, tmp$_3, false);
      }
    }
     else if (Kotlin.isType(obj, PHUIntegration)) {
      this.addTransaction_0(Transaction_init_7(obj, action), obj.recordId, true);
    }
  };
  SyncManager.prototype.addTransaction_0 = function (transaction, recordId, sync) {
    this.addTransactions_0(listOf(transaction), recordId, sync);
  };
  SyncManager.prototype.addTransactions_0 = function (transactions, recordId, sync) {
    var tmp$;
    tmp$ = transactions.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().CREATE, element);
    }
    if (sync) {
      this.initiateSync(recordId, false);
    }
  };
  SyncManager.prototype.genericError_0 = function (error) {
    if (error === void 0)
      error = null;
    if (error == null) {
      return Error$Companion_getInstance().id(Id_getInstance().error_sync_general);
    }
    return Error$Companion_getInstance().string(Str_getInstance().get_ge7pzc$(Id_getInstance().error_sync_general_message, [error]));
  };
  Object.defineProperty(SyncManager.prototype, 'isLocked', {
    get: function () {
      var locked = JavelinManager$Companion_getInstance().instance_8be2vx$.simpleBroadcast(SyncType$Simple_getInstance().LOCK, Action_getInstance().READ, null) != null;
      if (locked) {
        JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(SyncBroadcast_getInstance().LOCK);
      }
      return locked;
    }
  });
  SyncManager.prototype.parseResponse_0 = function (endpoint, code, body) {
    var tmp$, tmp$_0;
    this.log_0.i_y4putb$('Call: ' + endpoint + ', Response: ' + code);
    switch (code) {
      case 200:
      case 202:
        tmp$_0 = null;
        break;
      case 400:
        try {
          tmp$ = Json_getInstance().from_z6hou8$(body, PrimitiveClasses$stringClass, 'message');
        }
         catch (e) {
          if (Kotlin.isType(e, Exception)) {
            this.log_0.e_8o0b5c$(Kotlin.newThrowable('Error parsing error message', e));
            return this.genericError_0('JsonError');
          }
           else
            throw e;
        }

        var error = tmp$;
        switch (error) {
          case 'MissingDeviceInfo':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_sync_device);
            break;
          case 'PasswordInvalid':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_password);
            break;
          case 'NotFound':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_sync_not_found);
            break;
          case 'AccountDisabled':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_disabled);
            break;
          case 'EmailNotVerified':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_verify_email);
            break;
          case 'CodeInvalid':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_code_invalid);
            break;
          case 'EmailInvalid':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_email);
            break;
          case 'OldPasswordInvalid':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_old_password);
            break;
          case 'EmailTaken':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_sync_email_taken);
            break;
          case 'NameInvalid':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_name);
            break;
          case 'ConsentNotValid':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_sync_consent);
            break;
          case 'MissingLocation':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_sync_location);
            break;
          case 'CountryInvalid':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_country);
            break;
          case 'SpokenLanguageInvalid':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_spoken_language);
            break;
          case 'InvalidPhone':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_phone);
            break;
          case 'AccountLocked':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_locked);
            break;
          case 'AccountPendingDelete':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_pending_delete);
            break;
          case 'AccountNotLocked':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_unlocked);
            break;
          case 'AccountUnlockRequestExpired':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_locked_expired);
            break;
          case 'CodeMismatchException':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_verification_code);
            break;
          case 'UserNotFoundException':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_verification_not_found);
            break;
          case 'ExpiredCodeException':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_verification_expired);
            break;
          case 'NotAuthorizedException':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_verification_not_authorized);
            break;
          case 'ExpiredCode':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_reset_code_expired);
            break;
          case 'RateLimitExceeded':
            tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_too_many_attempts);
            break;
          case 'UpdateRequired':
            JavelinManager$Companion_getInstance().instance_8be2vx$.simpleBroadcast(SyncType$Simple_getInstance().LOCK, Action_getInstance().UPDATE, Lock_getInstance().APP_UPDATE);
            JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(SyncBroadcast_getInstance().LOCK);
            tmp$_0 = this.genericError_0();
            break;
          default:tmp$_0 = this.genericError_0(error);
            break;
        }

        break;
      case 403:
        JavelinManager$Companion_getInstance().instance_8be2vx$.simpleBroadcast(SyncType$Simple_getInstance().LOCK, Action_getInstance().UPDATE, Lock_getInstance().INVALID_TOKEN);
        JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(SyncBroadcast_getInstance().LOCK);
        tmp$_0 = this.genericError_0();
        break;
      case 503:
        tmp$_0 = Error$Companion_getInstance().id(Id_getInstance().error_sync_maintenance);
        break;
      default:tmp$_0 = this.genericError_0();
        break;
    }
    return tmp$_0;
  };
  Object.defineProperty(SyncManager.prototype, 'deviceJson_0', {
    get: function () {
      var json = LinkedHashMap_init();
      var key = 'deviceId';
      var value = JavelinManager$Companion_getInstance().instance_8be2vx$.deviceId;
      json.put_xwzc9p$(key, value);
      var value_0 = JavelinManager$Companion_getInstance().instance_8be2vx$.deviceName;
      json.put_xwzc9p$('name', value_0);
      var value_1 = JavelinManager$Companion_getInstance().instance_8be2vx$.deviceModel;
      json.put_xwzc9p$('model', value_1);
      var toLowerCase$result;
      toLowerCase$result = JavelinManager$Platform_getInstance().string.toLowerCase();
      var key_0 = 'platform';
      json.put_xwzc9p$(key_0, toLowerCase$result);
      return json;
    }
  });
  Object.defineProperty(SyncManager.prototype, 'params_0', {
    get: function () {
      return mapOf([to('platform', JavelinManager$Platform_getInstance().string.toLowerCase()), to('version', JavelinManager$Companion_getInstance().instance_8be2vx$.appVersion), to('buildType', JavelinManager$Companion_getInstance().instance_8be2vx$.buildType)]);
    }
  });
  SyncManager.prototype.getCookieString_0 = function (cookies) {
    if (cookies.isEmpty()) {
      this.log_0.e_ly7if3$('No tokens returned when logging in');
      return new Pair(this.genericError_0(), '');
    }
    this.log_0.i_y4putb$('Number of cookies: ' + cookies.size);
    return new Pair(null, joinToString(cookies, ';'));
  };
  SyncManager.prototype.getCookieString = function () {
    return JavelinManager$Companion_getInstance().instance_8be2vx$.simpleBroadcast(SyncType$Simple_getInstance().TOKEN, Action_getInstance().READ, null);
  };
  Object.defineProperty(SyncManager.prototype, 'account_0', {
    get: function () {
      var account = JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(Account), new QueryBuilder(SyncType_getInstance().ACCOUNT));
      if (account == null && this.isLoggedIn) {
        this.log_0.e_ly7if3$('Account was null');
        JavelinManager$Companion_getInstance().instance_8be2vx$.simpleBroadcast(SyncType$Simple_getInstance().LOCK, Action_getInstance().UPDATE, Lock_getInstance().ERROR);
        JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(SyncBroadcast_getInstance().LOCK);
      }
      return account;
    }
  });
  function SyncManager$makeRequest$ObjectLiteral(closure$endpoint, this$SyncManager, closure$callback, closure$success, callback) {
    this.closure$endpoint = closure$endpoint;
    this.this$SyncManager = this$SyncManager;
    this.closure$callback = closure$callback;
    this.closure$success = closure$success;
    ResponseCallback.call(this, callback);
  }
  SyncManager$makeRequest$ObjectLiteral.prototype.onSuccess = function (code, body, cookies) {
    var tmp$;
    var error = this.this$SyncManager.parseResponse_0(this.closure$endpoint, code, body);
    if (error != null) {
      (tmp$ = this.closure$callback) != null ? (tmp$.onError(error), Unit) : null;
    }
     else {
      this.closure$success(code, body, cookies);
    }
  };
  SyncManager$makeRequest$ObjectLiteral.$metadata$ = {
    kind: Kind_CLASS,
    interfaces: [ResponseCallback]
  };
  SyncManager.prototype.makeRequest_0 = function (type, endpoint, cookies, initialParams, body, callback, success) {
    var params = toMutableMap(this.params_0);
    if (initialParams != null) {
      params.putAll_a2k3zr$(initialParams);
    }
    this.syncInterface_0.makeRequest(type, endpoint, cookies, params, body, new SyncManager$makeRequest$ObjectLiteral(endpoint, this, callback, success, callback));
  };
  SyncManager.prototype.saveAccount_0 = function (body, action, shouldUpdate) {
    var account = Json_getInstance().from_z6hou8$(body, getKClass(Account), 'account');
    if (account == null) {
      this.log_0.e_ly7if3$('Error getting account from body');
      return;
    }
    var oldAccount = JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(Account), new QueryBuilder(SyncType_getInstance().ACCOUNT));
    if (oldAccount != null && !equals(oldAccount.accountId, account.accountId)) {
      this.clearRecordsAndTransactions_0(true);
      JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().DELETE, oldAccount);
    }
    JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(action, account);
    if (shouldUpdate) {
      JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().UI_UPDATE, SyncType_getInstance().ACCOUNT);
    }
  };
  SyncManager.prototype.saveLoginInfo_0 = function (password, body, cookies, callback) {
    JavelinManager$Companion_getInstance().instance_8be2vx$.simpleBroadcast(SyncType$Simple_getInstance().PASSWORD, Action_getInstance().CREATE, password);
    var tmp$ = this.getCookieString_0(cookies);
    var error = tmp$.component1()
    , token = tmp$.component2();
    if (error != null) {
      callback.onError(error);
      return;
    }
    JavelinManager$Companion_getInstance().instance_8be2vx$.simpleBroadcast(SyncType$Simple_getInstance().TOKEN, Action_getInstance().CREATE, token);
    this.saveAccount_0(body, Action_getInstance().CREATE, false);
    var $receiver = JavelinManager$Companion_getInstance().dm_8be2vx$.queryList(getKClass(Record), new QueryBuilder(Type_getInstance().RECORD));
    var destination = ArrayList_init_0();
    var tmp$_0;
    tmp$_0 = $receiver.iterator();
    while (tmp$_0.hasNext()) {
      var element = tmp$_0.next();
      if (element.lastSyncTimestamp == null)
        destination.add_11rb$(element);
    }
    var tmp$_1;
    tmp$_1 = destination.iterator();
    while (tmp$_1.hasNext()) {
      var element_0 = tmp$_1.next();
      this.onBroadcastReceived(Action_getInstance().CREATE, element_0, ArrayList_init_0());
    }
    this.refreshRecords();
    callback.onSuccess();
  };
  function SyncManager$login$lambda(closure$password, closure$callback, this$SyncManager) {
    return function (code, responseBody, cookies) {
      JavelinManager$Companion_getInstance().instance_8be2vx$.simpleBroadcast(SyncType$Simple_getInstance().LOCK, Action_getInstance().DELETE, null);
      switch (code) {
        case 200:
          this$SyncManager.saveLoginInfo_0(closure$password, responseBody, cookies, closure$callback);
          break;
        case 202:
          var tmp$ = this$SyncManager.getCookieString_0(cookies);
          var cookieError = tmp$.component1()
          , tokens = tmp$.component2();
          if (cookieError != null) {
            closure$callback.onError(cookieError);
          }
           else {
            closure$callback.onSuccess(Success$Companion_getInstance().success(tokens));
          }

          break;
      }
      return Unit;
    };
  }
  SyncManager.prototype.login = function (email, password, callback) {
    var tmp$;
    var e = (tmp$ = AccountValidation_getInstance().validatePassword_pdl1vj$(password)) != null ? tmp$ : Validation_getInstance().validateEmail(email);
    if (e != null) {
      callback.onError(e);
      return;
    }
    var body = LinkedHashMap_init();
    body.put_xwzc9p$('email', email);
    var key = 'password';
    var value = ensureNotNull(password);
    body.put_xwzc9p$(key, value);
    var value_0 = this.deviceJson_0;
    body.put_xwzc9p$('device', value_0);
    var jsonBody = Json_getInstance().to_8ea4ql$(body);
    if (jsonBody == null) {
      callback.onError(this.genericError_0());
      return;
    }
    this.makeRequest_0(RequestType$POST_getInstance(), 'login', null, null, jsonBody, callback, SyncManager$login$lambda(password, callback, this));
  };
  function SyncManager$verifyMFA$lambda(closure$password, closure$callback, this$SyncManager) {
    return function (f, responseBody, cookies) {
      this$SyncManager.saveLoginInfo_0(closure$password, responseBody, cookies, closure$callback);
      return Unit;
    };
  }
  SyncManager.prototype.verifyMFA = function (cookieString, password, code, callback) {
    var e = this.validateMFACode_0(code);
    if (e != null) {
      callback.onError(e);
      return;
    }
    var body = LinkedHashMap_init();
    body.put_xwzc9p$('code', code);
    var jsonBody = Json_getInstance().to_8ea4ql$(body);
    if (jsonBody == null) {
      callback.onError(this.genericError_0());
      return;
    }
    this.makeRequest_0(RequestType$POST_getInstance(), 'login-mfa', cookieString, null, jsonBody, callback, SyncManager$verifyMFA$lambda(password, callback, this));
  };
  function SyncManager$forgotPassword$lambda(closure$callback) {
    return function (f, f_0, f_1) {
      closure$callback.onSuccess(Success$Companion_getInstance().thankYouId(Id_getInstance().success_reset_password));
      return Unit;
    };
  }
  SyncManager.prototype.forgotPassword = function (email, callback) {
    var e = Validation_getInstance().validateEmail(email);
    if (e != null) {
      callback.onError(e);
      return;
    }
    var body = LinkedHashMap_init();
    body.put_xwzc9p$('email', email);
    var jsonBody = Json_getInstance().to_8ea4ql$(body);
    if (jsonBody == null) {
      callback.onError(this.genericError_0());
      return;
    }
    this.makeRequest_0(RequestType$POST_getInstance(), 'forgot-password', null, null, jsonBody, callback, SyncManager$forgotPassword$lambda(callback));
  };
  function SyncManager$resetPassword$lambda(closure$callback) {
    return function (f, f_0, f_1) {
      closure$callback.onSuccess(Success$Companion_getInstance().thankYouId(Id_getInstance().password_reset_success));
      return Unit;
    };
  }
  SyncManager.prototype.resetPassword = function (email, code, newPassword, confirmNewPassword, callback) {
    if (Validation_getInstance().validateEmail(email) != null) {
      callback.onError(Error$Companion_getInstance().id(Id_getInstance().error_general));
      return;
    }
    if (code == null || isBlank(code)) {
      callback.onError(Error$Companion_getInstance().id(Id_getInstance().error_general));
      return;
    }
    var e = AccountValidation_getInstance().validateNewPassword_rkkr90$(newPassword, confirmNewPassword);
    if (e != null) {
      callback.onError(e);
      return;
    }
    var body = LinkedHashMap_init();
    body.put_xwzc9p$('email', email);
    body.put_xwzc9p$('code', code);
    var key = 'newPassword';
    body.put_xwzc9p$(key, newPassword);
    var jsonBody = Json_getInstance().to_8ea4ql$(body);
    if (jsonBody == null) {
      callback.onError(this.genericError_0());
      return;
    }
    this.makeRequest_0(RequestType$PUT_getInstance(), 'forgot-password', null, null, jsonBody, callback, SyncManager$resetPassword$lambda(callback));
  };
  function SyncManager$checkEmailAvailability$lambda(closure$callback) {
    return function (f, f_0, f_1) {
      closure$callback.onSuccess();
      return Unit;
    };
  }
  SyncManager.prototype.checkEmailAvailability = function (email, callback) {
    var e = Validation_getInstance().validateEmail(email);
    if (e != null) {
      callback.onError(e);
      return;
    }
    var body = LinkedHashMap_init();
    body.put_xwzc9p$('email', email);
    var jsonBody = Json_getInstance().to_8ea4ql$(body);
    if (jsonBody == null) {
      callback.onError(this.genericError_0());
      return;
    }
    this.makeRequest_0(RequestType$POST_getInstance(), 'check-email-availability', null, null, jsonBody, callback, SyncManager$checkEmailAvailability$lambda(callback));
  };
  function SyncManager$signUp$lambda(closure$callback) {
    return function (f, f_0, f_1) {
      closure$callback.onSuccess(Success$Companion_getInstance().successId(Id_getInstance().success_sign_up));
      return Unit;
    };
  }
  SyncManager.prototype.signUp = function (name, email, password, consentDate, postalCode, city, country, callback) {
    var tmp$;
    var postalCodeLocal = postalCode != null ? postalCode.toUpperCase() : null;
    var cityLocal = city;
    var e = (tmp$ = AccountValidation_getInstance().validateLocation(postalCodeLocal, cityLocal, country)) != null ? tmp$ : AccountValidation_getInstance().validateAccountInfo(name, email, password, password);
    if (e != null) {
      callback.onError(e);
      return;
    }
    if (consentDate == null) {
      callback.onError(Error$Companion_getInstance().id(Id_getInstance().error_sync_consent));
      return;
    }
    if (country != null) {
      cityLocal = null;
      postalCodeLocal = null;
    }
     else if (cityLocal != null) {
      postalCodeLocal = null;
    }
    var body = LinkedHashMap_init();
    body.put_xwzc9p$('email', email);
    body.put_xwzc9p$('name', name);
    var key = 'password';
    body.put_xwzc9p$(key, password);
    var consents = listOf(Consent_init(null, SyncType_getInstance().ACCOUNT, Consent$Name_getInstance().SYNC, consentDate, 2));
    var key_0 = 'consents';
    body.put_xwzc9p$(key_0, consents);
    var key_1 = 'language';
    var value = Language_getInstance().get_8be2vx$();
    body.put_xwzc9p$(key_1, value);
    var key_2 = 'postalCode';
    var value_0 = postalCodeLocal;
    body.put_xwzc9p$(key_2, value_0);
    var key_3 = 'language';
    var value_1 = JavelinManager$Companion_getInstance().instance_8be2vx$.language;
    body.put_xwzc9p$(key_3, value_1);
    var value_2 = this.deviceJson_0;
    body.put_xwzc9p$('device', value_2);
    var key_4 = 'isPushEnabled';
    body.put_xwzc9p$(key_4, false);
    if (cityLocal != null) {
      var value_3 = cityLocal.cityId;
      body.put_xwzc9p$('city', value_3);
    }
    if (country != null) {
      var value_4 = country.code;
      body.put_xwzc9p$('country', value_4);
    }
    var jsonBody = Json_getInstance().to_8ea4ql$(body);
    if (jsonBody == null) {
      callback.onError(this.genericError_0());
      return;
    }
    this.makeRequest_0(RequestType$POST_getInstance(), 'signup', null, null, jsonBody, callback, SyncManager$signUp$lambda(callback));
  };
  function SyncManager$confirmAccount$lambda(closure$callback) {
    return function (f, f_0, f_1) {
      closure$callback.onSuccess(Success$Companion_getInstance().successId(Id_getInstance().success_verification));
      return Unit;
    };
  }
  SyncManager.prototype._confirmAccount = function (params, callback) {
    if (params == null || params.isEmpty()) {
      callback.onError(Error$Companion_getInstance().id(Id_getInstance().error_general));
      return;
    }
    this.makeRequest_0(RequestType$GET_getInstance(), 'confirm', null, params, null, callback, SyncManager$confirmAccount$lambda(callback));
  };
  function SyncManager$unlockAccount$lambda(closure$callback) {
    return function (f, f_0, f_1) {
      closure$callback.onSuccess(Success$Companion_getInstance().successId(Id_getInstance().success_unlock));
      return Unit;
    };
  }
  SyncManager.prototype.unlockAccount_wuzsy0$ = function (requestId, callback) {
    var tmp$ = requestId == null;
    if (!tmp$) {
      tmp$ = requestId.length === 0;
    }
    if (tmp$) {
      callback.onError(Error$Companion_getInstance().id(Id_getInstance().error_general));
      return;
    }
    var params = mutableMapOf([to('requestId', requestId)]);
    this.makeRequest_0(RequestType$GET_getInstance(), 'unlock-account', null, params, null, callback, SyncManager$unlockAccount$lambda(callback));
  };
  function SyncManager$resendEmail$lambda(closure$callback, closure$isVerify) {
    return function (f, f_0, f_1) {
      closure$callback.onSuccess(Success$Companion_getInstance().successId(closure$isVerify ? Id_getInstance().success_verify_email : Id_getInstance().success_unlock_email));
      return Unit;
    };
  }
  SyncManager.prototype.resendEmail_0 = function (isVerify, email, callback) {
    var e = Validation_getInstance().validateEmail(email);
    if (e != null) {
      callback.onError(e);
      return;
    }
    var body = LinkedHashMap_init();
    body.put_xwzc9p$('email', email);
    var jsonBody = Json_getInstance().to_8ea4ql$(body);
    if (jsonBody == null) {
      callback.onError(this.genericError_0());
      return;
    }
    var endpoint = isVerify ? 'resend-verify-email' : 'resend-unlock-account-email';
    this.makeRequest_0(RequestType$POST_getInstance(), endpoint, null, null, jsonBody, callback, SyncManager$resendEmail$lambda(callback, isVerify));
  };
  SyncManager.prototype.resendVerificationEmail = function (email, callback) {
    this.resendEmail_0(true, email, callback);
  };
  SyncManager.prototype.resendUnlockEmail = function (email, callback) {
    this.resendEmail_0(false, email, callback);
  };
  Object.defineProperty(SyncManager.prototype, 'isEnabled', {
    get: function () {
      return this.syncInterface_0.isEnabled;
    }
  });
  Object.defineProperty(SyncManager.prototype, 'isLoggedIn', {
    get: function () {
      var tmp$ = this.isEnabled;
      if (tmp$) {
        var $receiver = this.getCookieString();
        tmp$ = !($receiver == null || $receiver.length === 0);
      }
      return tmp$;
    }
  });
  SyncManager.prototype.unlock = function (password) {
    var error = AccountValidation_getInstance().validatePassword_pdl1vj$(password);
    if (error != null) {
      return error;
    }
    if (!equals(password, JavelinManager$Companion_getInstance().instance_8be2vx$.simpleBroadcast(SyncType$Simple_getInstance().PASSWORD, Action_getInstance().READ, null))) {
      return Error$Companion_getInstance().id(Id_getInstance().error_old_password);
    }
    return null;
  };
  SyncManager.prototype.clearLocal_6taknv$ = function (delete_0) {
    JavelinManager$Companion_getInstance().instance_8be2vx$.simpleBroadcast(SyncType$Simple_getInstance().PASSWORD, Action_getInstance().DELETE, null);
    JavelinManager$Companion_getInstance().instance_8be2vx$.simpleBroadcast(SyncType$Simple_getInstance().TOKEN, Action_getInstance().DELETE, null);
    JavelinManager$Companion_getInstance().instance_8be2vx$.simpleBroadcast(SyncType$Simple_getInstance().LOCK, Action_getInstance().DELETE, null);
    this.clearRecordsAndTransactions_0(delete_0);
    JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(Action_getInstance().DELETE, this.account_0);
  };
  function SyncManager$clearRecordsAndTransactions$lambda(closure$delete) {
    return function (record) {
      if (closure$delete)
        record.delete_vft4zs$(true);
      else
        record.fullClean();
      return Unit;
    };
  }
  SyncManager.prototype.clearRecordsAndTransactions_0 = function (delete_0) {
    JavelinManager$Companion_getInstance().dm_8be2vx$.operateList(getKClass(Record), new QueryBuilder(Type_getInstance().RECORD), SyncManager$clearRecordsAndTransactions$lambda(delete_0));
    JavelinManager$Companion_getInstance().dm_8be2vx$.deleteList(getKClass(Transaction), new QueryBuilder(SyncType_getInstance().TRANSACTION));
  };
  function SyncManager$logout$ObjectLiteral(this$SyncManager, closure$callback, callback) {
    this.this$SyncManager = this$SyncManager;
    this.closure$callback = closure$callback;
    ResponseCallback.call(this, callback);
  }
  SyncManager$logout$ObjectLiteral.prototype.onFailure$default = function (stringId) {
    this.finalizeLogout_0();
  };
  SyncManager$logout$ObjectLiteral.prototype.onSuccess = function (code, body, cookies) {
    this.finalizeLogout_0(code);
  };
  SyncManager$logout$ObjectLiteral.prototype.finalizeLogout_0 = function (code) {
    if (code === void 0)
      code = null;
    if (code !== 200) {
      this.this$SyncManager.log_0.e_ly7if3$('Code received during logout: ' + toString(code));
    }
    this.this$SyncManager.clearLocal_6taknv$(true);
    this.closure$callback.onSuccess();
  };
  SyncManager$logout$ObjectLiteral.$metadata$ = {
    kind: Kind_CLASS,
    interfaces: [ResponseCallback]
  };
  SyncManager.prototype.logout = function (callback) {
    this.syncInterface_0.makeRequest(RequestType$GET_getInstance(), 'logout', this.getCookieString(), this.params_0, null, new SyncManager$logout$ObjectLiteral(this, callback, null));
  };
  function SyncManager$deleteAccount$lambda(closure$callback) {
    return function (f, f_0, f_1) {
      closure$callback.onSuccess(Success$Companion_getInstance().successId(Id_getInstance().delete_account_success));
      return Unit;
    };
  }
  SyncManager.prototype.deleteAccount = function (message, callback) {
    var body = LinkedHashMap_init();
    body.put_xwzc9p$('message', message);
    var jsonBody = Json_getInstance().to_8ea4ql$(body);
    if (jsonBody == null) {
      callback.onError(this.genericError_0());
      return;
    }
    this.makeRequest_0(RequestType$POST_getInstance(), 'delete/request', this.getCookieString(), null, jsonBody, callback, SyncManager$deleteAccount$lambda(callback));
  };
  function SyncManager$updateAccount$lambda(this$SyncManager, closure$callback) {
    return function (f, responseBody, f_0) {
      var tmp$, tmp$_0, tmp$_1;
      if (Json_getInstance().from_z6hou8$(responseBody, getKClass(Account), 'account') != null) {
        tmp$ = Action_getInstance().UPDATE;
        tmp$_1 = (tmp$_0 = Json_getInstance().from_z6hou8$(responseBody, PrimitiveClasses$booleanClass, 'shouldUpdate')) != null ? tmp$_0 : false;
        this$SyncManager.saveAccount_0(responseBody, tmp$, tmp$_1);
      }
       else {
        this$SyncManager.log_0.e_ly7if3$('Received account from server was null');
      }
      closure$callback != null ? (closure$callback.onSuccess(), Unit) : null;
      return Unit;
    };
  }
  SyncManager.prototype.updateAccount_0 = function (transaction, callback) {
    var tmp$;
    if (this.isLocked)
      return;
    tmp$ = this.account_0;
    if (tmp$ == null) {
      return;
    }
    var account = tmp$;
    var body = LinkedHashMap_init();
    var key = 'appVersion';
    var value = JavelinManager$Companion_getInstance().instance_8be2vx$.appVersion;
    body.put_xwzc9p$(key, value);
    var key_0 = 'accountId';
    var value_0 = account.accountId;
    body.put_xwzc9p$(key_0, value_0);
    var transactions = ArrayList_init_0();
    if (transaction != null) {
      transactions.add_11rb$(transaction);
    }
    var key_1 = 'transactions';
    body.put_xwzc9p$(key_1, transactions);
    var key_2 = 'lastSyncTimestamp';
    var value_1 = account.lastSyncTimestamp.string;
    body.put_xwzc9p$(key_2, value_1);
    var jsonBody = Json_getInstance().to_8ea4ql$(body);
    if (jsonBody == null) {
      callback != null ? (callback.onError(this.genericError_0()), Unit) : null;
      return;
    }
    this.makeRequest_0(RequestType$POST_getInstance(), 'settings/update-account', this.getCookieString(), null, jsonBody, callback, SyncManager$updateAccount$lambda(this, callback));
  };
  SyncManager.prototype.refreshAccount = function () {
    this.updateAccount_0(null, null);
  };
  SyncManager.prototype.updateName = function (name, callback) {
    var tmp$;
    var error = AccountValidation_getInstance().validateName_pdl1vj$(name);
    if (error != null) {
      callback.onError(error);
      return;
    }
    tmp$ = this.account_0;
    if (tmp$ == null) {
      return;
    }
    var account = tmp$;
    if (equals(account.name, name)) {
      callback.onError(Error$Companion_getInstance().id(Id_getInstance().error_name_same));
      return;
    }
    this.updateAccount_0(Transaction_init_8(0, ensureNotNull(name)), callback);
  };
  SyncManager.prototype.updateConsent_sscekq$ = function (consent, callback) {
    var consentJson = Json_getInstance().to_8ea4ql$(consent);
    if (consentJson != null) {
      this.updateAccount_0(Transaction_init_8(4, consentJson), callback);
    }
  };
  SyncManager.prototype.updatePush_bci6hu$ = function (isPushEnabled, callback) {
    var tmp$;
    tmp$ = this.account_0;
    if (tmp$ == null) {
      return;
    }
    var account = tmp$;
    if (account.isPushEnabled === isPushEnabled) {
      callback.onError(Error$Companion_getInstance().id(Id_getInstance().error_push_same));
      return;
    }
    this.updateAccount_0(Transaction_init_8(2, isPushEnabled.toString()), callback);
  };
  SyncManager.prototype.updateMfaEnabled_bci6hu$ = function (isMfaEnabled, callback) {
    var tmp$;
    tmp$ = this.account_0;
    if (tmp$ == null) {
      return;
    }
    var account = tmp$;
    if (account.isMFAEnabled === isMfaEnabled) {
      callback.onError(Error$Companion_getInstance().id(Id_getInstance().error_mfa_same));
      return;
    }
    this.updateAccount_0(Transaction_init_8(1, isMfaEnabled.toString()), callback);
  };
  function SyncManager$changeEmail$lambda(closure$callback) {
    return function (f, f_0, f_1) {
      JavelinManager$Companion_getInstance().instance_8be2vx$.simpleBroadcast(SyncType$Simple_getInstance().LOCK, Action_getInstance().CREATE, Lock_getInstance().INVALID_TOKEN);
      closure$callback.onSuccess(Success$Companion_getInstance().successId(Id_getInstance().change_email_success));
      return Unit;
    };
  }
  SyncManager.prototype.changeEmail = function (newEmail, callback) {
    if (this.isLocked)
      return;
    var e = Validation_getInstance().validateEmail(newEmail);
    if (e != null) {
      callback.onError(e);
      return;
    }
    var body = LinkedHashMap_init();
    var key = 'newEmail';
    body.put_xwzc9p$(key, newEmail);
    var jsonBody = Json_getInstance().to_8ea4ql$(body);
    if (jsonBody == null) {
      callback.onError(this.genericError_0());
      return;
    }
    this.makeRequest_0(RequestType$POST_getInstance(), 'settings/change-email', this.getCookieString(), null, jsonBody, callback, SyncManager$changeEmail$lambda(callback));
  };
  function SyncManager$changePassword$lambda(closure$callback, closure$password) {
    return function (f, f_0, f_1) {
      closure$callback.onSuccess(Success$Companion_getInstance().successId(Id_getInstance().success_change_password));
      JavelinManager$Companion_getInstance().instance_8be2vx$.simpleBroadcast(SyncType$Simple_getInstance().PASSWORD, Action_getInstance().UPDATE, closure$password);
      return Unit;
    };
  }
  SyncManager.prototype.changePassword = function (currentPassword, newPassword, confirmNewPassword, callback) {
    if (this.isLocked)
      return;
    var tmp$;
    if (currentPassword != null) {
      var tmp$_0;
      tmp$ = trim(Kotlin.isCharSequence(tmp$_0 = currentPassword) ? tmp$_0 : throwCCE()).toString();
    }
     else
      tmp$ = null;
    var currentPasswordClean = tmp$;
    var tmp$_1;
    if (newPassword != null) {
      var tmp$_2;
      tmp$_1 = trim(Kotlin.isCharSequence(tmp$_2 = newPassword) ? tmp$_2 : throwCCE()).toString();
    }
     else
      tmp$_1 = null;
    var password = tmp$_1;
    var tmp$_3;
    if (confirmNewPassword != null) {
      var tmp$_4;
      tmp$_3 = trim(Kotlin.isCharSequence(tmp$_4 = confirmNewPassword) ? tmp$_4 : throwCCE()).toString();
    }
     else
      tmp$_3 = null;
    var confirmNewPasswordClean = tmp$_3;
    if (JavelinManager$Companion_getInstance().instance_8be2vx$.platform !== 2 && !equals(currentPasswordClean, JavelinManager$Companion_getInstance().instance_8be2vx$.simpleBroadcast(SyncType$Simple_getInstance().PASSWORD, Action_getInstance().READ, null))) {
      callback.onError(Error$Companion_getInstance().id(Id_getInstance().error_old_password));
      return;
    }
    var e = AccountValidation_getInstance().validateNewPassword_rkkr90$(password, confirmNewPasswordClean);
    if (e != null) {
      callback.onError(e);
      return;
    }
    if (equals(currentPasswordClean, password)) {
      callback.onError(Error$Companion_getInstance().id(Id_getInstance().error_passwords_same));
      return;
    }
    var body = LinkedHashMap_init();
    var key = 'newPassword';
    body.put_xwzc9p$(key, password);
    var key_0 = 'oldPassword';
    body.put_xwzc9p$(key_0, currentPasswordClean);
    var jsonBody = Json_getInstance().to_8ea4ql$(body);
    if (jsonBody == null) {
      callback.onError(this.genericError_0());
      return;
    }
    this.makeRequest_0(RequestType$POST_getInstance(), 'settings/change-password', this.getCookieString(), null, jsonBody, callback, SyncManager$changePassword$lambda(callback, password));
  };
  function SyncManager$updatePhone$lambda(closure$callback, this$SyncManager) {
    return function (f, f_0, f_1) {
      this$SyncManager.updateAccount_0(null, closure$callback);
      return Unit;
    };
  }
  SyncManager.prototype.updatePhone_0 = function (phone, callback) {
    if (this.isLocked)
      return;
    var body = LinkedHashMap_init();
    var key = 'newPhone';
    body.put_xwzc9p$(key, phone);
    var jsonBody = Json_getInstance().to_8ea4ql$(body);
    if (jsonBody == null) {
      callback.onError(this.genericError_0());
      return;
    }
    this.makeRequest_0(RequestType$POST_getInstance(), 'settings/change-phone', this.getCookieString(), null, jsonBody, callback, SyncManager$updatePhone$lambda(callback, this));
  };
  SyncManager.prototype.changePhone = function (phone, callback) {
    var tmp$;
    if (phone != null) {
      var tmp$_0;
      tmp$ = trim(Kotlin.isCharSequence(tmp$_0 = phone) ? tmp$_0 : throwCCE()).toString();
    }
     else
      tmp$ = null;
    var phoneClean = tmp$;
    var error = AccountValidation_getInstance().validatePhone_pdl1vj$(phoneClean);
    if (error != null) {
      callback.onError(error);
      return;
    }
    this.updatePhone_0(phoneClean, callback);
  };
  function SyncManager$deletePhone$ObjectLiteral(closure$callback, this$SyncManager) {
    this.closure$callback = closure$callback;
    this.this$SyncManager = this$SyncManager;
  }
  SyncManager$deletePhone$ObjectLiteral.prototype.onSuccess$default = function (message) {
    this.this$SyncManager.updatePhone_0(null, this.closure$callback);
  };
  SyncManager$deletePhone$ObjectLiteral.prototype.onError = function (error) {
    this.closure$callback.onError(error);
  };
  SyncManager$deletePhone$ObjectLiteral.$metadata$ = {
    kind: Kind_CLASS,
    interfaces: [RequestCallback]
  };
  SyncManager.prototype.deletePhone_wquaul$ = function (callback) {
    var tmp$;
    tmp$ = this.account_0;
    if (tmp$ == null) {
      return;
    }
    var account = tmp$;
    if (account.isMFAEnabled) {
      this.updateMfaEnabled_bci6hu$(false, new SyncManager$deletePhone$ObjectLiteral(callback, this));
    }
     else {
      this.updatePhone_0(null, callback);
    }
  };
  function SyncManager$verifyPhone$lambda(closure$callback, this$SyncManager) {
    return function (f, f_0, f_1) {
      this$SyncManager.updateAccount_0(null, closure$callback);
      return Unit;
    };
  }
  SyncManager.prototype.verifyPhone = function (code, callback) {
    if (this.isLocked)
      return;
    var tmp$;
    if (code != null) {
      var tmp$_0;
      tmp$ = trim(Kotlin.isCharSequence(tmp$_0 = code) ? tmp$_0 : throwCCE()).toString();
    }
     else
      tmp$ = null;
    var codeClean = tmp$;
    var e = this.validateMFACode_0(codeClean);
    if (e != null) {
      callback.onError(e);
      return;
    }
    var body = LinkedHashMap_init();
    body.put_xwzc9p$('code', codeClean);
    var jsonBody = Json_getInstance().to_8ea4ql$(body);
    if (jsonBody == null) {
      callback.onError(this.genericError_0());
      return;
    }
    this.makeRequest_0(RequestType$POST_getInstance(), 'settings/verify-phone', this.getCookieString(), null, jsonBody, callback, SyncManager$verifyPhone$lambda(callback, this));
  };
  function SyncManager$resendPhoneCode$lambda(closure$callback) {
    return function (f, f_0, f_1) {
      closure$callback.onSuccess(Success$Companion_getInstance().successId(Id_getInstance().success_code_new));
      return Unit;
    };
  }
  SyncManager.prototype.resendPhoneCode_wquaul$ = function (callback) {
    if (this.isLocked)
      return;
    this.makeRequest_0(RequestType$GET_getInstance(), 'settings/resend-verify-phone', this.getCookieString(), null, null, callback, SyncManager$resendPhoneCode$lambda(callback));
  };
  function SyncManager$convertToBasicUser$lambda(this$SyncManager) {
    return function (code, f, f_0) {
      if (code !== 200) {
        this$SyncManager.log_0.e_ly7if3$('Code received when logging out: ' + code);
      }
      return Unit;
    };
  }
  SyncManager.prototype.convertToBasicUser = function () {
    this.makeRequest_0(RequestType$GET_getInstance(), 'logout', this.getCookieString(), null, null, null, SyncManager$convertToBasicUser$lambda(this));
    this.clearLocal_6taknv$(false);
  };
  function SyncManager$refreshRecords$lambda$lambda(closure$receivedIds) {
    return function (record) {
      if (closure$receivedIds.contains_11rb$(record.recordId))
        return;
      if (JavelinManager$Companion_getInstance().dm_8be2vx$.exists(getKClass(Transaction), (new QueryBuilder(SyncType_getInstance().TRANSACTION)).where_puj7f4$('recordId', record.recordId))) {
        closure$receivedIds.add_11rb$(record.recordId);
      }
      return Unit;
    };
  }
  function SyncManager$refreshRecords$lambda(this$SyncManager) {
    return function (f, responseBody, f_0) {
      var receivedIds = toMutableList(Json_getInstance().listFrom_z6hou8$(responseBody, PrimitiveClasses$stringClass));
      JavelinManager$Companion_getInstance().dm_8be2vx$.operateList(getKClass(Record), new QueryBuilder(Type_getInstance().RECORD), SyncManager$refreshRecords$lambda$lambda(receivedIds));
      var tmp$;
      tmp$ = receivedIds.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        this$SyncManager.initiateSync(element);
      }
      return Unit;
    };
  }
  SyncManager.prototype.refreshRecords = function () {
    var tmp$, tmp$_0, tmp$_1;
    if (this.isLocked)
      return;
    var body = LinkedHashMap_init();
    var account = this.account_0;
    if (account != null) {
      var key = 'accountId';
      var value = account.accountId;
      body.put_xwzc9p$(key, value);
    }
    var recordIds = ArrayList_init_0();
    tmp$ = JavelinManager$Companion_getInstance().dm_8be2vx$.queryList(getKClass(Record), new QueryBuilder(Type_getInstance().RECORD)).iterator();
    while (tmp$.hasNext()) {
      var record = tmp$.next();
      tmp$_0 = record.lastSyncTimestamp;
      if (tmp$_0 == null) {
        continue;
      }
      var lastSyncTimestamp = tmp$_0;
      var json = LinkedHashMap_init();
      var key_0 = 'recordId';
      var value_0 = record.recordId;
      json.put_xwzc9p$(key_0, value_0);
      var key_1 = 'lastSyncTimestamp';
      var value_1 = lastSyncTimestamp.string;
      json.put_xwzc9p$(key_1, value_1);
      recordIds.add_11rb$(json);
    }
    var key_2 = 'recordIds';
    body.put_xwzc9p$(key_2, recordIds);
    tmp$_1 = Json_getInstance().to_8ea4ql$(body);
    if (tmp$_1 == null) {
      return;
    }
    var jsonBody = tmp$_1;
    this.makeRequest_0(RequestType$POST_getInstance(), 'record-ids', this.getCookieString(), null, jsonBody, null, SyncManager$refreshRecords$lambda(this));
  };
  SyncManager.prototype.initiateSync = function (recordId, isServerRequest) {
    if (isServerRequest === void 0)
      isServerRequest = true;
    if (this.isLocked)
      return;
    this.syncInterface_0.initiateSync(recordId, isServerRequest);
  };
  function SyncManager$sync$ObjectLiteral(closure$recordId, closure$isServerRequest, closure$callback, this$SyncManager, callback) {
    this.closure$recordId = closure$recordId;
    this.closure$isServerRequest = closure$isServerRequest;
    this.closure$callback = closure$callback;
    this.this$SyncManager = this$SyncManager;
    ResponseCallback.call(this, callback);
  }
  SyncManager$sync$ObjectLiteral.prototype.onSuccess = function (code, body, cookies) {
    this.this$SyncManager.parseSyncResponse_0(this.closure$recordId, this.closure$isServerRequest, this.closure$callback, code, body);
  };
  SyncManager$sync$ObjectLiteral.$metadata$ = {
    kind: Kind_CLASS,
    interfaces: [ResponseCallback]
  };
  SyncManager.prototype.sync = function (recordId, isServerRequest, callback) {
    var tmp$, tmp$_0;
    if (this.isLocked)
      return;
    var transactions = take(JavelinManager$Companion_getInstance().dm_8be2vx$.queryList(getKClass(Transaction), (new QueryBuilder(SyncType_getInstance().TRANSACTION)).where_puj7f4$('recordId', recordId)), 3);
    if (transactions.isEmpty() && !isServerRequest) {
      this.log_0.i_y4putb$('Record ' + recordId + ' has nothing to sync, stopping');
      return;
    }
    var record = JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(Record), (new QueryBuilder(Type_getInstance().RECORD)).where_puj7f4$('recordId', recordId));
    var cookieString = this.getCookieString();
    if (cookieString == null) {
      this.log_0.e_ly7if3$('No cookies to sync with');
      return;
    }
    var account = this.account_0;
    if (account == null) {
      this.log_0.e_ly7if3$('Account was null');
      return;
    }
    var body = LinkedHashMap_init();
    var key = 'accountId';
    var value = account.accountId;
    body.put_xwzc9p$(key, value);
    var key_0 = 'appVersion';
    var value_0 = JavelinManager$Companion_getInstance().instance_8be2vx$.appVersion;
    body.put_xwzc9p$(key_0, value_0);
    var key_1 = 'recordId';
    body.put_xwzc9p$(key_1, recordId);
    var date = (tmp$ = record != null ? record.lastSyncTimestamp : null) != null ? tmp$.string : null;
    if (date != null) {
      var key_2 = 'lastSyncTimestamp';
      body.put_xwzc9p$(key_2, date);
      var destination = ArrayList_init_0();
      var tmp$_1;
      tmp$_1 = transactions.iterator();
      while (tmp$_1.hasNext()) {
        var element = tmp$_1.next();
        if (element.action !== 0 || element.objectType !== 0 || !equals(element.objectId, recordId))
          destination.add_11rb$(element);
      }
      tmp$_0 = destination;
    }
     else {
      tmp$_0 = transactions;
    }
    var toSend = tmp$_0;
    var key_3 = 'transactions';
    body.put_xwzc9p$(key_3, toSend);
    var jsonBody = Json_getInstance().to_8ea4ql$(body);
    if (jsonBody == null) {
      this.log_0.e_ly7if3$('Body is null');
      return;
    }
    this.syncInterface_0.makeRequest(RequestType$POST_getInstance(), 'sync', cookieString, this.params_0, jsonBody, new SyncManager$sync$ObjectLiteral(recordId, isServerRequest, callback, this, callback));
  };
  function SyncManager$parseSyncResponse$lambda(it) {
    it.clean();
    return Unit;
  }
  var mapNotNullTo$lambda_0 = wrapFunction(function () {
    return function (closure$transform, closure$destination) {
      return function (element) {
        var tmp$;
        if ((tmp$ = closure$transform(element)) != null) {
          closure$destination.add_11rb$(tmp$);
        }
        return Unit;
      };
    };
  });
  var mapNotNullTo$lambda_1 = wrapFunction(function () {
    return function (closure$transform, closure$destination) {
      return function (element) {
        var tmp$;
        if ((tmp$ = closure$transform(element)) != null) {
          closure$destination.add_11rb$(tmp$);
        }
        return Unit;
      };
    };
  });
  SyncManager.prototype.parseSyncResponse_0 = function (recordId, isServerRequest, callback, code, body) {
    var tmp$;
    this.log_0.i_y4putb$('Call: sync, Response: ' + code);
    switch (code) {
      case 200:
        try {
          var transactionIds = Json_getInstance().listFrom_z6hou8$(body, PrimitiveClasses$stringClass, 'transactions');
          var destination = ArrayList_init_0();
          var tmp$_0;
          tmp$_0 = transactionIds.iterator();
          while (tmp$_0.hasNext()) {
            var element = tmp$_0.next();
            var tmp$_0_0;
            if ((tmp$_0_0 = JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(Transaction), (new QueryBuilder(SyncType_getInstance().TRANSACTION)).where_puj7f4$('transactionId', element))) != null) {
              destination.add_11rb$(tmp$_0_0);
            }
          }
          var tmp$_1;
          tmp$_1 = destination.iterator();
          while (tmp$_1.hasNext()) {
            var element_0 = tmp$_1.next();
            JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().DELETE, element_0);
          }
          var shouldUpdate = (tmp$ = Json_getInstance().from_z6hou8$(body, PrimitiveClasses$booleanClass, 'shouldUpdate')) != null ? tmp$ : false;
          var rejectedTransactionIds = Json_getInstance().listFrom_z6hou8$(body, PrimitiveClasses$stringClass, 'rejectedTransactions');
          if (!rejectedTransactionIds.isEmpty()) {
            this.log_0.e_ly7if3$('Received rejected transactions');
            shouldUpdate = true;
            var destination_0 = ArrayList_init_0();
            var tmp$_2;
            tmp$_2 = rejectedTransactionIds.iterator();
            while (tmp$_2.hasNext()) {
              var element_1 = tmp$_2.next();
              var tmp$_0_1;
              if ((tmp$_0_1 = JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(Transaction), (new QueryBuilder(SyncType_getInstance().TRANSACTION)).where_puj7f4$('transactionId', element_1))) != null) {
                destination_0.add_11rb$(tmp$_0_1);
              }
            }
            var tmp$_3;
            tmp$_3 = destination_0.iterator();
            while (tmp$_3.hasNext()) {
              var element_2 = tmp$_3.next();
              JavelinManager$Companion_getInstance().instance_8be2vx$.broadcast(Action_getInstance().DELETE, element_2);
            }
          }
          if (JavelinManager$Companion_getInstance().dm_8be2vx$.exists(getKClass(Transaction), (new QueryBuilder(SyncType_getInstance().TRANSACTION)).where_puj7f4$('recordId', recordId))) {
            this.initiateSync(recordId, isServerRequest);
            return;
          }
          this.syncInterface_0.saveLastSyncDate(recordId);
          var record = Json_getInstance().from_z6hou8$(body, getKClass(Record), 'record');
          if (record != null) {
            JavelinManager$Companion_getInstance().dm_8be2vx$.updateRecord(record, shouldUpdate);
          }
           else {
            this.log_0.e_ly7if3$('Received record from server was null');
          }
        }
         catch (e) {
          if (Kotlin.isType(e, Exception)) {
            this.log_0.e_ly7if3$('Error parsing response', e);
          }
           else
            throw e;
        }

        break;
      case 213:
        var record_0 = JavelinManager$Companion_getInstance().dm_8be2vx$.querySingle(getKClass(Record), (new QueryBuilder(Type_getInstance().RECORD)).where_puj7f4$('recordId', recordId));
        if (record_0 != null) {
          record_0.delete_vft4zs$(true);
          JavelinManager$Companion_getInstance().dm_8be2vx$.onBroadcastReceived_2urz0g$(Action_getInstance().DELETE, record_0, emptyList());
        }

        JavelinManager$Companion_getInstance().dm_8be2vx$.deleteList(getKClass(Transaction), (new QueryBuilder(SyncType_getInstance().TRANSACTION)).where_puj7f4$('recordId', recordId));
        JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(Action_getInstance().REGENERATE_PAGES, recordId);
        break;
      case 400:
        this.log_0.e_ly7if3$('400 from the server');
        JavelinManager$Companion_getInstance().dm_8be2vx$.operateList(getKClass(Transaction), (new QueryBuilder(SyncType_getInstance().TRANSACTION)).where_puj7f4$('recordId', recordId), SyncManager$parseSyncResponse$lambda);
        this.initiateSync(recordId, isServerRequest);
        break;
      case 403:
        JavelinManager$Companion_getInstance().instance_8be2vx$.simpleBroadcast(SyncType$Simple_getInstance().LOCK, Action_getInstance().UPDATE, Lock_getInstance().INVALID_TOKEN);
        JavelinManager$Companion_getInstance().instance_8be2vx$.clientBroadcast(SyncBroadcast_getInstance().LOCK);
        this.log_0.e_ly7if3$('Sync Error: ' + code);
        break;
      case 503:
        this.log_0.i_y4putb$('Server is in maintenance');
        break;
      default:this.log_0.e_ly7if3$('Sync Error: ' + code);
        break;
    }
    callback.onSuccess();
  };
  SyncManager.prototype.handleSocketBroadcast = function (broadcast, message) {
    if (this.isLocked)
      return;
    try {
      switch (broadcast) {
        case 'sync_record':
          if (message == null) {
            this.log_0.e_ly7if3$('Received message was null');
            return;
          }

          var recordId = Json_getInstance().from_z6hou8$(message, PrimitiveClasses$stringClass, 'recordId');
          if (recordId == null) {
            this.log_0.e_ly7if3$('Record Id received from socket was null');
            return;
          }

          this.initiateSync(recordId);
          break;
        case 'sync_account':
          this.refreshAccount();
          break;
      }
    }
     catch (e) {
      if (Kotlin.isType(e, Exception)) {
        this.log_0.e_8o0b5c$(Kotlin.newThrowable('Error handling socket message', e));
      }
       else
        throw e;
    }
  };
  SyncManager.prototype.validateMFACode_0 = function (code) {
    var tmp$;
    var tmp$_0;
    if (code != null) {
      var tmp$_1;
      tmp$_0 = trim(Kotlin.isCharSequence(tmp$_1 = code) ? tmp$_1 : throwCCE()).toString();
    }
     else
      tmp$_0 = null;
    var codeClean = (tmp$ = tmp$_0) != null ? tmp$ : '';
    if (codeClean.length === 0) {
      return Error$Companion_getInstance().id(Id_getInstance().error_code_requirements);
    }
    if (codeClean.length !== 6) {
      return Error$Companion_getInstance().id(Id_getInstance().error_code_requirements);
    }
    try {
      toInt(codeClean);
    }
     catch (e) {
      if (Kotlin.isType(e, Exception)) {
        return Error$Companion_getInstance().id(Id_getInstance().error_code_requirements);
      }
       else
        throw e;
    }
    return null;
  };
  SyncManager.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'SyncManager',
    interfaces: []
  };
  function SyncType() {
    SyncType_instance = this;
    this.ACCOUNT = 'Account';
    this.TRANSACTION = 'SyncTransaction';
  }
  function SyncType$Simple() {
    SyncType$Simple_instance = this;
    this.TOKEN = 'Token';
    this.LOCK = 'Lock';
    this.PASSWORD = 'Password';
  }
  SyncType$Simple.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Simple',
    interfaces: []
  };
  var SyncType$Simple_instance = null;
  function SyncType$Simple_getInstance() {
    if (SyncType$Simple_instance === null) {
      new SyncType$Simple();
    }
    return SyncType$Simple_instance;
  }
  SyncType.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'SyncType',
    interfaces: []
  };
  var SyncType_instance = null;
  function SyncType_getInstance() {
    if (SyncType_instance === null) {
      new SyncType();
    }
    return SyncType_instance;
  }
  function Help() {
    Help_instance = this;
  }
  Help.prototype.randomId = function () {
    return JavelinManager$Companion_getInstance().instance_8be2vx$.randomId();
  };
  Help.prototype.isFieldChanged_kmul3d$ = function (oldValue, newValue, fieldName, fieldChanges) {
    if (!equals(oldValue, newValue)) {
      fieldChanges.add_11rb$(fieldName);
      return true;
    }
    return false;
  };
  Help.prototype.getMapValue_ije21m$ = function (map, language) {
    var value = map.get_11rb$(language);
    var tmp$ = value != null;
    if (tmp$) {
      tmp$ = !isBlank(value);
    }
    if (tmp$) {
      return value;
    }
    if (!equals(language, Language_getInstance().ENGLISH)) {
      var enValue = map.get_11rb$(Language_getInstance().ENGLISH);
      var tmp$_0 = enValue != null;
      if (tmp$_0) {
        tmp$_0 = !isBlank(enValue);
      }
      if (tmp$_0) {
        return enValue;
      }
    }
    return ERROR;
  };
  Help.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Help',
    interfaces: []
  };
  var Help_instance = null;
  function Help_getInstance() {
    if (Help_instance === null) {
      new Help();
    }
    return Help_instance;
  }
  function Id() {
    Id_instance = this;
    this.english = 'english';
    this.french = 'french';
    this.french_french = 'french_french';
    this.english_english = 'english_english';
    this.success = 'success';
    this.error = 'error';
    this.error_general = 'error_general';
    this.error_internet = 'error_internet';
    this.warning = 'warning';
    this.oops = 'oops';
    this.thank_you = 'thank_you';
    this.edit = 'edit';
    this.back = 'back';
    this.next = 'next';
    this.skip = 'skip';
    this.save = 'save';
    this.delete = 'delete';
    this.done = 'done';
    this.close = 'close';
    this.begin = 'begin';
    this.submit = 'submit';
    this.defaut = 'defaut';
    this.continu = 'continu';
    this.notes = 'notes';
    this.please_wait = 'please_wait';
    this.download = 'download';
    this.not_now = 'not_now';
    this.sex = 'sex';
    this.male = 'male';
    this.female = 'female';
    this.password = 'password';
    this.confirm_password = 'confirm_password';
    this.share = 'share';
    this.swipe = 'swipe';
    this.login = 'login';
    this.logout = 'logout';
    this.sign_up = 'sign_up';
    this.allow = 'allow';
    this.verify = 'verify';
    this.code = 'code';
    this.age = 'age';
    this.language = 'language';
    this.location = 'location';
    this.city = 'city';
    this.country = 'country';
    this.or = 'or';
    this.title_name = 'title_name';
    this.email = 'email';
    this.unlock = 'unlock';
    this.read_more = 'read_more';
    this.required = 'required';
    this.optional = 'optional';
    this.cancel = 'cancel';
    this.okay = 'okay';
    this.yes = 'yes';
    this.no = 'no';
    this.no_thanks = 'no_thanks';
    this.email_prompt = 'email_prompt';
    this.phone_prompt = 'phone_prompt';
    this.saved = 'saved';
    this.sent = 'sent';
    this.browser_open_safari = 'browser_open_safari';
    this.error_missing_app = 'error_missing_app';
    this.error_pdf_none = 'error_pdf_none';
    this.help = 'help';
    this.settings = 'settings';
    this.about = 'about';
    this.feedback = 'feedback';
    this.report_bug = 'report_bug';
    this.information = 'information';
    this.search = 'search';
    this.notifications = 'notifications';
    this.version = 'version';
    this.copyright = 'copyright';
    this.add_to_calendar = 'add_to_calendar';
    this.tap_to_enter = 'tap_to_enter';
    this.warning_unsaved_changes = 'warning_unsaved_changes';
    this.tap_to_select = 'tap_to_select';
    this.travel = 'travel';
    this.other = 'other';
    this.unknown = 'unknown';
    this.home = 'home';
    this.initializing = 'initializing';
    this.updating = 'updating';
    this.mail_error = 'mail_error';
    this.AB = 'AB';
    this.BC = 'BC';
    this.MB = 'MB';
    this.NB = 'NB';
    this.NL = 'NL';
    this.NS = 'NS';
    this.NT = 'NT';
    this.NU = 'NU';
    this.ON = 'ON';
    this.PE = 'PE';
    this.QC = 'QC';
    this.SK = 'SK';
    this.YT = 'YT';
    this.new_version = 'new_version';
    this.title_records = 'title_records';
    this.title_outbreaks = 'title_outbreaks';
    this.records_add = 'records_add';
    this.records_none = 'records_none';
    this.title_facebook = 'title_facebook';
    this.title_twitter = 'title_twitter';
    this.rating_title = 'rating_title';
    this.rating_explanation = 'rating_explanation';
    this.rating_now = 'rating_now';
    this.rating_later = 'rating_later';
    this.records_walkthrough_welcome = 'records_walkthrough_welcome';
    this.records_walkthrough_vaccinations_grouped = 'records_walkthrough_vaccinations_grouped';
    this.records_walkthrough_adult_explanation = 'records_walkthrough_adult_explanation';
    this.records_walkthrough_record_received_male = 'records_walkthrough_record_received_male';
    this.records_walkthrough_record_received_female = 'records_walkthrough_record_received_female';
    this.records_walkthrough_appropriate_categories = 'records_walkthrough_appropriate_categories';
    this.records_walkthrough_rotate = 'records_walkthrough_rotate';
    this.records_walkthrough_already_vaccinated_male = 'records_walkthrough_already_vaccinated_male';
    this.records_walkthrough_already_vaccinated_female = 'records_walkthrough_already_vaccinated_female';
    this.records_walkthrough_be_sure_to_record = 'records_walkthrough_be_sure_to_record';
    this.records_walkthrough_consult_doctor = 'records_walkthrough_consult_doctor';
    this.records_walkthrough_start_by = 'records_walkthrough_start_by';
    this.records_walkthrough_colours_indicate = 'records_walkthrough_colours_indicate';
    this.records_walkthrough_overdue = 'records_walkthrough_overdue';
    this.records_walkthrough_approaching = 'records_walkthrough_approaching';
    this.records_walkthrough_received = 'records_walkthrough_received';
    this.records_walkthrough_future = 'records_walkthrough_future';
    this.title_vaccinations = 'title_vaccinations';
    this.vaccinations_add = 'vaccinations_add';
    this.vaccinations_child = 'vaccinations_child';
    this.vaccinations_adult = 'vaccinations_adult';
    this.vaccinations_not_received_confirmation = 'vaccinations_not_received_confirmation';
    this.records_settings_title = 'records_settings_title';
    this.records_settings_tour = 'records_settings_tour';
    this.records_settings_hide_ignored = 'records_settings_hide_ignored';
    this.records_settings_hide_ignored_explanation = 'records_settings_hide_ignored_explanation';
    this.overdue = 'overdue';
    this.ignored = 'ignored';
    this.dose_other_province = 'dose_other_province';
    this.dose_error_date_missing = 'dose_error_date_missing';
    this.dose_error_future_date_on_receive = 'dose_error_future_date_on_receive';
    this.dose_error_before_birthdate = 'dose_error_before_birthdate';
    this.dose_warning_delete = 'dose_warning_delete';
    this.dose_received = 'dose_received';
    this.dose_view_vaccine_information = 'dose_view_vaccine_information';
    this.dose_date_recommended = 'dose_date_recommended';
    this.date_recommended = 'date_recommended';
    this.dose_date_scheduled = 'dose_date_scheduled';
    this.date_scheduled = 'date_scheduled';
    this.dose_date_received = 'dose_date_received';
    this.date_received = 'date_received';
    this.dose_unschedule = 'dose_unschedule';
    this.tap_to_schedule = 'tap_to_schedule';
    this.dose_product_name = 'dose_product_name';
    this.dose_product_information = 'dose_product_information';
    this.dose_ignored_max_age_past = 'dose_ignored_max_age_past';
    this.dose_no_longer_recommended_after = 'dose_no_longer_recommended_after';
    this.dose_trade_name_unspecified = 'dose_trade_name_unspecified';
    this.dose_lot = 'dose_lot';
    this.dose_expiry = 'dose_expiry';
    this.dose_expiry_remove = 'dose_expiry_remove';
    this.dose_gtin = 'dose_gtin';
    this.dose_gtin_remove = 'dose_gtin_remove';
    this.dose_comments = 'dose_comments';
    this.about_this_vaccine = 'about_this_vaccine';
    this.product_monograph = 'product_monograph';
    this.error_lot_length = 'error_lot_length';
    this.error_gtin_length = 'error_gtin_length';
    this.error_dose_comments_length = 'error_dose_comments_length';
    this.dose_added_calendar = 'dose_added_calendar';
    this.dose_added_calendar_title = 'dose_added_calendar_title';
    this.dose_calendar_error_title = 'dose_calendar_error_title';
    this.dose_calendar_error_description = 'dose_calendar_error_description';
    this.title_status = 'title_status';
    this.records_status_vaccinations = 'records_status_vaccinations';
    this.records_status_diseases = 'records_status_diseases';
    this.records_status_flu_shots = 'records_status_flu_shots';
    this.records_status_tetanus_shots = 'records_status_tetanus_shots';
    this.records_status_overdue_vaccinations = 'records_status_overdue_vaccinations';
    this.records_status_no_overdue_vaccinations = 'records_status_no_overdue_vaccinations';
    this.records_status_next_recommended_vaccination = 'records_status_next_recommended_vaccination';
    this.records_status_disease = 'records_status_disease';
    this.records_status_disclaimer_individual = 'records_status_disclaimer_individual';
    this.records_status_disclaimer_general = 'records_status_disclaimer_general';
    this.records_status_swipe_notification = 'records_status_swipe_notification';
    this.records_status_turn_off_notifcation_dose = 'records_status_turn_off_notifcation_dose';
    this.records_status_turn_off_notifcation_visit = 'records_status_turn_off_notifcation_visit';
    this.notification_ignore_warning = 'notification_ignore_warning';
    this.title_profile = 'title_profile';
    this.birthdate = 'birthdate';
    this.first_name = 'first_name';
    this.last_name = 'last_name';
    this.region = 'region';
    this.schedule = 'schedule';
    this.records_profile_paper_records = 'records_profile_paper_records';
    this.doctor = 'doctor';
    this.notes_health_card_id = 'notes_health_card_id';
    this.city_none = 'city_none';
    this.city_choose = 'city_choose';
    this.warning_change_sex = 'warning_change_sex';
    this.warning_change_birthdate = 'warning_change_birthdate';
    this.consent_info = 'consent_info';
    this.relationship_unknown = 'relationship_unknown';
    this.consent_record = 'consent_record';
    this.record_consent_under_16 = 'record_consent_under_16';
    this.error_date_missing = 'error_date_missing';
    this.error_date_before_dose = 'error_date_before_dose';
    this.error_date_future = 'error_date_future';
    this.error_missing_first_name = 'error_missing_first_name';
    this.error_missing_sex = 'error_missing_sex';
    this.error_missing_region = 'error_missing_region';
    this.error_missing_schedule = 'error_missing_schedule';
    this.error_record_consent = 'error_record_consent';
    this.error_first_name_length = 'error_first_name_length';
    this.error_last_name_length = 'error_last_name_length';
    this.error_hcp_length = 'error_hcp_length';
    this.error_record_notes_length = 'error_record_notes_length';
    this.record_delete = 'record_delete';
    this.record_delete_confirmation = 'record_delete_confirmation';
    this.error_delete_name = 'error_delete_name';
    this.record_save_changes = 'record_save_changes';
    this.records_profile_send_phu = 'records_profile_send_phu';
    this.relationship = 'relationship';
    this.relationship_other = 'relationship_other';
    this.relationship_self = 'relationship_self';
    this.relationship_guardian = 'relationship_guardian';
    this.relationship_spouse = 'relationship_spouse';
    this.error_relationship = 'error_relationship';
    this.title_record_card = 'title_record_card';
    this.record_card_title = 'record_card_title';
    this.record_card_not_official_record = 'record_card_not_official_record';
    this.record_card_grid_title = 'record_card_grid_title';
    this.record_card_date = 'record_card_date';
    this.record_card_date_format = 'record_card_date_format';
    this.record_card_pdf_title = 'record_card_pdf_title';
    this.record_card_pdf_header = 'record_card_pdf_header';
    this.record_card_share = 'record_card_share';
    this.record_card_choose_title = 'record_card_choose_title';
    this.record_card_memory_error = 'record_card_memory_error';
    this.record_card_email_saved = 'record_card_email_saved';
    this.record_card_email_failed = 'record_card_email_failed';
    this.record_card_email_sucess = 'record_card_email_sucess';
    this.visit_recommended_date = 'visit_recommended_date';
    this.visit_recommended_dates = 'visit_recommended_dates';
    this.visit_calendar_event_notes = 'visit_calendar_event_notes';
    this.visit_ignored = 'visit_ignored';
    this.visit_old_schedule = 'visit_old_schedule';
    this.visit_delete = 'visit_delete';
    this.visit_unignore = 'visit_unignore';
    this.records_confirm_dose_date = 'records_confirm_dose_date';
    this.record_no_doses = 'record_no_doses';
    this.record_add_dose = 'record_add_dose';
    this.page_other_description = 'page_other_description';
    this.page_travel_description = 'page_travel_description';
    this.doses = 'doses';
    this.records_i_dont_know = 'records_i_dont_know';
    this.records_which_product = 'records_which_product';
    this.records_vaccinations_select_add = 'records_vaccinations_select_add';
    this.records_add_dose_nonscheduled = 'records_add_dose_nonscheduled';
    this.notifications_none = 'notifications_none';
    this.notifications_status_overdue = 'notifications_status_overdue';
    this.notifications_status_approaching = 'notifications_status_approaching';
    this.notifications_status_none = 'notifications_status_none';
    this.title_outbreak = 'title_outbreak';
    this.outbreaks_all = 'outbreaks_all';
    this.outbreaks_powered_by = 'outbreaks_powered_by';
    this.outbreaks_rotate_device = 'outbreaks_rotate_device';
    this.outbreaks_filter_by = 'outbreaks_filter_by';
    this.outbreaks_filter_city = 'outbreaks_filter_city';
    this.outbreaks_radius = 'outbreaks_radius';
    this.outbreaks_filter_disease = 'outbreaks_filter_disease';
    this.outbreaks_filter_disease_android = 'outbreaks_filter_disease_android';
    this.outbreaks_km = 'outbreaks_km';
    this.outbreaks_date = 'outbreaks_date';
    this.outbreaks_proximity = 'outbreaks_proximity';
    this.outbreaks_about_data_source = 'outbreaks_about_data_source';
    this.outbreaks_error_range = 'outbreaks_error_range';
    this.outbreaks_error_location_unavailable = 'outbreaks_error_location_unavailable';
    this.outbreaks_error_location_off = 'outbreaks_error_location_off';
    this.outbreaks_link_disclaimer = 'outbreaks_link_disclaimer';
    this.outbreaks_more_info = 'outbreaks_more_info';
    this.outbreaks_view_status = 'outbreaks_view_status';
    this.outbreaks_status_against = 'outbreaks_status_against';
    this.outbreaks_cell_outbreak = 'outbreaks_cell_outbreak';
    this.outbreaks_using_current_location = 'outbreaks_using_current_location';
    this.outbreaks_use_current_location = 'outbreaks_use_current_location';
    this.outbreaks_choose_location = 'outbreaks_choose_location';
    this.enable_geolocation = 'enable_geolocation';
    this.outbreaks_location_services_title = 'outbreaks_location_services_title';
    this.outbreaks_location_services_description = 'outbreaks_location_services_description';
    this.search_all = 'search_all';
    this.search_vaccines_diseases = 'search_vaccines_diseases';
    this.search_vaccines = 'search_vaccines';
    this.search_diseases = 'search_diseases';
    this.search_placeholder = 'search_placeholder';
    this.title_disease = 'title_disease';
    this.title_vaccination = 'title_vaccination';
    this.debug_settings = 'debug_settings';
    this.send_records = 'send_records';
    this.send_records_disclaimer = 'send_records_disclaimer';
    this.reconvert_records = 'reconvert_records';
    this.reconvert_records_pre_240 = 'reconvert_records_pre_240';
    this.reconvert_records_disclaimer = 'reconvert_records_disclaimer';
    this.feedback_email_title = 'feedback_email_title';
    this.bug_report_email_title = 'bug_report_email_title';
    this.feedback_email_saved_drafts_ios = 'feedback_email_saved_drafts_ios';
    this.feedback_email_message_sent = 'feedback_email_message_sent';
    this.social_facebook_title = 'social_facebook_title';
    this.social_facebook_description = 'social_facebook_description';
    this.social_facebook_image = 'social_facebook_image';
    this.social_link_android = 'social_link_android';
    this.social_link_ios = 'social_link_ios';
    this.social_twitter_message = 'social_twitter_message';
    this.social_post_success = 'social_post_success';
    this.social_twitter_error = 'social_twitter_error';
    this.notification_recommended_on = 'notification_recommended_on';
    this.notification_approaching = 'notification_approaching';
    this.notification_scheduled_for = 'notification_scheduled_for';
    this.notification_scheduled_on_date = 'notification_scheduled_on_date';
    this.notification_recommended_on_date = 'notification_recommended_on_date';
    this.notification_recommended_asap = 'notification_recommended_asap';
    this.notification_is_approaching = 'notification_is_approaching';
    this.notification_visit_is_approaching = 'notification_visit_is_approaching';
    this.years = 'years';
    this.year = 'year';
    this.months = 'months';
    this.month = 'month';
    this.weeks = 'weeks';
    this.week = 'week';
    this.notification_visit_is_scheduled_on_date = 'notification_visit_is_scheduled_on_date';
    this.notification_visit_is_recommended_on_date = 'notification_visit_is_recommended_on_date';
    this.notification_flu_shot_received_male = 'notification_flu_shot_received_male';
    this.notification_flu_shot_required_male = 'notification_flu_shot_required_male';
    this.notification_flu_shot_received_female = 'notification_flu_shot_received_female';
    this.notification_flu_shot_required_female = 'notification_flu_shot_required_female';
    this.notification_next_recommended_vaccination_on = 'notification_next_recommended_vaccination_on';
    this.notification_flu_shot_fall_next = 'notification_flu_shot_fall_next';
    this.notification_flu_shot_young = 'notification_flu_shot_young';
    this.notifications_no_tetanus_vaccines = 'notifications_no_tetanus_vaccines';
    this.notifications_last_tetanus_on_date = 'notifications_last_tetanus_on_date';
    this.notifications_next_tetanus_on_date = 'notifications_next_tetanus_on_date';
    this.notification_is_overdue_time = 'notification_is_overdue_time';
    this.notification_is_overdue = 'notification_is_overdue';
    this.notification_scheduled_overdue = 'notification_scheduled_overdue';
    this.notification_visit_is_overdue = 'notification_visit_is_overdue';
    this.notification_time_overdue = 'notification_time_overdue';
    this.notification_vaccinations_no_recommended = 'notification_vaccinations_no_recommended';
    this.notification_recommended_in = 'notification_recommended_in';
    this.notification_is_recommended_asap = 'notification_is_recommended_asap';
    this.notification_recommended_for_asap = 'notification_recommended_for_asap';
    this.notification_received_on = 'notification_received_on';
    this.notification_recommended_2_weeks = 'notification_recommended_2_weeks';
    this.records_travelpage_introduction = 'records_travelpage_introduction';
    this.HICRoot_1 = 'HICRoot_1';
    this.HICFAQ_q1 = 'HICFAQ_q1';
    this.HICFAQ_q2 = 'HICFAQ_q2';
    this.HICFAQ_q3 = 'HICFAQ_q3';
    this.HICFAQ_q4 = 'HICFAQ_q4';
    this.HICFAQ_q5 = 'HICFAQ_q5';
    this.HICFAQ_q6 = 'HICFAQ_q6';
    this.HICFAQ_q7 = 'HICFAQ_q7';
    this.HICFAQ_q8 = 'HICFAQ_q8';
    this.HICFAQ_q9 = 'HICFAQ_q9';
    this.HICFAQ_q10 = 'HICFAQ_q10';
    this.HICFAQ_q11 = 'HICFAQ_q11';
    this.HICFAQ_a1 = 'HICFAQ_a1';
    this.HICFAQ_a2 = 'HICFAQ_a2';
    this.HICFAQ_a3 = 'HICFAQ_a3';
    this.HICFAQ_a4 = 'HICFAQ_a4';
    this.HICFAQ_a5 = 'HICFAQ_a5';
    this.HICFAQ_a6 = 'HICFAQ_a6';
    this.HICFAQ_a7 = 'HICFAQ_a7';
    this.HICFAQ_a8 = 'HICFAQ_a8';
    this.HICFAQ_a9 = 'HICFAQ_a9';
    this.HICFAQ_a10 = 'HICFAQ_a10';
    this.HICFAQ_a11 = 'HICFAQ_a11';
    this.HICRoot_2 = 'HICRoot_2';
    this.HICRoot_3 = 'HICRoot_3';
    this.HICProtect = 'HICProtect';
    this.HICRoot_4 = 'HICRoot_4';
    this.HICFR1 = 'HICFR1';
    this.HICFR2 = 'HICFR2';
    this.HICFR3 = 'HICFR3';
    this.HICFR4 = 'HICFR4';
    this.HICFR5 = 'HICFR5';
    this.HICFR6 = 'HICFR6';
    this.HICFR1b = 'HICFR1b';
    this.HICFR2b = 'HICFR2b';
    this.HICFR3b = 'HICFR3b';
    this.HICFR4b = 'HICFR4b';
    this.HICFR5b = 'HICFR5b';
    this.HICFR6b = 'HICFR6b';
    this.HICRoot_5 = 'HICRoot_5';
    this.HICRoot_6 = 'HICRoot_6';
    this.HICRoot_7 = 'HICRoot_7';
    this.HIC_pain_header = 'HIC_pain_header';
    this.HIC_yto = 'HIC_yto';
    this.HIC_yto_content = 'HIC_yto_content';
    this.HIC_yto_do = 'HIC_yto_do';
    this.HIC_yto_give = 'HIC_yto_give';
    this.HIC_yto_act = 'HIC_yto_act';
    this.HIC_yto_do_breastfeed = 'HIC_yto_do_breastfeed';
    this.HIC_yto_do_breastfeed_content = 'HIC_yto_do_breastfeed_content';
    this.HIC_yto_do_hold = 'HIC_yto_do_hold';
    this.HIC_yto_do_hold_content = 'HIC_yto_do_hold_content';
    this.HIC_yto_give_sugar = 'HIC_yto_give_sugar';
    this.HIC_yto_give_sugar_content = 'HIC_yto_give_sugar_content';
    this.HIC_yto_give_anesthetic = 'HIC_yto_give_anesthetic';
    this.HIC_yto_give_anesthetic_content = 'HIC_yto_give_anesthetic_content';
    this.HIC_yto_act_state = 'HIC_yto_act_state';
    this.HIC_yto_act_state_content = 'HIC_yto_act_state_content';
    this.HIC_yto_act_distract = 'HIC_yto_act_distract';
    this.HIC_yto_act_distract_content = 'HIC_yto_act_distract_content';
    this.HIC_pain_kids_and_teens = 'HIC_pain_kids_and_teens';
    this.HIC_pain_kids_and_teens_content = 'HIC_pain_kids_and_teens_content';
    this.HIC_pain_kids_and_teens_give = 'HIC_pain_kids_and_teens_give';
    this.HIC_pain_kids_and_teens_do = 'HIC_pain_kids_and_teens_do';
    this.HIC_pain_kids_and_teens_act = 'HIC_pain_kids_and_teens_act';
    this.HIC_pain_kids_and_teens_give_anesthetic = 'HIC_pain_kids_and_teens_give_anesthetic';
    this.HIC_pain_kids_and_teens_give_anesthetic_content = 'HIC_pain_kids_and_teens_give_anesthetic_content';
    this.HIC_pain_kids_and_teens_do_upright = 'HIC_pain_kids_and_teens_do_upright';
    this.HIC_pain_kids_and_teens_do_upright_content = 'HIC_pain_kids_and_teens_do_upright_content';
    this.HIC_pain_kids_and_teens_act_your = 'HIC_pain_kids_and_teens_act_your';
    this.HIC_pain_kids_and_teens_act_your_content = 'HIC_pain_kids_and_teens_act_your_content';
    this.HIC_pain_kids_and_teens_act_distract = 'HIC_pain_kids_and_teens_act_distract';
    this.HIC_pain_kids_and_teens_act_distract_content = 'HIC_pain_kids_and_teens_act_distract_content';
    this.HIC_pain_adult = 'HIC_pain_adult';
    this.HIC_pain_adult_content = 'HIC_pain_adult_content';
    this.HIC_pain_adult_use = 'HIC_pain_adult_use';
    this.HIC_pain_adult_do = 'HIC_pain_adult_do';
    this.HIC_pain_adult_act = 'HIC_pain_adult_act';
    this.HIC_pain_adult_use_anesthetic = 'HIC_pain_adult_use_anesthetic';
    this.HIC_pain_adult_use_anesthetic_content = 'HIC_pain_adult_use_anesthetic_content';
    this.HIC_pain_adult_do_body = 'HIC_pain_adult_do_body';
    this.HIC_pain_adult_do_body_content = 'HIC_pain_adult_do_body_content';
    this.HIC_pain_adult_act_stay = 'HIC_pain_adult_act_stay';
    this.HIC_pain_adult_act_stay_content = 'HIC_pain_adult_act_stay_content';
    this.HIC_pain_adult_act_distraction = 'HIC_pain_adult_act_distraction';
    this.HIC_pain_adult_act_distraction_content = 'HIC_pain_adult_act_distraction_content';
    this.HIC_pregnancy_title = 'HIC_pregnancy_title';
    this.HIC_pregnancy_content = 'HIC_pregnancy_content';
    this.title_for_kids = 'title_for_kids';
    this.for_kids_iw_description = 'for_kids_iw_description';
    this.for_kids_iw_launch = 'for_kids_iw_launch';
    this.for_kids_iw_for_motion_comic = 'for_kids_iw_for_motion_comic';
    this.for_kids_open_madefire = 'for_kids_open_madefire';
    this.for_kids_iw_madefire_disclaimer = 'for_kids_iw_madefire_disclaimer';
    this.for_kids_iw_created_by = 'for_kids_iw_created_by';
    this.for_kids_iw_swipe = 'for_kids_iw_swipe';
    this.title_immunity_warriors = 'title_immunity_warriors';
    this.phu_footer_new = 'phu_footer_new';
    this.phu_footer_existing = 'phu_footer_existing';
    this.error_phu_first_name = 'error_phu_first_name';
    this.error_phu_last_name = 'error_phu_last_name';
    this.phu_valid_ohip = 'phu_valid_ohip';
    this.phu_valid_postal_code = 'phu_valid_postal_code';
    this.phu_valid_phone_number = 'phu_valid_phone_number';
    this.phu_phone_number_containing = 'phu_phone_number_containing';
    this.phu_enter_address = 'phu_enter_address';
    this.phu_unique_ohip = 'phu_unique_ohip';
    this.phu_last_name_required = 'phu_last_name_required';
    this.phu_send_which_records = 'phu_send_which_records';
    this.phu_checked_automatically_updated = 'phu_checked_automatically_updated';
    this.phu_no_records = 'phu_no_records';
    this.phu_record_on = 'phu_record_on';
    this.phu_record_off = 'phu_record_off';
    this.phu_enabled_profile_change_error = 'phu_enabled_profile_change_error';
    this.phu_program_disabled = 'phu_program_disabled';
    this.phu_must_live_ontario = 'phu_must_live_ontario';
    this.phu_must_fifteen_younger = 'phu_must_fifteen_younger';
    this.error_phu_age = 'error_phu_age';
    this.phu_prevent_further_updates = 'phu_prevent_further_updates';
    this.phu_contact_info = 'phu_contact_info';
    this.phu_parent_first_name = 'phu_parent_first_name';
    this.phu_parent_last_name = 'phu_parent_last_name';
    this.phu_address_1 = 'phu_address_1';
    this.phu_address_2 = 'phu_address_2';
    this.phu_postal_code = 'phu_postal_code';
    this.phu_enter_all_following_information = 'phu_enter_all_following_information';
    this.phu_ohip_number = 'phu_ohip_number';
    this.phu_ohip_only_numeric = 'phu_ohip_only_numeric';
    this.phu_must_live_listed_area = 'phu_must_live_listed_area';
    this.phu_i_agree = 'phu_i_agree';
    this.phu_launch_screen_prompt = 'phu_launch_screen_prompt';
    this.phu_record_received = 'phu_record_received';
    this.phu_select_city = 'phu_select_city';
    this.error_phu_relationship = 'error_phu_relationship';
    this.error_guardian_first_length = 'error_guardian_first_length';
    this.error_guardian_last_length = 'error_guardian_last_length';
    this.error_address_1_length = 'error_address_1_length';
    this.error_address_2_length = 'error_address_2_length';
    this.javelin_title = 'javelin_title';
    this.javelin_conversion_title = 'javelin_conversion_title';
    this.javelin_conversion_description = 'javelin_conversion_description';
    this.javelin_conversion_info = 'javelin_conversion_info';
    this.javelin_conversion_now = 'javelin_conversion_now';
    this.javelin_conversion_later = 'javelin_conversion_later';
    this.javelin_conversion_update_title = 'javelin_conversion_update_title';
    this.javelin_conversion_replaced = 'javelin_conversion_replaced';
    this.javelin_conversion_deletion = 'javelin_conversion_deletion';
    this.javelin_conversion_summary = 'javelin_conversion_summary';
    this.javelin_conversion_date_before_birthdate = 'javelin_conversion_date_before_birthdate';
    this.tagline = 'tagline';
    this.get_started = 'get_started';
    this.tour_login = 'tour_login';
    this.tour_track_family_records = 'tour_track_family_records';
    this.tour_track_family_records_explanation = 'tour_track_family_records_explanation';
    this.tour_reminders = 'tour_reminders';
    this.tour_reminders_explanation = 'tour_reminders_explanation';
    this.tour_province_facts = 'tour_province_facts';
    this.tour_province_facts_explanation = 'tour_province_facts_explanation';
    this.tour_outbreaks = 'tour_outbreaks';
    this.tour_outbreaks_explanation = 'tour_outbreaks_explanation';
    this.tour_travel = 'tour_travel';
    this.tour_travel_explanation = 'tour_travel_explanation';
    this.tour_sync = 'tour_sync';
    this.tour_sync_explanation = 'tour_sync_explanation';
    this.tour_basic = 'tour_basic';
    this.password_rules = 'password_rules';
    this.sign_up_title = 'sign_up_title';
    this.sign_up_email = 'sign_up_email';
    this.sign_up_google = 'sign_up_google';
    this.sign_up_facebook = 'sign_up_facebook';
    this.sign_up_basic = 'sign_up_basic';
    this.sign_up_login = 'sign_up_login';
    this.error_email = 'error_email';
    this.error_sync_email_taken = 'error_sync_email_taken';
    this.error_password_rules = 'error_password_rules';
    this.error_password_confirm = 'error_password_confirm';
    this.error_name = 'error_name';
    this.location_description = 'location_description';
    this.location_postal_code = 'location_postal_code';
    this.location_not_canada = 'location_not_canada';
    this.error_location = 'error_location';
    this.country_description = 'country_description';
    this.error_country = 'error_country';
    this.error_spoken_language = 'error_spoken_language';
    this.language_description = 'language_description';
    this.language_primary = 'language_primary';
    this.mfa_title = 'mfa_title';
    this.mfa_description = 'mfa_description';
    this.mfa_code = 'mfa_code';
    this.mfa_phone = 'mfa_phone';
    this.mfa_resend_code = 'mfa_resend_code';
    this.error_phone = 'error_phone';
    this.notifications_description = 'notifications_description';
    this.notifications_settings = 'notifications_settings';
    this.welcome_title = 'welcome_title';
    this.welcome_description = 'welcome_description';
    this.basic_title = 'basic_title';
    this.basic_description = 'basic_description';
    this.basic_features = 'basic_features';
    this.basic_backup = 'basic_backup';
    this.basic_sync = 'basic_sync';
    this.basic_web = 'basic_web';
    this.basic_previous_features = 'basic_previous_features';
    this.basic_password = 'basic_password';
    this.basic_backup_ios = 'basic_backup_ios';
    this.basic_backup_android = 'basic_backup_android';
    this.basic_safe_guard = 'basic_safe_guard';
    this.basic_passcode = 'basic_passcode';
    this.basic_periodic_backup = 'basic_periodic_backup';
    this.basic_oph = 'basic_oph';
    this.basic_convert = 'basic_convert';
    this.basic_continue = 'basic_continue';
    this.basic_become_sync = 'basic_become_sync';
    this.login_description = 'login_description';
    this.login_forgot_password = 'login_forgot_password';
    this.email_verify_resend = 'email_verify_resend';
    this.email_lock_resend = 'email_lock_resend';
    this.error_password = 'error_password';
    this.error_verify_email = 'error_verify_email';
    this.error_unlocked = 'error_unlocked';
    this.error_locked = 'error_locked';
    this.error_locked_expired = 'error_locked_expired';
    this.error_disabled = 'error_disabled';
    this.error_pending_delete = 'error_pending_delete';
    this.success_unlock = 'success_unlock';
    this.success_verification = 'success_verification';
    this.error_verification_code = 'error_verification_code';
    this.error_verification_not_found = 'error_verification_not_found';
    this.error_verification_expired = 'error_verification_expired';
    this.error_verification_not_authorized = 'error_verification_not_authorized';
    this.error_reset_code_expired = 'error_reset_code_expired';
    this.consent_welcome = 'consent_welcome';
    this.consent_subtitle = 'consent_subtitle';
    this.consent_scroll = 'consent_scroll';
    this.consent_p1 = 'consent_p1';
    this.consent_p2 = 'consent_p2';
    this.consent_learn_protect = 'consent_learn_protect';
    this.consent_p3 = 'consent_p3';
    this.consent_learn_device = 'consent_learn_device';
    this.consent_p4 = 'consent_p4';
    this.consent_p4a = 'consent_p4a';
    this.consent_p4b = 'consent_p4b';
    this.consent_p4c = 'consent_p4c';
    this.consent_p4d = 'consent_p4d';
    this.consent_p4e = 'consent_p4e';
    this.consent_learn_collect = 'consent_learn_collect';
    this.consent_learn_use = 'consent_learn_use';
    this.consent_p5 = 'consent_p5';
    this.consent_learn_delete = 'consent_learn_delete';
    this.consent_p6 = 'consent_p6';
    this.consent_privacy_email = 'consent_privacy_email';
    this.consent_privacy_phone = 'consent_privacy_phone';
    this.consent_privacy_phone_ext = 'consent_privacy_phone_ext';
    this.consent_more_info_about = 'consent_more_info_about';
    this.consent_collect = 'consent_collect';
    this.consent_use = 'consent_use';
    this.consent_protect = 'consent_protect';
    this.consent_delete = 'consent_delete';
    this.consent_device = 'consent_device';
    this.consent_share = 'consent_share';
    this.consent_contact = 'consent_contact';
    this.consent_consent = 'consent_consent';
    this.consent_changes = 'consent_changes';
    this.consent_cookies = 'consent_cookies';
    this.consent_terms = 'consent_terms';
    this.consent_read_full_policy = 'consent_read_full_policy';
    this.consent_p7 = 'consent_p7';
    this.consent_statement = 'consent_statement';
    this.error_consent = 'error_consent';
    this.consent_create_account = 'consent_create_account';
    this.enter_email = 'enter_email';
    this.password_reset_info = 'password_reset_info';
    this.welcome_existing_description = 'welcome_existing_description';
    this.welcome_existing_description_2 = 'welcome_existing_description_2';
    this.welcome_existing_read_more = 'welcome_existing_read_more';
    this.sync_update_title = 'sync_update_title';
    this.sync_update_description = 'sync_update_description';
    this.sync_update_whats_new = 'sync_update_whats_new';
    this.sync_update_account = 'sync_update_account';
    this.sync_update_sync = 'sync_update_sync';
    this.sync_update_toh = 'sync_update_toh';
    this.sync_update_privacy = 'sync_update_privacy';
    this.sync_update_basic = 'sync_update_basic';
    this.sync_update_mfa = 'sync_update_mfa';
    this.sync_update_soon = 'sync_update_soon';
    this.sync_update_web = 'sync_update_web';
    this.sync_update_web_description = 'sync_update_web_description';
    this.enter_password = 'enter_password';
    this.enter_password_fingerprint = 'enter_password_fingerprint';
    this.title_language = 'title_language';
    this.settings_account = 'settings_account';
    this.settings_account_description = 'settings_account_description';
    this.settings_notifications = 'settings_notifications';
    this.settings_notifications_description = 'settings_notifications_description';
    this.settings_sync_now = 'settings_sync_now';
    this.settings_sync_date = 'settings_sync_date';
    this.settings_help = 'settings_help';
    this.settings_help_description = 'settings_help_description';
    this.settings_privacy = 'settings_privacy';
    this.settings_privacy_description = 'settings_privacy_description';
    this.settings_about = 'settings_about';
    this.settings_about_description = 'settings_about_description';
    this.settings_feedback = 'settings_feedback';
    this.settings_feedback_description = 'settings_feedback_description';
    this.settings_bug_description = 'settings_bug_description';
    this.settings_share_description = 'settings_share_description';
    this.settings_new = 'settings_new';
    this.settings_copyright = 'settings_copyright';
    this.settings_sign_up = 'settings_sign_up';
    this.settings_login_description = 'settings_login_description';
    this.settings_account_header = 'settings_account_header';
    this.settings_logout_warning = 'settings_logout_warning';
    this.settings_logout_warning_unsynced = 'settings_logout_warning_unsynced';
    this.settings_logout_progress = 'settings_logout_progress';
    this.error_name_same = 'error_name_same';
    this.error_push_same = 'error_push_same';
    this.error_mfa_same = 'error_mfa_same';
    this.error_passwords_same = 'error_passwords_same';
    this.error_old_password = 'error_old_password';
    this.licenses = 'licenses';
    this.notification_settings_title = 'notification_settings_title';
    this.notifications_settings_description = 'notifications_settings_description';
    this.notifications_settings_push_basic = 'notifications_settings_push_basic';
    this.notifications_settings_push_basic_description = 'notifications_settings_push_basic_description';
    this.notifications_settings_push = 'notifications_settings_push';
    this.notifications_settings_push_description = 'notifications_settings_push_description';
    this.notifications_change_title = 'notifications_change_title';
    this.notifications_change_description = 'notifications_change_description';
    this.change_password = 'change_password';
    this.change_password_description = 'change_password_description';
    this.password_current = 'password_current';
    this.password_new = 'password_new';
    this.password_new_confirm = 'password_new_confirm';
    this.error_too_many_attempts = 'error_too_many_attempts';
    this.account_settings_title = 'account_settings_title';
    this.account_settings_description = 'account_settings_description';
    this.require_password = 'require_password';
    this.require_password_description = 'require_password_description';
    this.account_change_password_description = 'account_change_password_description';
    this.account_mfa_description = 'account_mfa_description';
    this.change_email = 'change_email';
    this.change_name = 'change_name';
    this.change_account_name_success = 'change_account_name_success';
    this.become_basic_user = 'become_basic_user';
    this.become_basic_user_description = 'become_basic_user_description';
    this.delete_account_description = 'delete_account_description';
    this.delete_account_request = 'delete_account_request';
    this.delete_account_success = 'delete_account_success';
    this.remove_phone = 'remove_phone';
    this.change_phone = 'change_phone';
    this.change_name_description = 'change_name_description';
    this.change_email_description = 'change_email_description';
    this.change_email_success = 'change_email_success';
    this.phone_verify = 'phone_verify';
    this.restore_drive_title = 'restore_drive_title';
    this.restore_drive_description = 'restore_drive_description';
    this.restore_drive_warning = 'restore_drive_warning';
    this.restore_drive_contacts_permission = 'restore_drive_contacts_permission';
    this.error_drive_contacts_permission = 'error_drive_contacts_permission';
    this.backup_restore = 'backup_restore';
    this.backup_restore_message = 'backup_restore_message';
    this.backup_restore_check = 'backup_restore_check';
    this.backup_restore_error_no_backups = 'backup_restore_error_no_backups';
    this.whats_new = 'whats_new';
    this.sync_last_backup_never = 'sync_last_backup_never';
    this.error_sync_maintenance = 'error_sync_maintenance';
    this.error_sync_general = 'error_sync_general';
    this.error_sync_general_message = 'error_sync_general_message';
    this.error_sync_device = 'error_sync_device';
    this.error_sync_not_found = 'error_sync_not_found';
    this.error_code_expired = 'error_code_expired';
    this.error_code_invalid = 'error_code_invalid';
    this.error_code_requirements = 'error_code_requirements';
    this.error_sync_consent = 'error_sync_consent';
    this.error_sync_location = 'error_sync_location';
    this.success_sign_up = 'success_sign_up';
    this.success_reset_password = 'success_reset_password';
    this.success_change_password = 'success_change_password';
    this.success_change_email = 'success_change_email';
    this.success_change_name = 'success_change_name';
    this.success_change_phone = 'success_change_phone';
    this.success_code_new = 'success_code_new';
    this.success_verify_email = 'success_verify_email';
    this.success_unlock_email = 'success_unlock_email';
    this.account_expiry_title = 'account_expiry_title';
    this.update_title = 'update_title';
    this.account_expiry = 'account_expiry';
    this.lock_app_update = 'lock_app_update';
    this.lock_error_generic = 'lock_error_generic';
    this.require_fingerprint = 'require_fingerprint';
    this.fingerprint_hint = 'fingerprint_hint';
    this.fingerprint_not_recognized = 'fingerprint_not_recognized';
    this.fingerprint_success = 'fingerprint_success';
    this.require_fingerprint_description = 'require_fingerprint_description';
    this.fingerprint_enrollment_required = 'fingerprint_enrollment_required';
    this.canimmunize_webclient_front_page_description = 'canimmunize_webclient_front_page_description';
    this.check_inbox_for_email_containing_password_reset_code = 'check_inbox_for_email_containing_password_reset_code';
    this.contact_support = 'contact_support';
    this.email_may_not_exist_error_text = 'email_may_not_exist_error_text';
    this.failed_to_verify_email = 'failed_to_verify_email';
    this.forgot_your_password = 'forgot_your_password';
    this.forgot_password_email_send_failed_msg = 'forgot_password_email_send_failed_msg';
    this.forgot_password_email_sent = 'forgot_password_email_sent';
    this.forgot_password_error = 'forgot_password_error';
    this.inbox = 'inbox';
    this.invalid_email = 'invalid_email';
    this.is_not_a_valid_email_address = 'is_not_a_valid_email_address';
    this.login_err = 'login_err';
    this.login_err_account_locked = 'login_err_account_locked';
    this.login_err_credentials = 'login_err_credentials';
    this.login_success = 'login_success';
    this.new_password = 'new_password';
    this.password_requirements_text = 'password_requirements_text';
    this.password_reset_err = 'password_reset_err';
    this.password_reset_err_invalid_code = 'password_reset_err_invalid_code';
    this.password_reset_err_not_found = 'password_reset_err_not_found';
    this.password_reset_err_unknown_error = 'password_reset_err_unknown_error';
    this.password_reset_success = 'password_reset_success';
    this.phone = 'phone';
    this.please_close_this_window_and_log_in_to_the_app = 'please_close_this_window_and_log_in_to_the_app';
    this.please_enter_your_email_address = 'please_enter_your_email_address';
    this.please_enter_your_email_address_and_password = 'please_enter_your_email_address_and_password';
    this.privacy_policy = 'privacy_policy';
    this.resend_verification_email = 'resend_verification_email';
    this.reset_password = 'reset_password';
    this.reset_your_password = 'reset_your_password';
    this.return_to_login = 'return_to_login';
    this.send_reset_password_email = 'send_reset_password_email';
    this.tap_the_button_below_to_resend_the_email = 'tap_the_button_below_to_resend_the_email';
    this.tap_the_button_below_to_resend_the_verification_email = 'tap_the_button_below_to_resend_the_verification_email';
    this.this_link_may_have_expired = 'this_link_may_have_expired';
    this.this_verification_link_is_invalid = 'this_verification_link_is_invalid';
    this.verification_email_sent = 'verification_email_sent';
    this.you_may_close_this_window = 'you_may_close_this_window';
    this.you_may_now_log_in_to_the_app = 'you_may_now_log_in_to_the_app';
    this.your_email_address_has_been_verified = 'your_email_address_has_been_verified';
    this.your_password_has_been_changed = 'your_password_has_been_changed';
    this.your_password_has_been_successfully_changed = 'your_password_has_been_successfully_changed';
    this.consent_what = 'consent_what';
    this.consent_star = 'consent_star';
  }
  Id.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Id',
    interfaces: []
  };
  var Id_instance = null;
  function Id_getInstance() {
    if (Id_instance === null) {
      new Id();
    }
    return Id_instance;
  }
  var ERROR;
  function isError($receiver) {
    return equals($receiver, ERROR);
  }
  function Validation() {
    Validation_instance = this;
    this.EMAIL_ADDRESS_PATTERN = Regex_init('[a-zA-Z0-9\\+\\.\\_\\%\\-\\+]{1,256}' + '\\@' + '[a-zA-Z0-9][a-zA-Z0-9\\-]{0,64}' + '(' + '\\.' + '[a-zA-Z0-9][a-zA-Z0-9\\-]{0,25}' + ')+');
  }
  Validation.prototype.validateEmail = function (email) {
    var tmp$;
    var tmp$_0;
    if (email != null) {
      var tmp$_1;
      tmp$_0 = trim(Kotlin.isCharSequence(tmp$_1 = email) ? tmp$_1 : throwCCE()).toString();
    }
     else
      tmp$_0 = null;
    var emailClean = (tmp$ = tmp$_0) != null ? tmp$ : '';
    if (emailClean.length === 0) {
      return Error$Companion_getInstance().id(Id_getInstance().error_email);
    }
    if (!this.EMAIL_ADDRESS_PATTERN.matches_6bul2c$(emailClean)) {
      return Error$Companion_getInstance().id(Id_getInstance().error_email);
    }
    return null;
  };
  Validation.prototype.isOverMaxLength_9g2trk$ = function (string, length) {
    return string != null && string.length > length;
  };
  Validation.prototype.isPhoneValid = function (phone) {
    var tmp$, tmp$_0;
    var numericPhone = (tmp$ = phone != null ? Regex_init('[^0-9]').replace_x2uqeu$(phone, '') : null) != null ? tmp$ : '';
    if (numericPhone.length !== 10)
      tmp$_0 = false;
    else {
      if (toInt(numericPhone.substring(0, 1)) === 1)
        tmp$_0 = false;
      else
        tmp$_0 = true;
    }
    return tmp$_0;
  };
  Validation.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Validation',
    interfaces: []
  };
  var Validation_instance = null;
  function Validation_getInstance() {
    if (Validation_instance === null) {
      new Validation();
    }
    return Validation_instance;
  }
  function Date_0() {
    Date_instance = this;
  }
  Date_0.prototype.nowZoned_8be2vx$ = function () {
    return JavelinManager$Companion_getInstance().instance_8be2vx$.zonedNow();
  };
  Date_0.prototype.now_8be2vx$ = function () {
    return JavelinManager$Companion_getInstance().instance_8be2vx$.localNow();
  };
  Date_0.prototype.of_cub51b$ = function (year, month, day) {
    return JavelinManager$Companion_getInstance().instance_8be2vx$.localOf(year, month, day);
  };
  Date_0.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Date',
    interfaces: []
  };
  var Date_instance = null;
  function Date_getInstance() {
    if (Date_instance === null) {
      new Date_0();
    }
    return Date_instance;
  }
  function Json() {
    Json_instance = this;
  }
  Json.prototype.from_z6hou8$ = function (json, type, elementId) {
    if (elementId === void 0)
      elementId = null;
    return JavelinManager$Companion_getInstance().instance_8be2vx$.objectFromJson_tandj7$(json, type, elementId);
  };
  Json.prototype.listFrom_z6hou8$ = function (json, type, elementId) {
    if (elementId === void 0)
      elementId = null;
    return JavelinManager$Companion_getInstance().instance_8be2vx$.listFromJson_tandj7$(json, type, elementId);
  };
  Json.prototype.to_8ea4ql$ = function (obj) {
    return JavelinManager$Companion_getInstance().instance_8be2vx$.objectToJson(obj);
  };
  Json.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Json',
    interfaces: []
  };
  var Json_instance = null;
  function Json_getInstance() {
    if (Json_instance === null) {
      new Json();
    }
    return Json_instance;
  }
  function Log() {
    Log_instance = this;
  }
  Log.prototype.i_wdz5eb$ = function (tag, message) {
    JavelinManager$Companion_getInstance().instance_8be2vx$.logMessage(tag, message);
  };
  Log.prototype.e_nmd5vm$ = function (tag, exception) {
    JavelinManager$Companion_getInstance().instance_8be2vx$.logError(tag, exception);
  };
  Log.prototype.e_xnh3o3$ = function (tag, message, throwable) {
    if (throwable === void 0)
      throwable = null;
    JavelinManager$Companion_getInstance().instance_8be2vx$.logError(tag, new JavelinException(message, throwable));
  };
  Log.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Log',
    interfaces: []
  };
  var Log_instance = null;
  function Log_getInstance() {
    if (Log_instance === null) {
      new Log();
    }
    return Log_instance;
  }
  function Logger(tag) {
    this.tag_0 = tag;
  }
  Logger.prototype.i_y4putb$ = function (message) {
    Log_getInstance().i_wdz5eb$(this.tag_0, message);
  };
  Logger.prototype.e_8o0b5c$ = function (exception) {
    Log_getInstance().e_nmd5vm$(this.tag_0, exception);
  };
  Logger.prototype.e_ly7if3$ = function (message, throwable) {
    if (throwable === void 0)
      throwable = null;
    Log_getInstance().e_xnh3o3$(this.tag_0, message, throwable);
  };
  Logger.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Logger',
    interfaces: []
  };
  function Str() {
    Str_instance = this;
  }
  Str.prototype.get_y4putb$ = function (stringId) {
    return JavelinManager$Companion_getInstance().instance_8be2vx$.getString(stringId, []);
  };
  Str.prototype.get_ge7pzc$ = function (stringId, arguments_0) {
    return JavelinManager$Companion_getInstance().instance_8be2vx$.getString(stringId, arguments_0.slice());
  };
  Str.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Str',
    interfaces: []
  };
  var Str_instance = null;
  function Str_getInstance() {
    if (Str_instance === null) {
      new Str();
    }
    return Str_instance;
  }
  function JavelinException(message, throwable) {
    if (throwable === void 0)
      throwable = null;
    Exception.call(this, message, throwable);
    this.name = 'JavelinException';
  }
  JavelinException.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'JavelinException',
    interfaces: [Exception]
  };
  var package$ca = _.ca || (_.ca = {});
  var package$ohri = package$ca.ohri || (package$ca.ohri = {});
  var package$javelin = package$ohri.javelin || (package$ohri.javelin = {});
  var package$util = package$javelin.util || (package$javelin.util = {});
  package$util.JOverloads = JOverloads;
  package$javelin.DateInterface = DateInterface;
  package$javelin.JavelinInterface = JavelinInterface;
  Object.defineProperty(JavelinManager, 'Platform', {
    get: JavelinManager$Platform_getInstance
  });
  Object.defineProperty(JavelinManager, 'Companion', {
    get: JavelinManager$Companion_getInstance
  });
  package$javelin.JavelinManager = JavelinManager;
  package$javelin.JsonInterface = JsonInterface;
  var package$data = package$javelin.data || (package$javelin.data = {});
  package$data.DataInterface = DataInterface;
  var package$model = package$data.model || (package$data.model = {});
  package$model.City = City;
  package$model.Country = Country;
  Object.defineProperty(DateModifier, 'Companion', {
    get: DateModifier$Companion_getInstance
  });
  package$model.DateModifier = DateModifier;
  Object.defineProperty(Filter, 'Type', {
    get: Filter$Type_getInstance
  });
  Object.defineProperty(Filter, 'Companion', {
    get: Filter$Companion_getInstance
  });
  package$model.Filter = Filter;
  Object.defineProperty(package$model, 'Gender', {
    get: Gender_getInstance
  });
  Object.defineProperty(package$model, 'Language', {
    get: Language_getInstance
  });
  package$model.Notification = Notification;
  package$model.Outbreak = Outbreak;
  package$model.PHUConfig = PHUConfig;
  package$model.Region = Region;
  Object.defineProperty(package$model, 'Relationship', {
    get: Relationship_getInstance
  });
  Object.defineProperty(package$model, 'Status', {
    get: Status_getInstance
  });
  var package$concept = package$model.concept || (package$model.concept = {});
  package$concept.Concept = Concept;
  package$concept.DiseaseConcept = DiseaseConcept;
  package$concept.GenericConcept = GenericConcept;
  package$concept.TradeNameConcept = TradeNameConcept;
  package$concept.VaccineConcept = VaccineConcept;
  var package$date = package$model.date || (package$model.date = {});
  package$date.JLocalDate = JLocalDate;
  package$date.JZonedDateTime = JZonedDateTime;
  var package$page = package$model.page || (package$model.page = {});
  package$page.CollectionPage = CollectionPage;
  Object.defineProperty(OtherPage, 'Companion', {
    get: OtherPage$Companion_getInstance
  });
  package$page.OtherPage = OtherPage;
  Object.defineProperty(Page, 'Type', {
    get: Page$Type_getInstance
  });
  package$page.Page = Page;
  Object.defineProperty(Error_0, 'Companion', {
    get: Error$Companion_getInstance
  });
  var package$result = package$model.result || (package$model.result = {});
  package$result.Error = Error_0;
  package$result.Result = Result;
  Object.defineProperty(Success, 'Companion', {
    get: Success$Companion_getInstance
  });
  package$result.Success = Success;
  Object.defineProperty(Banner, 'Companion', {
    get: Banner$Companion_getInstance
  });
  var package$schedule = package$model.schedule || (package$model.schedule = {});
  package$schedule.Banner = Banner;
  package$schedule.Disease = Disease;
  package$schedule.DoseGenerator = DoseGenerator;
  package$schedule.FAQ = FAQ;
  package$schedule.GeneratorCollection = GeneratorCollection;
  Rule.IdDate = Rule$IdDate;
  Object.defineProperty(Rule, 'Name', {
    get: Rule$Name_getInstance
  });
  package$schedule.Rule = Rule;
  Object.defineProperty(Schedule, 'Companion', {
    get: Schedule$Companion_getInstance
  });
  package$schedule.Schedule = Schedule;
  package$schedule.Vaccine = Vaccine;
  Object.defineProperty(Consent, 'Name', {
    get: Consent$Name_getInstance
  });
  var package$user = package$model.user || (package$model.user = {});
  package$user.Consent_init_qwhnjh$ = Consent_init;
  package$user.Consent_init_216a01$ = Consent_init_0;
  package$user.Consent_init_vm89mk$ = Consent_init_1;
  package$user.Consent = Consent;
  Object.defineProperty(Dose, 'Companion', {
    get: Dose$Companion_getInstance
  });
  package$user.Dose_init_db = Dose_init;
  package$user.Dose_init_base = Dose_init_0;
  package$user.Dose_init_generated = Dose_init_1;
  package$user.Dose_init_g1bokp$ = Dose_init_2;
  package$user.Dose = Dose;
  Object.defineProperty(package$user, 'Field', {
    get: Field_getInstance
  });
  Object.defineProperty(Record, 'Companion', {
    get: Record$Companion_getInstance
  });
  package$user.Record_init_db = Record_init;
  package$user.Record_init_client = Record_init_1;
  package$user.Record = Record;
  Object.defineProperty(Integration, 'Companion', {
    get: Integration$Companion_getInstance
  });
  var package$integration = package$user.integration || (package$user.integration = {});
  package$integration.Integration_init_hctnbt$ = Integration_init;
  package$integration.Integration = Integration;
  Object.defineProperty(PHUIntegration, 'Companion', {
    get: PHUIntegration$Companion_getInstance
  });
  package$integration.PHUIntegration_init_db = PHUIntegration_init;
  package$integration.PHUIntegration_init_ktg00b$ = PHUIntegration_init_0;
  package$integration.PHUIntegration = PHUIntegration;
  var package$util_0 = package$data.util || (package$data.util = {});
  Object.defineProperty(package$util_0, 'Action', {
    get: Action_getInstance
  });
  QueryBuilder.Item = QueryBuilder$Item;
  package$util_0.QueryBuilder = QueryBuilder;
  Object.defineProperty(Type.prototype, 'Simple', {
    get: Type$Simple_getInstance
  });
  Object.defineProperty(package$util_0, 'Type', {
    get: Type_getInstance
  });
  var package$manager = package$util_0.manager || (package$util_0.manager = {});
  package$manager.DataManager = DataManager;
  Object.defineProperty(package$manager, 'NotificationManager', {
    get: NotificationManager_getInstance
  });
  Object.defineProperty(package$manager, 'SchedulerManager', {
    get: SchedulerManager_getInstance
  });
  var package$localnotifications = package$javelin.localnotifications || (package$javelin.localnotifications = {});
  package$localnotifications.LocalNotificationInterface = LocalNotificationInterface;
  var package$model_0 = package$localnotifications.model || (package$localnotifications.model = {});
  package$model_0.LocalNotification = LocalNotification;
  var package$util_1 = package$localnotifications.util || (package$localnotifications.util = {});
  package$util_1.LocalNotificationManager = LocalNotificationManager;
  var package$sync = package$javelin.sync || (package$javelin.sync = {});
  package$sync.SyncInterface = SyncInterface;
  var package$model_1 = package$sync.model || (package$sync.model = {});
  package$model_1.Account = Account;
  Object.defineProperty(package$model_1, 'Lock', {
    get: Lock_getInstance
  });
  package$model_1.RequestCallback = RequestCallback;
  package$model_1.ResponseCallback = ResponseCallback;
  Object.defineProperty(package$model_1, 'SyncBroadcast', {
    get: SyncBroadcast_getInstance
  });
  package$model_1.Transaction_init_dnv871$ = Transaction_init;
  package$model_1.Transaction_init_9gteum$ = Transaction_init_2;
  package$model_1.Transaction_init_ine9n2$ = Transaction_init_3;
  package$model_1.Transaction_init_5r7mre$ = Transaction_init_4;
  package$model_1.Transaction_init_oqmg62$ = Transaction_init_5;
  package$model_1.Transaction_init_sc47nj$ = Transaction_init_6;
  package$model_1.Transaction_init_4osz6n$ = Transaction_init_7;
  package$model_1.Transaction_init_19mbxw$ = Transaction_init_8;
  package$model_1.Transaction = Transaction;
  var package$util_2 = package$sync.util || (package$sync.util = {});
  Object.defineProperty(package$util_2, 'AccountValidation', {
    get: AccountValidation_getInstance
  });
  Object.defineProperty(RequestType, 'GET', {
    get: RequestType$GET_getInstance
  });
  Object.defineProperty(RequestType, 'POST', {
    get: RequestType$POST_getInstance
  });
  Object.defineProperty(RequestType, 'PUT', {
    get: RequestType$PUT_getInstance
  });
  package$util_2.RequestType = RequestType;
  package$util_2.SyncManager = SyncManager;
  Object.defineProperty(SyncType.prototype, 'Simple', {
    get: SyncType$Simple_getInstance
  });
  Object.defineProperty(package$util_2, 'SyncType', {
    get: SyncType_getInstance
  });
  Object.defineProperty(package$util, 'Help', {
    get: Help_getInstance
  });
  Object.defineProperty(package$util, 'Id', {
    get: Id_getInstance
  });
  Object.defineProperty(package$util, 'ERROR', {
    get: function () {
      return ERROR;
    }
  });
  package$util.isError_pdl1vz$ = isError;
  Object.defineProperty(package$util, 'Validation', {
    get: Validation_getInstance
  });
  var package$convenience = package$util.convenience || (package$util.convenience = {});
  Object.defineProperty(package$convenience, 'Date', {
    get: Date_getInstance
  });
  Object.defineProperty(package$convenience, 'Json', {
    get: Json_getInstance
  });
  Object.defineProperty(package$convenience, 'Log', {
    get: Log_getInstance
  });
  package$convenience.Logger = Logger;
  Object.defineProperty(package$convenience, 'Str', {
    get: Str_getInstance
  });
  var package$exception = package$util.exception || (package$util.exception = {});
  package$exception.JavelinException = JavelinException;
  SyncManager$deletePhone$ObjectLiteral.prototype.onSuccess = RequestCallback.prototype.onSuccess;
  ERROR = '###Error###';
  Kotlin.defineModule('javelinscript', _);
  return _;
}(module.exports, require('kotlin')));

//# sourceMappingURL=javelinscript.js.map
